import React from 'react'
import { createContext, useState, useEffect, useRef } from "react";
import { mainlanguages } from '../data/QuizSamples.ts';
import axios from "axios"
import { config } from '../config';
import AuthContext from "./AuthContext";


var bottomPosition = 0;



const StatusContext = createContext();

export default StatusContext;

  const supportedlanguages = [
      { short: 'EN', long: 'English' },
      { short: 'DN', long: 'German' },
      { short: 'FR', long: 'French' },
      { short: 'PR', long: 'Portuguese' },
      { short: 'SP', long: 'Spanish' },
      { short: 'SR', long: 'Serbian'},
      ]


export function formatPrice(price, isAmerican) {
    if (isAmerican) {
        // Format for American customer
        return `$${price.toFixed(2)}`;
    } else {
        // Format for European customer
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'USD' }).format(price);
    }
}


export const sortChats = (chats) => {
    
    const stringArray=[]
    let sortedArray = []
    let sortedChats = []
    let adjustedChats = []

    for (let i = 0; i < chats.length; i++) {
        stringArray.push(chats[i].chatname); // Push the string into the separate array
    }

    sortedArray = [...stringArray].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

    for (let i = 0; i < sortedArray.length; i++) {
        for (let j = 0; j< chats.length; j++) {
            if (sortedArray[i] === chats[j].chatname) {
                sortedChats.push(chats[j])
            }
        }
    }

    //adjust indexes
    let i = 0;
    sortedChats.forEach((chat) => {
       let newchat = chat;
       newchat.id = i;
       adjustedChats.push(newchat);
       i++
    })
    //console.log("Adjusted chats:", adjustedChats)
    return adjustedChats;

}

export const StatusProvider = ((props) => {

    const [statusNavbar, setStatusNavbar] = useState();

    const [temperature, setTemperature] = useState(0.7);
    const scrollRef = useRef(null);
    const focusRef = useRef(null);
   
    const [isLoading, setIsLoading] = useState(false);
    const [mainLanguage, setMainLanguage] = useState(
            localStorage.getItem("mainLanguage") ||"English");

    const [showmainLanguage, setShowMainLanguage] = useState(false)

    const [language, setLanguage] = useState(localStorage.getItem("mainLanguage") ||"English");
    const [languages, setLanguages] = useState('');

    const [openDialog, handleDisplay] = useState(false);
    const [openDialogResponse, handleDisplayResponse] = useState(false);
    const [openDialogConfirm, handleDisplayConfirm] = useState(false);
    const [openDialogAlert, handleDisplayAlert] = useState(false);

    const [openLogin, handleOpenLogin] = useState(false);
    const [openLogout, handleOpenLogout] = useState(false);
    const [testname, setTestName] = useState('')
    const [showlogindialog, setShowLoginDialog] = useState(false)
    const [showlogoutdialog, setShowLogoutDialog] = useState(false)
    const [showsecuritydialog, setShowSecurityDialog] = useState(false)
    const [showdialogsecurityquestion, setShowDialogSecurityQuestion] = useState(false)
    const [showpasswordchangeddialog, setShowPasswordChangedDialog] = useState(false)
    const [showsignupdialog, setShowSignupDialog] = useState(false)
    const [showsignupconfirmdialog, setShowSignupConfirmDialog] = useState(false)
    const [showloginconfirmdialog, setShowLoginConfirmDialog] = useState(false)
    const [enablesignupdialog, setEnableSignupDialog] = useState(false)

    const [showcreateconnectaccountdialog, setShowCreateConnectAccountDialog] = useState(false)
    const [showbuytestdialog, setShowBuyTestDialog] = useState(false)
    const [showcreditsdialog, setShowCreditsDialog] = useState(false)
    const [showbuycredits,setShowBuyCredits] = useState(false)
    const [dialogStatus, setDialogStatus] = useState('')
    const [isTextCopied, setIsTextCopied] = useState({
        id: -1,
        status: false,
    });

    const[secquestion, setSecurityQuestion] = useState("")
    const [shownewpassworddialog, setShowNewPasswordDialog] = useState(false)
    const[logininputs, setLoginInputs] = useState({
        username:"",
        password:"",
        newpassword:"",
        confirmnewpassword: "",
        answer:""
      })
    
    const [showLanguages, setShowLanguages] = useState(false)
    const [shortLanguage, setShortLanguage] = useState(localStorage.getItem("mainLanguageShort") ||"EN")

    const [showDialogAccountCreated, setShowDialogAccountCreated] = useState(false);
    const [dialogAccountText, setDialogAccountText] = useState(false);
    const [dialogLogoutText, setDialogLogoutText] = useState(false);
    const [openLogoutDialog, setOpenLogoutDialog] = useState(false)
    const [waitonResponse, setWaitOnResponse] = useState('')
    const [responseMode, setResponseMode] = useState('3')
    const [showModels, setShowModels] = useState(false)

    const [activePane, setActivePane] = useState(1)

    const [showDialogBoughtCredits, setShowDialogBoughtCredits] = useState(false)
    const [securitycodestatus, setSecurityCodeStatus] = useState('')
    const [testlanguage, setTestLanguage] = useState(
            localStorage.getItem("Test language") ||"English");
   

    const {
        currentUser, 
        checkCurrentUser,
    } = React.useContext(AuthContext);

   const onClickAIButton = (pane) => {
    console.log("onClickAIButton")
        setActivePane(pane)
        setShowModels(true)
   }

   const isMe = () => {
    if (currentUser === 'dsrdjevic@yahoo.com')
        return true
    else
        return false
   }

   const isPromotion = () => {

        if (isMe())
            return false

        if (checkCurrentUser() === false)
            return false
       
        return true
   }

   const onSelectModel = (provider,model, name) => {
       if (activePane === 0)
       {
         localStorage.setItem("AIProvider", provider)
         localStorage.setItem("AIModel", model)
         localStorage.setItem("AIName", name)
        
       }
       else if (activePane === 1)
       {
           localStorage.setItem("AIProvider_1", provider)
           localStorage.setItem("AIModel_1", model)
           localStorage.setItem("AIName_1", name)
          
       }
       else if (activePane === 2)
         {
             localStorage.setItem("AIProvider_2", provider)
             localStorage.setItem("AIModel_2", model)
             localStorage.setItem("AIName_2", name)
         }
     
     }

    const handleFocus = () => {

        // Scroll to the target element
        setTimeout(() => {
          if (focusRef.current)
            focusRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }, 100)
    
    
      }

      const getAIProvider = () => {
        if (isMe())
        {
            let aiprovider = localStorage.getItem('AIProvider')
        
            if (!aiprovider)
                aiprovider = 'DeepSeek'
        
            return aiprovider
        }
        else
            return 'DeepSeek'
      }

      

      const getAIModel = () => {
        
        if (isMe())
        {
            let provider = getAIProvider()

            for (let i = 0; i < models.length; ++i)
            {
                if (models[i].provider === provider)
                    return models[i].model
            }

            //return 'deepseek-v4-flash'
            return 'deepseek-flash'
        }
        else
            //return 'deepseek-v4-flash'
            return 'deepseek-flash'
      }
        

      const getAIName = () => {
        
        if (isMe())
        {
        let provider = getAIProvider()

            for (let i = 0; i < models.length; ++i)
            {
                if (models[i].provider === provider)
                    return models[i].name
            }

            //return 'deepseek-v4-flash'
            return 'deepseek-flash'
        }

       //return 'deepseek-v4-flash'
       return 'deepseek-flash'

      }

      const getChatGPTModel = () => {
        for (let i = 0 ; i < models.length; ++i)
        {
            if (models[i].provider === 'ChatGPT')
                return models[i].model
        }
        return 'gpt-5.6-luna'
      }

      
      
    
    const closeDialogBox = () => {
       handleDisplay(false);
    };
 
    const openDialogBox = () => {
       handleDisplay(true);
    };

    const closeDialogBoxResponse = () => {
        handleDisplayResponse(false);
     };
  
     const openDialogBoxResponse = () => {
        handleDisplayResponse(true);
     };

     const closeDialogBoxConfirm = () => {
        handleDisplayConfirm(false);
     };
  
     const openDialogBoxConfirm = () => {
        handleDisplayConfirm(true);
     };

     const closeDialogBoxAlert = () => {
        handleDisplayAlert(false);
     };
  
     const openDialogBoxAlert= () => {
        handleDisplayAlert(true);
     };



     const closeLoginDialogConfirm = () => {
        handleOpenLogin(false);
     };

     const openLoginDialogConfirm = () => {
        handleOpenLogin(true);
     };

     const closeLogoutDialogConfirm = () => {
        handleOpenLogout(false);
     };

     const openLogoutDialogConfirm = () => {
        handleOpenLogout(true);
     };

    const isMobile = () => {
        let a = window.innerWidth
        return (a < 500);
    }

    const handleTemperature = (e) => {
        setTemperature(e)
        sessionStorage.setItem("Temperature", e)
    }

    const onCopy = async (prompt) => {
        console.log("onCopy:", prompt)
   
        try {
            await navigator.clipboard.writeText(prompt.response);
            let a = {
                id: prompt.id,
                status: true,
            }
            setIsTextCopied(a);
            //alert('Text copied to clipboard!');
          } catch (err) {
            console.error('Failed to copy: ', err);
          }
    }

    const changeLanguage = (page, key) =>  {
      
        // Get the language preference from the user
       let text = null;
       if (translations[mainLanguage] && translations[mainLanguage][page] && translations[mainLanguage][page][key]) 
       {
           text = translations[mainLanguage][page][key];
       } else {
           text  = '<?>';
       }
      
       return text;
}

 const changeLanguageEnglish = (page, key) =>  {
      
        // Get the language preference from the user
       let text = null;
       if (translations["English"] && translations["English"][page] && translations["English"][page][key]) 
       {
           text = translations["English"][page][key];
       } else {
           text  = '<?>';
       }
      
       return text;
}

  const changeTestLanguage = (page, key) =>  {
      
        // Get the language preference from the user
       let text = null;
       if (testtranslations[testlanguage] && testtranslations[testlanguage][page] && testtranslations[testlanguage][page][key]) 
       {
           text = testtranslations[testlanguage][page][key];
       } else {
           text  = '<?>';
       }
      
       return text;
}
    

    const sortTemplates = (template) => {
        const stringArray=[]
        let sortedArray = []
        let sortedTemplate = []

        for (let i = 0; i < template.length; i++) {
            //console.log("Name: ", template[i].name)
            stringArray.push(template[i].name); // Push the string into the separate array
        }

        sortedArray = [...stringArray].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
        stringArray.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

        for (let i = 0; i < sortedArray.length; i++) {
            for (let j = 0; j< template.length; j++) {
                if (sortedArray[i] === template[j].name) {
                    sortedTemplate.push(template[j])
                }
            }
        }
      
        return sortedTemplate;

    }
    const ScrollResponse = () => {
      
        setTimeout(() => {
            if (scrollRef.current) {
                const { offsetHeight, scrollHeight } = scrollRef.current;
                const bottomPosition = (scrollHeight - offsetHeight) * 2;
                scrollRef.current.scrollTo({ top: bottomPosition, behavior: 'smooth' });
              }
            
          }, 100);
  
    }

    const ScrollResponseToMiddle = () => {
  
        setTimeout(() => {
            if (scrollRef.current) {
                const { offsetHeight, scrollHeight } = scrollRef.current;
              
                bottomPosition +=  offsetHeight * 2;
              
                scrollRef.current.scrollTo({ top: bottomPosition, behavior: 'smooth' });
                bottomPosition = scrollHeight - offsetHeight;
              }
            
          }, 100);
        
    }

      const getChats = async (table) => {
        let sortedChats  = []
        let getchatsstatus = {
            chats: [],
            status: 0
        }

        //console.log("GetChats:", table, currentUser)
        setIsLoading(true)
        let q = "/deda_ai_api/" + table + "/get"
    
        try{
            const res = await axios.post(config.url.API_URL + q, {currentUser}) 
            if (res.data.length > 0) {
                const chats = JSON.parse(res.data[0].templates)
                console.log("GetChats:", chats)
                sortedChats = sortChats(chats)    
                console.log("SortedChats:", sortedChats) 
            }
            else{
                // Handle case when res.data is empty
                console.log("No data in res.data")
            }
        } 
        catch(err)
        {
            console.log("Received error:", err)
            if (err.response && err.response.status !== 409)
            {
                getchatsstatus.status = err.response.status
                setIsLoading(false)
                return getchatsstatus;
            }
        }
       
        setIsLoading(false)

        let chatsstatus = {chats: sortedChats, status: 200}
       
        return chatsstatus;
    }


    useEffect(() => {
        console.log("Status useEffect")
        const getTemperature = () => {
            if (sessionStorage.getItem("Temperature"))
            {
                let temp = sessionStorage.getItem("Temperature");
                console.log("UseEffect: sessionStorageTemp:", temp)
                setTemperature(temp)
            }
        }

        const getLanguages = (data, setdata) => {

            let newsamples = []
            data.forEach((templ) => {
                let newsample = {
                    value: '',
                    label: '',
                }
                newsample.value = templ.id;
                newsample.label = templ.language;
                newsamples.push(newsample)
            })
    
            setdata(newsamples)
        }
    
        getLanguages(mainlanguages, setLanguages)
        getTemperature()


    },[] )

    const saveMainLanguage = (lang) => {
        console.log("saveMainLanguage:", lang)
        setLanguage(lang); 
        setMainLanguage(lang);
      
        setShowMainLanguage(!showmainLanguage);
        
        localStorage.setItem("mainLanguage", lang)
    }


    const testtranslations = {
        English: {
            newquestions: 'Questions',
            questions: 'Questions:',

            testspayments:'Payments',
        },

        Serbian: {
            aitest: {
                additionalcreditstex_1:'Ako koristite ',
                additionalcreditstex_2:'za dodatna objašnjenja odgovora, koriste se krediti za upite koje AI modeli naplaćuju i krediti se posebno kupuju.',
                advicetext: 'Koristite MOJA BIBLIOTEKA stranicu za veoma detaljan opis pojmova, tema i interesovanja.',
                afterpromotion:"POSLE PROMOCIJE",

                buytest: "Kupi",
                buyalltests:"Kupi sve",

                cancel: 'Zatvori',

                description: 'Opis testa',
                disclaimer:'NAPOMENA: ',
                disclaimertext:'Testovi služe kao pomoć učenju. Generisani su uz pomoć AI. Moguće su pravopisne greške, greške u prevodu i dijalektu.',

                firstyear: "Prva godina",
                fourthyear: "Četvrta godina",
                fifthyear: "Peta godina",
                freetext: 'Lista obaveznih predmeta sa svih smerova',

                individualtests:"Pojedinačni testovi",
                schoolyeartests:"Testovi za školsku godinu",
                
                newquestions: 'Nova pitanja',
                newquestionstip:'Dodajte ovde nove detalje i napravite svoje testove.',
                noavailabletests: 'Testovi nisu dostupni.',
                norefunds: '*Uplate se ne vraćaju',

                onefreetest:'Imate pravo na još jedan predmet BESPLATNO.',

                pay: 'Kupi',
                
                pleaselogin:'Molimo vas, prijavite se.', 
                promotions:"PROMOCIJA",
                promotionstext:"Svi testovi su BESPLATNI do 15. januara.",
                
                questions: 'Pitanja:',

                resetanswers: "Da li želiš da resetuješ odgovore?",
                resettooltip: "Resetuj odgovore",

                secondyear: "Druga godina",
                showanswersonly: "Pokaži tačne odgovore",
                showquestionsonly: "Pokaži samo pitanja",
                sixthyear: 'Šesta godina',

                test:'TEST',
                
                testnotbought:'Ovi testovi nisu kupljeni. Prikazana su samo pitanja bez odgovora.',
                tests: 'TESTOVI',
                testspayments:'Kupovina',
                thirdyear: "Treća godina",
                
                translatetext:'Prevedi',
                textcenatestova: "Možete kupiti testove za pojedinačne predmete po ceni od ~600rsd ($5.99) ili paket svih testova za godinu studija za ~2500rsd ($24.99).",
                twofreetests:'Odaberite prva dva predmeta BESPLATNO.',

                updateformulas: 'Formule',
            }
        }
    }
          
  // Define the translated text for each language
  const translations = {
    German: {
        aitest: {
            accept: 'Akzeptieren',
            account: 'Mein Konto',
            accountcapital: 'KONTO',
            active: 'In Benutzung',
            activated: "Aktiviert an/aus",
            activity: 'Konto',
            alltestssubtitle: 'Alle Tests',
            addfreetestdialog: "Möchten Sie einen kostenlosen Test hinzufügen",
            accountverificationtext: "Stellen Sie sicher, dass Ihre Identitätsverifizierung abgeschlossen ist. Das Konto ist ohne diese nicht gültig.",
            areas:'Testbereich: ',
           

            bankaccountnumber: 'Bankkontonummer',
            buytestdialog: "Möchten Sie den Test kaufen",
            buytest: 'Kaufen',
            buytestfree: 'Kostenlos',
            boughttest: 'Sie haben gerade den Test gekauft',
            by: 'von',

            cancel: 'Stornieren',
            cannotbepurchased: 'Dieser Test kann nicht gekauft werden.',
            changeaccount: "Neues Konto",
            changeaccounttext: "Du hast bereits das Zahlungskonto. Wenn du es ändern möchtest, musst du ein neues Konto erstellen.",
            createaccount: 'Konto erstellen',
            createaccounttext: "Wenn Sie planen, Ihre Tests zu verkaufen, müssen Sie zuerst ein Konto erstellen, um Zahlungen zu erhalten.",
            creatorname: 'Autor',
            createtest:'Test erstellen',
            createtesttitle: 'TEST ERSTELLEN',
            createaccountbutton: 'Konto erstellen',
            createaccounttitle: 'Konto erstellen',
            choosetesttitle:'ALLGEMEINE TESTS',
            collegetests: 'College-Studientests',
        
            dialogquestion: "Frage:",
            dialoganswer_1: "Antwort 1:",
            dialoganswer_2: "Antwort 2:",
            dialoganswer_3: "Antwort 3:",
            dialogmodifytest: 'Test ändern',
            dialogupdate: 'Aktualisieren',
            description: 'Beschreibung:',
            descriptionprompt: 'Testbeschreibung hinzufügen',

            expired: 'Abgelaufen',

            free: 'Kostenlos',
            freevspaidtest: "Kostenlose oder kostenpflichtige Tests",

            generatesubtopics: 'Unterthemen generieren',
            generatequestions: 'Fragen generieren',

            howtocreatetest: "Wie man einen Test erstellt",

            language: 'Sprache: ',
            login: 'Bitte einloggen.',

            moreanswertitle: "Mehr über ..",
            mytests: 'Meine Tests',
            mytestalert:'Dieser Test wurde von Ihnen erstellt und kann nicht gekauft werden.',

            navbartitle: "Test:",
            newsubtopics: "Möchten Sie aus einem gegebenen Kontext neue Unterthemen erstellen?",
            notactive: "Nicht in Benutzung",
            notactivated: "Nicht aktiviert",
            nocreatornametosave: "Autorname fehlt.",
            nodescriptiontosave: "Beschreibung fehlt.",
            noareatosave:'Testbereich fehlt.',

            opentest: 'Wählen Sie einen Test',

            paidtestwarning: 'Dies ist ein kostenpflichtiger Test und wird zum Kauf angeboten. DedaAI wird 12 % von jedem Verkauf als Gebühr für die Zahlungsabwicklung einbehalten. Möchten Sie diesen Test aktivieren?',       
            placeholdergeneratetestid: 'Test ID',
            placeholderopentest: 'Test ID',
            problemsavingfile: "Es gab ein Problem beim Speichern der Datei.",
            prompttestname: 'Testname',
            previewquestions: "Dies ist eine kostenpflichtige Testvorschau, und es werden nur die ersten fünf Fragen angezeigt.", 
            purchasedtests:'Gekaufte Tests',

            questions: 'Fragen:',
            questionsbutton: 'Fragen',
            questionslimit: "Sie haben die maximale Anzahl an erlaubten Fragen für diesen Test erreicht.",

            resettooltip: "Antworten zurücksetzen",
            resetanswers: "Willst du die Antworten zurücksetzen?",

            sameauthor: "Ein weiterer Autor mit dem gleichen Namen existiert bereits. Bitte wählen Sie einen anderen Namen.",
            sametestname: "Es gibt einen weiteren Test mit demselben Namen von einem anderen Autor und er kann nicht aktualisiert werden.",
            savetestname: 'Testname',
            savedtests:'Meine Tests',
            savetest: 'Test speichern',
            save: 'Speichern',
            savechosentest: "Möchten Sie Ihre Antworten speichern?",
            saveanswers: "Speichern",
            selecttest:'Allgemeine Tests',
            selecttestarea: 'Wählen Sie ein Testgebiet',
            selecttestlanguage: 'Wählen Sie eine Testsprache',
            selectedtestinfo: 'Sie haben den folgenden Test zum Kauf ausgewählt:',
            showcontext: 'Kontext',
            somethingwentwrong: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
            startreceivingpayments: "Erstellen Sie ein Konto, um Zahlungen zu erhalten.",
            subtopics: 'Unterthemen',
            subtopicssubtext: 'Unterthemen werden aus dem Kontext generiert und helfen bei der Erstellung detaillierterer Fragen Generieren.',

            test: "Testnote:",
            testid: 'Test ID generieren',
            testname: 'Testname',
            testexists: ' befindet sich bereits in der Liste der gekauften Tests.',
            topic: 'Kontext:',
            testprice: 'Preis: $',
            tests:'Tests:',
            totalearnings: 'Gesamteinnahmen: $',
            topicplaceholder: 'Geben Sie einen Kontext ein und fahren Sie mit "Fragen" fort',
            transfermoney: 'Geld überweisen',
            transactions: 'Transaktionen',
            transfermoneybutton: 'Überweisen',
            testarea: 'bereich: ',
            testlanguage: 'sprache: ',
            text1: 'Klicken Sie auf das Unterthema, um es auszuwählen.',
            text2: 'Ein nicht verwendeter Test hat keine Käufe oder alle Käufe sind abgelaufen. Dieser Test kann gelöscht werden.',
            text3: "Der Test muss aktiviert werden, um für die Nutzung verfügbar zu sein. Während der Erstellung ist der Test NICHT AKTIV und nicht verfügbar. Wenn du mit dem Inhalt zufrieden bist, mache ihn öffentlich, indem du das Kontrollkästchen aktivierst.",
            text4: 'Erstelle einen Test mit Hilfe von KI. Gib einen Kontext ein, klicke auf "Fragen generieren" und die KI wird Fragen mit Antworten generieren. Bearbeite die Fragen und Antworten nach Bedarf. Sobald der Test bereit ist, aktiviere ihn, um ihn öffentlich zu machen.',
            text8: 'Wähle Test',
            text9: 'Test erstellen',
            text10: "Bereiten Sie Tests mit unserer Testplattform vor, um Studenten, Mitarbeitern und Freunden bei ihren Prüfungen und Bewertungen zu helfen. Wählen Sie, ob Sie Ihre Tests kostenlos teilen oder monetarisieren möchten, sodass Sie verdienen können, während Sie Ihr Fachwissen einbringen.",
            text11: "Möchten Sie den Test kaufen",
            text12: "Sie können ihn ab heute 6 Monate lang verwenden.",        
            text13: "Verkaufen Sie Ihre Tests und monetarisieren Sie Ihr Wissen und Ihre Expertise. Verdienen Sie, während Sie der Gemeinschaft helfen, ihr Wissen zu erweitern. Fordern Sie Ihre Studenten, Mitarbeiter oder Freunde mit gut gestalteten Tests heraus.",
            text14: "Finden Sie die Tests, die am besten zu Ihren Bedürfnissen bei der Vorbereitung auf Prüfungen und Bewertungen passen. Vertiefen Sie Ihr Lernen, indem Sie auf die richtigen Antworten eingehen und Ihr Verständnis für jedes Thema verbessern. Beginnen Sie noch heute Ihre Reise zum Erfolg und erweitern Sie Ihr Wissen.",
            text15: "Dieser Test wurde von Ihnen erstellt und kann nicht ausgewählt werden.",
            text17: "Dieser Test wird gelöscht werden. Möchten Sie mit dem Löschen dieses Tests fortfahren?",
            text18: "Möchten Sie diesen Test aktivieren, um ihn öffentlich zugänglich zu machen?",
            text19: "Möchten Sie diesen Test deaktivieren?",
            text21: "Der Test kann nicht bearbeitet werden, während er im AKTIVEN (in Benutzung) Zustand ist.",
            text22: "Fragen werden jeweils drei auf einmal generiert. Richtige Antworten werden zufällig platziert. Du kannst den Kontext vor der Erstellung der nächsten Fragen ändern, um spezifischere Fragen zu einem Kontext zu erhalten.",
            text23: "Der Test ist abgelaufen und kann nicht angezeigt werden.",
            text24: "Ein Kontext muss vor der Generierung von Unterkontexten angegeben werden.",
            text25: "Möchten Sie Unterkontexte aus einem gegebenen Kontext generieren?",
            text26: 'Dies ist ein kostenpflichtiger Test. Der Test kann nicht aktiviert werden, da Sie kein Konto erstellt haben, um Zahlungen zu akzeptieren. Bitte erstellen Sie ein Konto, indem Sie auf "Konto" klicken.',  
            text27: "Dies ist ein kostenpflichtiger Test und wird zum Kauf angeboten. DedaAI wird 18 % des Kaufpreises als Gebühr und für die Zahlungsabwicklungskosten einbehalten. Möchten Sie diesen Test aktivieren?",
            text30: 'Wettbewerbsvorteil erlangen',
            text31: 'Seien Sie an der Spitze der KI-Entwicklungen, erschließen Sie neue Möglichkeiten, treiben Sie Innovationen voran und übertreffen Sie die Wettbewerber bei der Bereitstellung intelligenter Lösungen, die den Anforderungen der heutigen digital geprägten Welt gerecht werden.',
            text32: 'Maßgeschneiderte Lösungen, die Ihren Geschäftsbedürfnissen entsprechen',
            text33: 'Wir bieten Lösungen, die speziell auf die einzigartigen Bedürfnisse Ihres Unternehmens zugeschnitten sind und perfekt auf Ihre Anforderungen und Ziele abgestimmt sind.',
            text34: 'Entwicklung von KI-Strategien, Datenanalyse und Modellierung',
            text35: 'Mit unserer Expertise in der Entwicklung von KI-Strategien, Datenanalyse und Modellierung bieten wir einen ganzheitlichen Ansatz, um Organisationen zu helfen, die Kraft der künstlichen Intelligenz zu nutzen, ihre datengestützten Prozesse zu optimieren und Innovationen in ihren jeweiligen Branchen voranzutreiben.',
            text36: 'KI in datengestützten Entscheidungsprozessen',
            text37: 'Wir haben ein Verständnis für Technologien der künstlichen Intelligenz und deren Anwendung bei der Analyse und Interpretation großer Datensätze, um fundierte Entscheidungen zu treffen. Es beinhaltet die Nutzung von KI-Algorithmen und -Techniken, um wertvolle Erkenntnisse zu gewinnen, Muster zu identifizieren und Ergebnisse vorherzusagen, die effektive Entscheidungsprozesse vorantreiben können.',
            text38: 'Verkaufstests',
            text40: 'Wählen Sie einen Kontext:',
            text41: '"Unterthemen generieren"-Schaltfläche generiert Unterthemen, die mit dem Kontext verbunden sind. Wähle ein Unterthema nach dem anderen aus und klicke auf "Fragen generieren", um verwandte Fragen zu erstellen.',
            text42: 'Du kannst deine Tests kostenlos anbieten oder du kannst deine Tests verkaufen und von deinem Wissen und deiner Expertise profitieren. Für jeden verkauften Test erhebt DedaAI eine Transaktions- und Wartungsgebühr von 12%.',
            text43: 'Wenn du kostenpflichtige Tests erstellst, musst du ein Konto erstellen, um Zahlungen zu sammeln.',
            
            userexists:  'Benutzer existiert bereits.',
            updatetest: "Möchtest du deinen Test aktualisieren ",

            viewallquestions: 'Alle anzeigen',
     
            waitonresponse: 'Warten auf Antwort...',

        },
              
        assistant: {
            clearall: "Löschen",
            credits: 'Credits',
            contextconversation: 'Die Konversation findet in einem Kontext statt.',

            summary: 'Zusammenfassung',
            reversesummary: 'Umgekehrte',
            navbartitle_1: "Copilot:",
            navbartitle_2: "Chat:",
            navbarsave: 'Speichern',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Themen',

            navbarvariations: 'Kreativität der Antwort',
            navbartext1: 'Chat behält den Kontext im Blick und sorgt nahtlos für den Fortgang Ihres Gesprächs.',
            navbartext2: 'Verwende die Schaltfläche \'Zusammenfassung\', um lange Gespräche zusammenzufassen.',
            navbartext3: 'Verwende die Schaltfläche \'Alles löschen\', um ein neues Gespräch mit einem neuen Kontext zu beginnen.',
            navbartext4: 'Verwende \'Kreativität der Antwort\', um mehr Variationen in den KI-Antworten zu erhalten.',
            note: 'Das Gespräch findet in einem Kontext statt. Jede neue Antwort steht in Beziehung zu vorherigen Antworten.',


            promptplaceholder:'Frag mich über ...',
            summaryprompt: 'Entferne Fragen und fasse den folgenden Text zusammen:',
            responselanguage:"Schicke mir eine Antwort in.",
            conversationlanguage:'Dieses Gespräch ist in ',
            whatisthetopic: 'Was ist das Thema in dem Folgenden:',
            relatedquestions: "Geben Sie eine Antwort im folgenden Format: '@@@Thema: '. Geben Sie mir drei damit verbundene Fragen zur Aufforderung. Fügen Sie jedem Frage eine Präfix '@@@' hinzu und zeigen Sie keine Nummern und das Präfix 'Frage' an.",
            related: 'Verwandt',
            summarizetext: 'Fassen Sie den folgenden Text zusammen:',
        },

       betterresponses: {
            navbartitle: 'Multi-KI-Antworten:',
            note: 'Diese Seite kombiniert die Antworten verschiedener KI-Modelle und bietet die beste Antwort. Sie verbraucht mehr Credits und benötigt mehr Zeit, um eine Antwort zu liefern. Jede Antwort ist unabhängig von vorherigen Fragen und Antworten.',

            waitonresponse_1: 'Durchgang 1 von 3: Antworten werden abgerufen...',
            waitonresponse_2: 'Durchgang 2 von 3: Antwort wird vorbereitet...',
            waitonresponse_3: 'Durchgang 3 von 3: Antwort wird finalisiert...',
        
       },

        common: {
            clearall: "Löschen",
            credits: 'Guthaben',
            contextconversation: 'Die Konversation ist außerhalb des Kontexts.',

            deletedefaultprompt:  'Dies ist eine Standardaufforderung und kann nicht gelöscht werden.',
            dialoglabel_1: 'Name:',
            dialoglabel_2: 'Eingabeaufforderung:',
            dialogadd: 'Hinzufügen',
            dialogdelete: "Möchten Sie löschen ",
            dialogdefaultpromptedit: "Dies ist eine Standardaufforderung und kann nicht bearbeitet werden.",
            dialogdefaultpromptdelete: "Dies ist eine Standardaufforderung und kann nicht gelöscht werden.",
            dialogupdate: 'Aktualisieren',
            dialogsamename: "Eine Aufforderung mit demselben Namen existiert bereits.",
            dialogtitle: 'Benutzerdefinierte Aufforderung',
            dialogeditprompt: 'Bearbeiten Sie den Namen und die Aufforderung und speichern Sie sie als Verknüpfung.',
            dialogaddprompt: 'Geben Sie den Namen und die Aufforderung ein und speichern Sie sie als Verknüpfung.',
            dialogupdateprompt: "Möchten Sie die Aufforderung aktualisieren?",

            summary: 'Zusammenfassung',
            reversesummary: 'Umgekehrte',
            navbartitle: "Allgemein",
            navbartopic:'Archiv',
            navbarsave: 'Speichern',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Themen',

            navbarvariations: 'Antwort-Kreativität',
            promptplaceholder:'Frag mich über ...',
            navbartext1: 'Erstellen Sie Verknüpfungen für häufig verwendete Eingabeaufforderungen.',
            navbartext3: 'Verwende Antwort-Kreativität, um Variationen in den AI-Antworten zu erhalten.',
            note: 'Diese Seite verbraucht weniger Credits. Jede neue Antwort ist unabhängig von vorherigen Fragen und Antworten.',
        
            conversationlanguage:'Dieses Gespräch ist in ',
            responselanguage:"Schicke mir eine Antwort auf ",

            shortcuts: 'Eingabeaufforderung',
            shortcutgrammar: 'Grammatik',
            shortcutkeywords: 'Schlüsselwörter',
            shortcutsummary: 'Zusammenfassung',
            shortcutcompact: 'Kompakt',
            shortcutstory: 'Eine Geschichte schreiben',
            shortcutimprove: 'Verbessern',
            shortcutemail: 'E-Mail',
            shortcutdescription: 'Beschreiben',

            promptgrammar: 'Korrigiere die Grammatik des folgenden Textes: ',
            promptkeywords: 'Extrahiere die wichtigsten Schlüsselwörter aus dem folgenden Text: ',
            promptsummary: 'Fasse den folgenden Text zusammen: ',
            promptcompact: 'Fasse den folgenden Text kompakt zusammen: ',
            promptstory: 'Schreibe die Geschichte über: ',
            promptimprove: 'Verbessere den folgenden Text: ',
            promptemail: 'Schreibe eine E-Mail über: ',
            promptdescription: 'Schreibe eine Beschreibung von: ',
           
        },

        compareai: {
            navbartitle: 'AI-Modelle vergleichen:',
        },

        comprehensiveresponses: {
            cleardata: "Daten werden gelöscht. Möchten Sie fortfahren?",
            navbartitle: 'Meine Bibliothek:',
            displaymodenormal: 'Standard',
            displaymodedetailed: 'Detailliert',
            displaymodecomprehensive: 'Umfassend',
           
            prepareresponse: 'Antwort wird vorbereitet...',
            prepareresponse_1: 'Bitte warten Sie, während wir unsere Antwort vorbereiten.',
            note: 'Diese Seite bietet detaillierte kontextuelle Informationen, die nützlich sind, um Dokumente, Artikel, Arbeiten, Geschichten und mehr zu erstellen.',
            note_1: 'Erhalten Sie die beste KI-Antwort, indem Sie Ergebnisse aus mehreren KI-Modellen auf dieser Seite vergleichen und kombinieren.',
          
            sendrequest: 'Anfrage senden',
            showresponse: 'Anzeigen',
            hideresponse: 'Verbergen',
            sendrequestagain: 'Anfrage erneut senden',
            minimumcredits: 'Ein Mindestguthaben von 3.000 Credits ist erforderlich, um eine detaillierte Antwort zu generieren.',
        },

        contactus: {
            title: 'Kontaktieren Sie uns',
            subtitle1: "Erzählen Sie uns von Ihrer DedaAI-Erfahrung und schlagen Sie Verbesserungen und neue Funktionen vor.",
            subtitle2: "Kontaktieren Sie uns bezüglich Ihrer geschäftlichen Bedürfnisse, und DedaAI wird Ihnen mit Lösungen helfen.",

            placeholdername: 'Name',
            placeholdercompanyname: 'Firmenname',
            placeholderemail: 'E-Mail',
            placeholdersubject: 'Betreff',
            placeholdertext: 'Text',
            buttonsend: 'Senden'

        },

        copilot: {
            navbartext1: 'Der Copilot hilft Ihnen, Antworten zu finden und Ihr gewähltes Thema eingehender zu erkunden.',
            navbartext2: "Verwenden Sie 'Antwort-Kreativität', um mehr Variationen in den KI-Antworten zu erhalten.",
        
            note:'Jede Antwort enthält Vorschläge für weitere Erkundungen.'
        
        },

        credits: {
           
            creditlimit:'Die maximale Anzahl von Credits beträgt 400 000. Wenn Sie mehr hinzufügen, überschreiten Sie das Limit.',
           
            title: 'Credits erhalten',
            text1: 'Kein Abonnement erforderlich. Bezahlen Sie nur für die Wörter, die Sie verwenden. Wenn Sie Guthaben benötigen, fügen Sie einfach mehr hinzu.',
            text2: 'Einmalige Zahlung von $7.99',
            text3: '100000 Credits (~300 Seiten Text).',
           
            text5: 'Sie haben',
            text6: 'verfügbare Credits.',
            text7: '*Zahlungen sind nicht rückerstattbar.',
            text12: '12,99 $ einmalige Zahlung',
            text13: '200.000 Credits (~600 Seiten Text).',

            paymenttext1: '$7.99 Einmalige Zahlung',
            paymenttext2: '$12.99 Einmalige Zahlung',
            creditstext1: '100.000 Credits (~300 Seiten Text)',
            creditstext2: '200.000 Credits (~600 Seiten Text)',
            buttontext1: 'Mit $7.99 Zahlung fortfahren',
            buttontext2: 'Mit $12.99 Zahlung fortfahren',
            taxtext: '( +10% Steuer )',

        },

        creditssuccess: {
            thankyou: 'Vielen Dank für Ihre Zahlung.',
            totalcredits: 'Gesamtguthaben verfügbar: ',
        },

        dialog: {
            cleardata: 'Möchten Sie die Daten löschen?',
            cleartemplatedata: 'Möchten Sie die Vorlagendaten löschen?',
            clearresponse: 'Möchten Sie die Antwortdaten löschen?',
            deletetemplatestep: 'Möchten Sie diesen Schritt löschen?',
            yes: 'Ja',
            cancel: 'Abbrechen',
            ok: 'Ok',
        },

        documentanalysis: {  

            attachfile:'Datei anhängen',

            fileexists: 'Eine Datei mit diesem Namen wurde bereits hinzugefügt.',
            filesizeoverlimit: 'Die Gesamtgröße der Datei(en) überschreitet das Limit von 20 MB.', 
            filenotsupported: 'Dateien dieses Typs werden nicht unterstützt.', 
            filenotattached: 'Bitte fügen Sie die Datei zur Suche bei.',
            filesmaxnumber: 'Sie können bis zu drei Dateien anhängen.',

            navbartitle_2: "Dokumentensuche:",
            navbarsavedtitles: 'Themen',

            navbartext1: 'Attach TXT, PDFand DOCS documents.',   
            navbartext2: "Wenn die Dokumente angehängt sind, gilt die Eingabeaufforderung für deren Inhalt.",
            navbartext3: 'Verwenden Sie die Schaltfläche \'Löschen\', um ein neues Gespräch mit einem neuen Kontext zu beginnen.',
            note: 'TXT-, PDF-und DOCS- Dokumente anhängen. Die Eingabeaufforderung wird auf den Dokumenteninhalt angewendet.',
        
            preparefile: 'Eine Datei wird vorbereitet...',  
            preparefiletext: 'Dies kann je nach Dateigröße länger dauern.'  
        
        },

        general: {
            accept: 'Akzeptieren',
            cancel: 'Stornieren',
            delete: 'Löschen',
            searchname: 'Name',
            searchauthor: 'Autor',
        },

     

        home: {

            advicetitle: "Ratschläge",
            advice: "Holen Sie sich Ratschläge von DedaAI zu verschiedenen Themen und erkunden Sie weitere Möglichkeiten, indem Sie DedaAI um weitere Unterstützung bitten.",
            art: "Kunst",
            assistant: "Assistent",

            boughtcredits: 'Kaufe Kredite...',
            businesssolutions: "Geschäftslösungen",

            chatgeneralcopilotheader: 'Chat, Copilot und Allgemein',
            chatgeneralcopilottext: 'Chatte mit KI. Das Gespräch findet in einem Kontext statt, wobei jede neue Antwort mit den vorherigen zusammenhängt.',
            chatgeneralcopilottext_1: 'Chatte mit KI, erstelle benutzerdefinierte Eingabeaufforderungen und verwende sie erneut. Diese Seite verbraucht weniger Credits. Jede Antwort ist unabhängig von vorherigen Antworten.',
            chatgeneralcopilottext_2: 'Jede KI-Antwort enthält bis zu 5 verwandte Eingabeaufforderungen, um die Antworten weiter auszubauen.',
            chatchat: 'Chat: ',
            chatgeneral: 'Allgemein: ',
            chatcopilot: 'Copilot: ',

            country: "Land",
            common: "Gemeinsam",
            commontext: "Verbessern Sie Ihre Schreibfähigkeiten, indem Sie lange Anfragen vermeiden und Abkürzungen für häufige Aufgaben nutzen.",
            compacttitle: "Den Text komprimieren",
            compact: "Verkürzen Sie die Länge des Textes. Entfernen Sie unnötige oder redundante Informationen, vereinfachen Sie Sätze und optimieren Sie die Gesamtstruktur, während Sie ihre Bedeutung und Klarheit beibehalten.",
            compareaiheader: "Vergleiche KI-Modelle und wähle die beste Antwort aus",
            compareaitext: "Modelle unterscheiden sich in ihren Antworten. Wählen Sie zwischen AI-Modellen und wählen Sie die beste Antwort aus.",
            
            customversion: "Vollständige Anpassung ist möglich. Kontaktieren Sie DedaAI für weitere Informationen.",

           
            comprehensiveresponsesheader: 'Meine Bibliothek',  
            comprehensiveresponsestext_tooltip: 'Erstellen Sie eine personalisierte Bibliothek basierend auf Ihren Interessen. Sammeln und speichern Sie detaillierte Informationen zu einer Vielzahl von Themen, von Wissenschaft und Kunst bis hin zu Geschichte, Natur und alltäglichen Themen.',  
            comprehensiveresponsestext_1: 'Erstellen Sie eine personalisierte Bibliothek basierend auf Ihren Interessen. Sammeln und speichern Sie detaillierte Informationen zu einer Vielzahl von Themen, von Wissenschaft und Kunst bis hin zu Geschichte, Natur und alltäglichen Themen. Probieren Sie die folgenden Beispiele aus:',  
            comprehensiveresponsestext1: '- Ein kleines Unternehmen gründen',  
            comprehensiveresponsestext1_1: 'Rechtsform, Geschäftspläne, Lizenzen und Marketingstrategien ...',  
            comprehensiveresponsestext2: '- Einen Roman über den Tiger im Dschungel schreiben',  
            comprehensiveresponsestext2_1: 'Ideen sammeln und Gliederung erstellen, Entwurf verfassen, überarbeiten, veröffentlichen ...',  
            comprehensiveresponsestext3: '- Napoleon',  
            comprehensiveresponsestext3_1: 'Frühes Leben, Aufstieg zur Macht, militärische Kampagnen, politische Reformen ...',  
            comprehensiveresponsestext4: '- Einen Artikel über die Erforschung des Mondes verfassen',  
            comprehensiveresponsestext4_1: 'Formulierung einer Forschungsfrage, Identifizierung und Nutzung von Quellen, Bewertung der Quellenglaubwürdigkeit, korrekte Zitiermethoden, Zusammenführung der Informationen zu einem schlüssigen Argument.',  
            comprehensiveresponsestext5: '- Spanien 15. - 16. Jahrhundert',  
            comprehensiveresponsestext5_1: 'Vereinigung, Monarchie, Inquisition, Entdeckungsreisen,...',  
            comprehensiveresponsestext6: '- International reisen',  
            comprehensiveresponsestext6_1: 'Ein ausführlicher Leitfaden würde notwendige Werkzeuge, Sicherheitsvorkehrungen, Schritt-für-Schritt-Anleitungen abdecken,...',

            documentanalysisheader: 'Dokumentensuche',
            documentanalysistext: 'Fügen Sie mehrere Dokumente hinzu und durchsuchen und analysieren Sie sie. Finden Sie Antworten und extrahieren Sie Themen.',
            descriptiontitle: "Eine Beschreibung geben",
            description: "Geben Sie eine Beschreibung eines Elements basierend auf den gegebenen Informationen. Geben Sie Fakten oder Eigenschaften eines Elements an und lassen Sie DedaAI den Rest erledigen.",

            examples: "Beispiele",
            emailstitle: "E-Mails und E-Mail-Threads",
            emails: "Erstellen Sie individuell angepasste E-Mails für einzelne Kunden mit unserem Vorlagetool. Erstellen Sie für jeden Kunden eine Vorlage mit ihren Vorlieben, aktualisieren Sie sie mit relevanten Fakten und lassen Sie die KI eine E-Mail für Sie generieren. Verwenden Sie unsere Common-Seite, um lange E-Mail-Threads zusammenzufassen.",
           
            famousperson: "Berühmte Persönlichkeit",
            famouspersontitle: "Mit einer berühmten Person chatten",
            famouspersonchat: "Führen Sie Gespräche mit historischen Persönlichkeiten und erfahren Sie durch interaktive Lernerlebnisse mehr über sie.",

            features1: 'Dokumentensuche',
            features_1: 'Hängen Sie TXT-, PDF- und DOC-Dateien an und durchsuchen Sie sie nach wichtigen Daten.',
            features2: 'TESTS im Bildungswesen',
            features_2: 'Eine intuitive Plattform für Professoren, Lehrer, Schüler und Eltern, um mühelos Tests zu erstellen.',
            features3: 'Handelsstrategien',
            features_3: 'Erstellen Sie Handelsstrategien mit historischen Aktiendaten.',
            features4: 'Notizen',
            features_4: 'Organisieren Sie Ihre Daten in Notizen und fragen Sie sie einfach ab. Nutzen Sie DedaAITemplates®, um mühelos Vorlagen für jede Aufgabe zu generieren. Vermeiden Sie repetitive Aufgaben, indem Sie Ihre Arbeit mit Vorlagen organisieren.',
            features5: 'Artikel erstellen',
            features_5: 'Bauen Sie eine personalisierte Bibliothek basierend auf Ihren Interessen auf. Sammeln und speichern Sie detaillierte Informationen zu einer Vielzahl von Themen, von Wissenschaft und Kunst über Geschichte und Natur bis hin zu alltäglichen Themen.',
            features6: 'Datenbanken durchsuchen',
            features_6: 'Durchsuchen Sie Datenbanken in Ihrer Muttersprache.',
            features7: 'Kundensupport',
            features_7: 'Automatisierter Kundensupport über KI-gestützte Chatbots.',
            
            grammartitle: "Die Grammatik überprüfen",
            grammar: "Überprüfen und korrigieren Sie die Grammatik des bereitgestellten Textes.",

            history: "Geschichte",

            introduction: "Einführung",
            introductiontext1: "",
            interview: "Fragen Sie DedaAI, wie Sie sich effektiv auf ein Vorstellungsgespräch vorbereiten können und welche Arten von Fragen gestellt werden könnten.",
            interviewtitle: "Sich auf ein Vorstellungsgespräch vorbereiten",
            improvetitle: "Den Text verbessern",
            improve: "Verbessern Sie den Text, um seine Qualität, Klarheit, Kohärenz und allgemeine Wirksamkeit zu steigern.",

            keywordstitle: "Die Schlüsselwörter finden",
            keywords: "Identifizieren und extrahieren Sie die bedeutendsten und relevantesten Wörter oder Phrasen, die die Hauptideen, Themen oder Konzepte des Textes erfassen.",
            knowledge: "Testen Sie Ihr Wissen",

            meetingtitle: "Eine Besprechung vorbereiten",
            meeting: "Verbessern Sie Ihre Besprechungsvorbereitung, indem Sie klare und prägnante Besprechungsübersichten erstellen und jede einzelne mit weiteren Details zu jedem Thema erweitern.",
            moto: "Ihr Unternehmen, unsere KI-Lösungen",
          
          
            performancereviewtitle: "Leistungsbewertung",
            performancereview: "Als Manager können Sie den Prozess der Erstellung von Leistungsbewertungen am Ende des Jahres optimieren, indem Sie für jeden Mitarbeiter eine Vorlage mit unserem Vorlagetool erstellen.",
            presentationtitle: "Präsentation",
            presentation: "Bereiten Sie sich auf eine Präsentation vor. Geben Sie DedaAi neben Fragen auch zusätzliche Informationen oder Kontext zu Ihrem Präsentationsthema. Dadurch kann DedaAi maßgeschneiderte und präzisere Antworten geben und die Gesamtqualität Ihrer Vorbereitung verbessern.",
            programming: "Programmierung",

            reporttitle: "Bericht",
            report: "Schreiben Sie einen Bericht mit unserem Vorlagetool. Erstellen Sie Vorlagen für verschiedene Arten von Berichten und verwenden Sie sie wieder, indem Sie nur die Fakten ändern.",
            
            storytitle: "Eine Geschichte schreiben",
            science: "Wissenschaft",
            summarytitle: "Den Text zusammenfassen",
            summary: "Geben Sie einen prägnanten und kondensierten Überblick über die Hauptideen, Schlüsselpunkte und wichtige Details innerhalb eines gegebenen Textes. Dabei geht es darum, die wesentlichen Informationen zu erfassen und in verkürzter Form darzustellen, ohne unnötige oder irrelevante Details einzubeziehen.",
           
            
            translationtitle: "Übersetzung",
            translation: "Übersetzen Sie Dokumente, Artikel, Berichte usw. mit unserer Übersetzungsseite.",
            testheader: 'Tests',
            testtitle:'Test erstellen',
            testtext: "**Tests zur Unterstützung von Studierenden beim Lernen an Hochschulen.",
            templatesamplesintro: 'Verwenden Sie DedaAITemplates®, um mühelos Vorlagen für jede Aufgabe zu generieren. Vermeiden Sie wiederkehrende Aufgaben, indem Sie Ihre Arbeit mit Vorlagen organisieren.',
            texthome1: 'Wir entwickeln anpassbare, fein abgestimmte, private und tragbare Open-Source-Modelle für KI-Lösungen.',
            texthome2: 'Wir sind eine Multi-Model-KI-Plattform',
            texthome3: 'Wir bieten die folgenden maßgeschneiderten Lösungen an',
            textompareaimodels: 'KI-Modelle vergleichen',
            textcomprehensiveresponses: 'Umfassende Antworten',
            textassistant: 'Chat',
            textcommon: 'Häufig',
            texttranslations: 'Übersetzungen',
            texttemplates: 'Notizen',
            texttests: 'Hochschul-Lerntests',
            textcopilot: 'Co-Pilot',
            texttutor: 'Lehrer',
            textquiz: 'Quiz',
            textdocumentanalysis: 'Dokumentensuche',

            textmultiairesponses: 'Es kombiniert Antworten verschiedener KI-Modelle und liefert die beste Antwort.',
            textgeneral: 'Verwende dies für allgemeine Fragen außerhalb eines spezifischen Kontexts. Jede Antwort ist unabhängig von vorherigen Interaktionen. Es verbraucht weniger Credits.',
            textcopilotdescription: 'Nutze Copilot, um Antworten zu erweitern. Jede Antwort enthält Vorschläge für weitere Erkundungen.',
            textchatdescription: 'Unterhalte dich mit der KI über verschiedene Themen und behalte dabei den Kontext während des gesamten Gesprächs.',
            texttranslationdescription: 'Übersetze Texte in verschiedene Sprachen.',
            texttutordescription: 'Lerne durch Interaktion mit der KI mittels Fragen und Antworten.',

            textjobinterview: 'Vorstellungsgespräch',  

            textstocks: 'Aktienhandelsstrategien',
            textstocksdescription: 'Erstellen Sie Aktienhandelsstrategien und finden Sie mit KI-Hilfe Kaufgelegenheiten.',
           
            testjobinterviewdescription: 'Bereiten Sie sich auf Ihren neuen Job vor, indem Sie häufige Interviewfragen üben, um Selbstvertrauen aufzubauen und Ihre Antworten zu verbessern.',

            vacationtitle: "Urlaub",
            vacation: "Lassen Sie sich von DedaAI einige Ideen für Ihren nächsten Urlaub geben.",
            
            writeastory: "Nutzen Sie die Kraft Ihrer Vorstellungskraft, indem Sie eine spannende Handlung mit spezifischen Handlungsdetails entwerfen und lassen Sie DedaAI sie zum Leben erwecken.",
        },

        introduction: {
            introduction: "Einführung",
            text1: "DedaAI bietet Ihnen Tools, um Ihre Interaktion mit ChatGPT zu erleichtern.",
            text2: "ChatGPT ist ein KI-Algorithmus, der Ihnen bei der Suche, dem Lernen und dem Schreiben mit Hilfe von KI hilft.",
            text3: "ES IST NICHT DAS INTERNET. Es kann keine Fragen wie \"Wie ist das Wetter heute?\" beantworten. Denken Sie an jemanden, der VIEL Bücher gelesen hat, der eine große Menge an Wissen angesammelt hat und Ihnen auf vielfältige Weise helfen kann.",
            text4: "Erkunden Sie mit DedaAI.",
            text5: "DedaAI bietet Ihnen folgendes:",

            text6: "DedaAITemplates®:",
            text7: "Unser proprietäres Tool zur Erstellung von wiederverwendbaren Vorlagen für jede Art von Arbeit.",
            text8: "Assistent:",
            text9: "Interaktive Seite, die Ihre Konversation mit KI innerhalb eines Kontextes beibehält.",
            text10: "Gemeinsam:",

            text11: "Seite für zufällige Fragen, bei der jede Frage und Antwort unabhängig von den vorherigen Fragen ist. Es gibt beschleunigte Tasten für die häufigsten Aufgaben.",
            text12: "Übersetzung:",
            text13: "Bietet Textübersetzung ohne übermäßiges Eingeben von Anfragen. Wählen Sie einfach eine Sprache aus und geben Sie einen Text ein.",
            text14: "Tutor",
            text15: "Lernen und testen Sie Ihr Wissen zu jedem Thema, indem Sie mit KI interagieren.",


        },

        jobinterview: {
           

            cleardata: 'Daten werden gelöscht. Möchten Sie fortfahren?',

            navbartitle_2: "Vorstellungsgespräch:",
            note: 'Bitte geben Sie Ihre Fähigkeiten und Erfahrungen ein und senden Sie dann ab.',
            navbartext1: "Bitte geben Sie einen kurzen Überblick über Ihre Erfahrung, Ihre Fähigkeiten, Ihre Kenntnisse und Ihre Fachgebiete und senden Sie diesen anschließend ab. Basierend auf Ihren Angaben erhalten Sie mehrere zentrale Fokusbereiche sowie dazugehörige Interviewfragen. Sie können jede Frage erweitern, um detailliertere und aufschlussreichere Antworten zu erhalten.",
            navbartext2: "Verwenden Sie diese Seite, um sich auf jedes Interview, Gespräch oder jede Diskussion vorzubereiten.",
            navbartext3: "Speichern Sie Fragen, um sie jederzeit überprüfen zu können.",

            of: 'von',

            preparing: 'Vorbereitung',
            promptplaceholder:'Bildung, Erfahrung und Fähigkeiten hinzufügen',

            save: 'Speichern',

            waitontopics: 'Warten auf Themen für das Vorstellungsgespräch...',
        },

        login: {
            
            answernotcorrect: 'Antwort ist nicht korrekt.',

            buttonlogin: 'Einloggen',
            buttonlogout: 'Ausloggen',

            forgotpassword: 'Passwort vergessen?',

            nvalidemail: 'Ungültige E-Mail.',
            invalidanswer: 'Ungültige Antwort.',
            newpassword: 'Bitte erstellen Sie ein neues Passwort',

            logoutlabel: "Bitte klicken Sie auf Abmelden.",
            logintext: 'Sie sind jetzt angemeldet. Bitte fahren Sie mit unserer Homepage fort.',
            logouttext: 'Sie wurden abgemeldet.',
            loginsuccess: 'Sie haben sich erfolgreich angemeldet.',

            placeholderemail: 'ihreme-mail@email.com',
            placeholderpassword: 'Passwort',
            passwordchanged: 'Ihr Passwort wurde geändert.',
            provideanswer: 'Bitte geben Sie eine Antwort.',

            signup: 'Registrieren',
            submit: "Einreichen",

            titlelogin: 'Anmelden',
            titlelogout: 'Abmelden',
            text: 'Wenn Sie kein Konto haben, bitte ',

            wrongpassword: 'Passwort muss mindestens 8 alphanumerische Zeichen lang sein.',

            userexists: 'Benutzer mit der gleichen E-Mail-Adresse existiert bereits!',

        },

        mainmenu: {
            aboutus: "Über uns",
           
            assistant: 'Copilot',

            betterresponses: 'Multi-KI-Antworten',

            common: "Allgemein",
            credits:"Guthaben",
            contactus: "Kontaktieren Sie uns",
            compareai: 'KI-Modelle vergleichen',
            comprehensiveresponses: 'MEINE BIBLIOTHEK',

            documentanalysis: 'Dokumentensuche',
           
            home: "Startseite",

            jobinterview:'Vorstellungsgespräch',

            login: "Anmelden",
            logout:"Abmelden",
          
            writing:"Chat",
            
            quiz: 'Quiz',
           
            signup: 'Registrieren',

            translation:'Übersetzung',
            templates: 'Notizen',
            tests: "TESTS",
         
        },

        quiz: {
            navbartitle: "Quiz:",
            reset:"Zurücksetzen",
            somethingwrong:"Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
            note:'Bereit für ein Quiz? Geben Sie ein Thema ein, um zu beginnen.'
        },

        signup: {
            answer:"Antwort",
           
            buttonsignup: "Registrieren",

            noemail:'Benutzer mit dieser E-Mail-Adresse existiert nicht.',

            signup: "Registrieren",
            signuptext: "Du erhältst 10000 kostenlose Credits bei der Registrierung.",

            securityquestions:"Sicherheitsfragen",
            securityquestion:"Sicherheitsfrage:",
           

            placeholderemail: "deineemail@email.com",
            placeholderconfirmemail: "Email bestätigen",
            placeholderpassword: "Passwort",
            placeholderconfirmpassword: "Passwort bestätigen",
            question_1:"Was ist der Mädchenname deiner Mutter?",
            question_2:"Wie heißt die Stadt, in der du geboren wurdest?"
        },

        status: {
            accountcreated: 'Ihr Konto wurde erstellt. Sie haben 10000 kostenlose Gutschriften zur Verfügung.',
            addcredits: 'Bitte fügen Sie Gutschriften hinzu.',
            attachfile: 'Textdatei anhängen',  
            attachmaxthreefiles: 'Es können bis zu drei Dateien angehängt werden.',

            deletetopic: 'Möchtest du das Thema löschen',
            deepseeknotsupported: 'Diese Seite unterstützt das DeepSeek-Modell nicht.',

            copy:'Kopieren',

            emailverification: "Bitte geben Sie einen Sicherheitscode ein, der an Ihre E-Mail-Adresse gesendet wurde. Wenn Sie ihn nicht sehen, überprüfen Sie bitte Ihre E-Mail-Adresse oder schauen Sie in Ihrem Spam-Ordner nach.",
            enteraname: "Bitte geben Sie einen Namen ein.",
            enteratext: 'Bitte geben Sie einen Text ein.',
            entersecuritycode: 'Bitte Sicherheitscode eingeben.',
            emailmismatch: 'E-Mail stimmt nicht überein.',
            enteratextandsubmit: 'Geben Sie einen Text ein und senden Sie ihn ab.',
            exampletext1: 'Verwenden Sie dies als Beispiel, um mit einer berühmten Person "zu chatten".',
            exampletext2: 'Dieses Beispiel zeigt Ihnen, wie Sie eine E-Mail erstellen.',
            exampletext3: 'Dieses Beispiel zeigt, wie man einen Artikel oder ein beliebiges Dokument beginnt.',
            exampletext4: 'Verwenden Sie dies als Beispiel, um Ratschläge zu verschiedenen Themen zu erhalten.',
            exampletext5: 'Verwenden Sie dies als Beispiel, wie man ein Gespräch beginnt.',
            exampletext6: 'Dieses Beispiel zeigt, wie man eine Geschichte erstellt. Folgen Sie diesem Beispiel, um Ihre eigenen Geschichten zu erstellen.',
            exampletext8: 'Geben Sie einen Text ein und klicken Sie auf Senden. Verwenden Sie die AI Tutor-Seite, um sich auf ein Interview vorzubereiten und Ihr Wissen zu jedem Thema zu testen.',
            exampletext9: 'Geben Sie einen Anhaltspunkt ein und klicken Sie auf Senden für beliebige Arten von E-Mails.',
            exampletext10: 'Geben Sie einen Anhaltspunkt ein und senden Sie ihn ab.',
            exampletext19: 'Erstellen und speichern Sie benutzerdefinierte Eingabeaufforderungen (Prompts) für wiederkehrende Aufgaben.',
            exampletext20: 'Senden Sie, um eine E-Mail zu erstellen.',
            exampletext21: 'Senden Sie, um eine Bewertung zu erhalten.',
            exampletext22: 'Senden Sie, um ein Ergebnis zu sehen.',
            exampletext23: 'Senden Sie, um einen Bericht zu generieren.',

            footertext1: 'DedaAI verwendet den von ChatGPT bereitgestellten Algorithmus von ',
            footertext2: ' Alle Nutzungsbedingungen werden von ',
            footertext3: 'Richtlinie definiert.',

            globalsearch: 'Im Internet suchen',

            invalidemail: "Ungültige E-Mail.",
            invalidconfirmemail: "Ungültige Bestätigung der E-Mail.",
            invalidanswer:"Ungültige Antwort.",
            invalidsecuritycode: 'Ungültiger Sicherheitscode.',

            loginfailed: 'Anmeldung fehlgeschlagen.',

            notopictosave: 'Es gibt kein Thema zum Speichern.',
            namenotdefined: 'Name ist nicht definiert.',
            noemail: 'Benutzer mit dieser E-Mail existiert nicht.',
            noresponsetosave: 'Es gibt keine Antworten zum Speichern.',

            passwordmismatch: 'Passwort stimmt nicht überein.',
            passwordlength: "Das Passwort muss mindestens 8 alphanumerische Zeichen enthalten.",
            pleaselogin: 'Bitte einloggen.',
            providetopic: 'Bitte geben Sie ein Thema an.',
            provideanswer: 'Bitte geben Sie eine Antwort an.',
            pleaseselectlanguage: 'Bitte wählen Sie eine Sprache aus.',
            
            promptempty: 'Der Text ist leer.',

            responsetype: 'Antworttyp',

            selectmodel: "AI-Modell auswählen",
            selectmodelnote: 'Hinweis: Aufgrund der häufigen Veröffentlichung neuer KI-Modell kann sich die Liste der unterstützten Modell ändern.',
            selectlanguage: 'Wählen Sie die Sprache aus, geben Sie einen Text ein und senden Sie ihn ab.',
            signupsuccess: 'Sie haben sich erfolgreich bei DedaAI registriert. Sie haben 2.500 kostenlose Credits zur Verfügung.',

        },

        templates: {
            add: 'Notiz hinzufügen',
            notes: 'Notizen',
            responses: 'Antworten',
            notesandresponses: "Notizen und Antworten",
            dialognewprompt: 'Neue Notiz',
            dialogupdateprompt: 'Notiz aktualisieren',

           addtooltip: 'Eine Notiz hinzufügen',  
            previewtooltip: 'Notizen anzeigen', 
            
            createtemplate:'Add notes',
            createtemplatetooltip: 'Erstelle deine Sequenz: Füge die Noten nacheinander hinzu. Speichere deine Arbeit: Klicke auf „Archivieren“, um die endgültige Sequenz zu speichern.',
            addprompt: 'Aufforderung hinzufügen',
            addprompt_label1: "Titel, wer, was, usw...",
            addprompt_label2: "Beschreibung, Fakten, usw...",
            clearall: "Löschen",
            credits: 'Credits:',
            close:'Schließen',

            delete: 'Löschen',
                    
          
            navbartitle: "Notizen:",
            navbarsave: 'Speichern',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Themen',

            navbarvariations: 'Antwortkreativität',
            promptplaceholder:'Frag mich nach ...',
            navbartext1: 'Erstelle eine logische Abfolge von Notizen, die die wichtigsten Fakten hervorheben. Dies ist ein modularer Ansatz zur Organisation deiner Arbeit rund um KI.',
            navbartext2: 'Vermeiden Sie das Schreiben langer Aufforderungen, indem Sie Aufgaben in Fakten, Beschreibungen, Wer, Was usw. unterteilen und sie einzeln als Schritte mithilfe von "Aufforderung erstellen" hinzufügen.',
            navbartext3: 'Speichern Sie die Vorlage und verwenden Sie sie erneut mit einem anderen Satz von Daten. Dies eliminiert die Notwendigkeit, lange Aufforderungen wiederholt zu schreiben.',
            navbartext4: 'Beispiel: Angenommen, es gibt fünf Kunden mit unterschiedlichen Präferenzen. Sie können für jeden Kunden eine E-Mail-Vorlage erstellen und nur die Fakten jedes Mal ändern, wenn Sie eine E-Mail senden müssen.',
            navbartext5: 'Schauen Sie sich Beispiele auf der Startseite an und verwenden Sie sie als Ausgangspunkt.',
            navbartext6: 'Verwenden Sie die Antwortkreativität, um Variationen in den KI-Antworten zu erhalten.',
           
            responselanguage:"Senden Sie mir eine Antwort in ",

        
            hide: 'Verbergen', 
            hideprompttext: 'Der letzte Schritt muss eine Eingabeaufforderung sein, die auf den Template-Kontext angewendet wird.',
            
            hideprompt: 'Aufforderung verbergen',
            
            preview: 'Vorschau',
            
            placeholderwho:'Titel, Wer, Was usw. ...',
            placeholderwhat: 'Beschreibung, Fakten usw. ...',

            showprompt: 'Eingabeaufforderung anzeigen',
            showprompttext: 'Die Eingabeaufforderung wird auf den Template-Kontext angewendet.',

            Update: 'Aktualisierung',
        
            whowarning: "Bitte fügen Sie 'Titel, Wer, Was usw. ...' hinzu",
            whatwarning:"'Beschreibung, Fakten, ...' ist leer. Möchten Sie es leer lassen?",
        },

        templatesamples: {
            templatesamples: 'Vorlagensamples',
            prepareameeting: 'Vorbereitung eines Meetings',
            writeareport:'Verfassen eines Berichts',
            performancereview:'Leistungsbewertung',
            email: 'E-Mail',
            travelexpense: 'Reisekosten',

        },

        translation: {
            clearall: "Löschen",
            credits: 'Credits',
            summary: 'Zusammenfassung',
            reversesummary: 'Umgekehrte',
            navbartitle: "Übersetzung:",
            navbarsave: 'Speichern',
            navbarsavedtitles: 'Themen',
            navbarsaveplaceholder: 'Speichern unter ...',
            translateto: 'Übersetzen nach: ',
            
            navbarvariations: 'Kreativität der Antwort',
            promptplaceholder:'Geben Sie einen Text ein, um ihn zu übersetzen ...',
            navbartext1: 'Wählen Sie eine Sprache aus, geben Sie einen Text ein, um ihn zu übersetzen, und senden Sie ihn ab.',
            navbartext2: 'Aufgrund der KI-Beschränkungen für die Menge an Text, die gleichzeitig verarbeitet werden kann, teilen Sie großen Text in Absätze oder Kapitel auf und übersetzen Sie sie einzeln.',
            navbartext3: 'Speichern Sie Ihre Arbeit und setzen Sie sie jederzeit fort.',
          
            showprompts: 'Prompts anzeigen',
            hideprompts: 'Prompts ausblenden',
        },

        tutor:{
            askquestion:'Frage',

            clearall: "Löschen",
            credits: 'Credits',
           
            navbartitle: "Tutor:",
            navbarsave: 'Speichern',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Themen',
            navbarlanguage:"Sprache: ",

            navbarvariations: 'Kreativität der Antwort',
            navbartext1: 'Lernen Sie ein Thema oder testen Sie Ihr Wissen zu einem beliebigen Thema. Geben Sie ein Thema ein, klicken Sie auf \'Frage\', geben Sie eine Antwort ein und senden Sie sie ab.',            
            navbartext2: 'Speichern Sie Ihre Konversation. Überprüfen Sie sie oder setzen Sie sie jederzeit fort.',
            navbartext3: 'Verwenden Sie die Kreativität der Antwort, um Variationen in den KI-Antworten zu erhalten.',
            
            note: 'Bitte geben Sie ein Thema ein und klicken Sie auf "Frage". Danach geben Sie Ihre Antwort ein und senden Sie sie ab.',
            promptplaceholder:'Geben Sie eine Antwort ein ...',
            responselanguage:"Senden Sie mir eine Antwort in .",

            tutortema: 'Thema',
            question: 'Frage?',
            
            sametopic: "Es gibt bereits ein Thema mit diesem Namen. Möchtest du es überschreiben?",
            samplemessage: 'Wählen Sie ein Thema aus, klicken Sie auf "Frage?" und senden Sie eine Antwort.',
        },


        
    },

    French: {
        aitest: {
            accept: 'Accepter', 
            account: 'Mon compte',
            accountcapital: 'COMPTE',
            active: 'Actif',
            activated: "Activé / désactivé",
            activity: 'Compte',
            alltestssubtitle: 'Tous les tests',
            addfreetestdialog: 'Voulez-vous ajouter un test gratuit',
            //accountverification: "Vérifier l'identité",
            accountverificationtext: "Assurez-vous que votre vérification d'identité est complète. Le compte ne sera pas valide sans cela.",

            areas: 'Zone de test: ',
            noareatosave: 'La zone de test est manquante.',

            buytestdialog: "Voulez-vous acheter le test",
            buytest: 'Acheter',
            buytestfree: 'Gratuit',
            boughttest: "Vous venez d'acheter le test",
            by: 'par',

            cancel: 'Annuler',
            changeaccount: "Nouveau compte",
            changeaccounttext: "Vous avez déjà le compte de paiement. Si vous voulez le changer, vous devez créer un nouveau compte.",
            cannotbepurchased: 'Ce test ne peut pas être acheté.',
            createaccount: 'Créer un compt',
            createaccounttext: "Si vous prévoyez de vendre vos tests, vous devez d'abord créer un compte pour recevoir les paiements.",
            creatorname: 'Auteur',
            createtest:'Créer un test',
            createtesttitle: 'CRÉER UN TEST',
            createaccounttitle: 'Créer un compte',
            createaccountbutton: 'Créer un compte',
            choosetesttitle:'TESTS GÉNÉRAUX',
            collegetests:"Tests d'étude pour le collège",

            dialogquestion: "Question:",
            dialoganswer_1: "Réponse 1:",
            dialoganswer_2: "Réponse 2:",
            dialoganswer_3: "Réponse 3:",
            dialogmodifytest: 'Modifier le test',
            dialogupdate: 'Mettre à jour',
            description: 'Description :',
            descriptionprompt: 'Ajouter une description au test',

            expired: 'Expiré',

            free: 'Gratuit',
            freevspaidtest: "Tests gratuits ou payants",

            generatesubtopics: 'Générer des sous-thèmes',  
            generatequestions: 'Générer des questions',

            howtocreatetest: "Comment créer un test",

            login: 'Veuillez vous connecter.',
            language: 'Langue: ',

            moreanswertitle: "Plus d'informations sur ...",
            mytests: 'Mes Tests',
            mytestalert: 'Ce test est créé par vous et ne peut pas être acheté.',

            navbartitle: "Test:",
            newsubtopics: "Voulez-vous créer de nouveaux sous-sujets à partir d'un contexte donné ?",
            notactive: "Pas en cours d'utilisation",
            notactivated: "Non activé",
            nocreatornametosave: "Le nom de l'auteur est manquant.",
            nodescriptiontosave: "Description manquante.",

            opentest: 'Sélectionnez un test',

            resettooltip: "Réinitialiser les réponses",
            resetanswers: "Voulez-vous réinitialiser les réponses ?",

            paidtestwarning: "Ceci est un test payant et sera disponible à l'achat. DedaAI prélèvera 12 % de chaque vente en tant que frais pour les coûts de traitement des paiements. Voulez-vous activer ce test ?",
            placeholdergeneratetestid: 'ID du test',
            placeholderopentest: 'ID du test',
            problemsavingfile: "Il y a eu un problème lors de l'enregistrement du fichier.",
            prompttestname: 'Nom du test',
            previewquestions: "Ceci est un aperçu de test payant et seules les cinq premières questions sont affichées.", 
            purchasedtests: 'Tests Achetés',

            questions: 'Questions:',
            questionsbutton: 'Questions',
            questionslimit: "Vous avez atteint le nombre maximum de questions autorisées pour ce test.",
            

            sameauthor: "Un autre auteur avec le même nom existe déjà. S'il vous plaît, choisissez un autre nom.",
            sametestname: "l y a un autre test avec le même nom d'un autre auteur et il ne peut pas être mis à jour.",
            savetestname: 'Nom du test',
            savedtests:'Mes tests',
            savetest: 'Enregistrer le test',
            save: 'Enregistrer',
            savechosentest: "Voulez-vous enregistrer vos réponses?",
            saveanswers: "Sauvegarder",
            selecttest:'Tests généraux',
            selecttestarea: 'Sélectionnez une zone de test.',
            selectedtestinfo: "Vous avez sélectionné le test suivant pour l'achat :",
            selecttestlanguage: 'Sélectionnez une langue de test',
            showcontext: 'Contexte',
            somethingwentwrong: "Une erreur s'est produite. Veuillez réessayer.",
            startreceivingpayments: "Créez un compte pour commencer à recevoir des paiements.",
            subtopics: 'Sous-thèmes',
            subtopicssubtext: 'Les sous-thèmes sont générés à partir du contexte et aideront à créer des questions plus détaillées.',

            test: "Résultat de test:",
            testid: "Générer l'identifiant du test",
            testname: 'Nom du test',
            testexists: ' já está na lista de testes adquiridos.',
            topic: 'Contexte:',
            testprice: 'Prix: $',
            tests:'Tests:',
            totalearnings: 'Total des gains: $',
            topicplaceholder: 'Entrez un contexte et continuez avec "Generer des Questions"',
            transfermoney: "ransférer de l'argent",
            transactions: 'Transactions',
            transfermoneybutton: 'Transférer',
            testarea: 'zone: ',
            testlanguage: 'langue: ',
            text1: 'Cliquez sur le sous-thème pour le sélectionner.',
            text2: "Un test non utilisé n'a aucun achat ou tous les achats ont expiré. Ce test peut être supprimé.",
            text3: "Le test doit être activé pour devenir disponible à l'utilisation. Pendant la création, le test n'est PAS ACTIF et n'est pas disponible à l'utilisation. Lorsque vous êtes satisfait de son contenu, rendez-le public en activant la case à cocher.",
            text4: "Créez un test avec l'aide de l'IA. Entrez un contexte, cliquez sur \"Générer des questions\" et l'IA générera des questions avec des réponses. Modifiez les questions et les réponses selon vos besoins. Une fois le test prêt, activez-le pour le rendre public.",
            text7: "de la liste de vos tests favoris ou de la liste de Tous les tests. Certains tests sont gratuits et d'autres doivent être achetés. Le test acheté est valable pendant 6 mois à compter de la date d'achat. Vous pouvez passer un test autant de fois que vous le souhaitez.",
            text8: 'Choisir un test ',
            text9: 'Créer un test ',
            text10: "Préparez des tests en utilisant notre plateforme de test pour aider les étudiants, les employés et les amis avec leurs examens et évaluations. Impliquez et mettez au défi vos élèves, employés ou amis avec des tests bien conçus.",
            text11: "Voulez-vous acheter le test ",
            text12: "Vous pourrez l'utiliser pendant 6 mois à partir d'aujourd'hui.",  
            text13: "Vendez vos tests et monétisez vos connaissances et votre expertise. Gagnez de l'argent tout en aidant la communauté à élargir ses connaissances. Engagez et défiez vos étudiants, employés ou amis avec des tests bien conçus.",
            text14: "Trouvez les tests qui correspondent le mieux à vos besoins en préparation aux examens et évaluations. Approfondissez votre apprentissage en développant les réponses correctes et en améliorant votre compréhension de chaque sujet. Commencez votre parcours vers le succès aujourd'hui et élevez vos connaissances.",
            text15: "Ce test est créé par vous et ne peut pas être sélectionné.",
            text17: "Ce test sera supprimé. Voulez-vous continuer à supprimer ce test ?",
            text18: " Voulez-vous activer ce test pour le rendre public?",
            text19: "Voulez-vous désactiver ce test?",
            text21: "Le test ne peut pas être modifié lorsqu'il est en ÉTAT ACTIF (en cours d'utilisation).",
            text22: "Les questions sont générées trois à la fois. Les réponses correctes sont placées au hasard. Vous pouvez changer un contexte avant que les prochaines questions ne soient créées pour obtenir des questions plus spécifiques sur un contexte.",
            text23: "Le test a expiré et ne peut pas être affiché.",
            text24: "Le contexte doit être fourni avant de générer des sous-thèmes.",
            text25: "Voulez-vous générer des sous-thèmes à partir d'un contexte donné?",
            text26: 'Ceci est un test payant. Le test ne peut pas être activé car vous n\'avez pas créé de compte pour accepter des paiements. Veuillez créer un compte en cliquant sur "Compte".',
            text27: "Ceci est un test payant et sera disponible à l'achat. DedaAI collectera 18 % du prix d'achat en tant que frais et pour les coûts de traitement des paiements. Voulez-vous activer ce test ?",
            text30: 'Obtenez un avantage concurrentiel',
            text31: "Soyez à l'avant-garde des avancées en IA, débloquez de nouvelles opportunités, stimulez l'innovation et surpassez vos concurrents en offrant des solutions intelligentes qui répondent aux exigences du monde numérique d'aujourd'hui.",
            text32: 'Solutions sur mesure qui correspondent aux besoins de votre entreprise',
            text33: 'Nous fournissons des solutions spécifiquement adaptées pour répondre aux besoins uniques de votre entreprise et parfaitement alignées avec vos exigences et objectifs.',
            text34: 'Développement de stratégie IA, analyse des données et modélisation',
            text35: "Avec notre expertise en développement de stratégie IA, analyse des données et modélisation, nous offrons une approche holistique pour aider les organisations à tirer parti de la puissance de l'intelligence artificielle, à optimiser leurs processus basés sur les données et à stimuler l'innovation dans leurs secteurs respectifs.",
            text36: 'IA dans la prise de décision basée sur les données',
            text37: "Nous comprenons les technologies d'intelligence artificielle et leur application dans l'analyse et l'interprétation de grands ensembles de données pour prendre des décisions éclairées. Cela implique de tirer parti des algorithmes et des techniques d'IA pour extraire des informations précieuses, identifier des motifs et prédire des résultats qui peuvent favoriser des processus de prise de décision efficaces.",
            text38: 'Vendre des tests',
            text40: 'Sélectionner un contexte :',
            text41: '"Le bouton "Générer des sous-thèmes" générera des sous-thèmes liés au contexte. Sélectionnez un sous-thème à la fois et cliquez sur "Générer des questions" pour créer des questions liées.',
            text42: 'Vous pouvez offrir vos tests gratuitement ou vous pouvez vendre vos tests et monétiser vos connaissances et votre expertise. Pour chaque test vendu, DedaAI percevra 12 % de frais de transaction et de maintenance.',
            text43: 'Si vous créez des tests payants, vous devez créer un compte pour commencer à collecter des paiements.',         

            userexists: "L'utilisateur existe déjà.",
            updatetest: "Voulez-vous mettre à jour votre test ",

            viewallquestions: "Afficher tout",

            waitonresponse: 'En attente de réponse...',

        },
        assistant: {
            clearall: "Effacer",
            credits: 'Crédits',
            contextconversation: "La conversation se déroule dans un contexte.",

            summary: 'Résumé',
            reversesummary: 'Inversé',
            navbartitle_1: "Copilot:",
            navbartitle_2: "Chat:",
            navbarsave: 'Enregistrer',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Sujets enregistrés',
            navbarvariations: 'Créativité des réponses',
            promptplaceholder:'Posez-moi une question sur ...',

            navbartext1: 'Le chat garde une trace du contexte et maintient sans effort le fil de votre conversation.',
            navbartext2: "Utilisez le bouton 'Résumé' pour résumer une longue conversation.",
            navbartext3: "Utilisez le bouton 'Effacer' pour commencer une nouvelle conversation avec un nouveau contexte.",
            navbartext4: "Utilisez 'Créativité des réponses' pour obtenir plus de variations dans les réponses de l'IA.",
            note: 'La conversation se déroule dans un contexte. Chaque nouvelle réponse est liée aux réponses précédentes.',

            summaryprompt: "Supprimez les questions et résumez le texte suivant :",
            responselanguage:"Envoyez-moi une réponse en.",
            conversationlanguage:"Cette conversation est en ",
            whatisthetopic: 'Quel est le sujet dans ce qui suit :',
            relatedquestions: "Donnez une réponse dans le format suivant : '@@@Sujet: '. Donnez-moi trois questions liées à la demande. Ajoutez le préfixe '@@@' à chaque question et n'affichez pas les numéros de séquence et le préfixe 'Question",
            related: 'Relatif',
            summarizetext: 'Résumez le texte suivant :',
        },

        betterresponses: {
            navbartitle: 'Réponses Multi-AI:',
            note: 'Cette page combine les réponses de différents modèles d\'IA et fournit la meilleure réponse. Cela consomme plus de crédits et prend plus de temps pour fournir une réponse. Chaque réponse est indépendante des questions et réponses précédentes.',
              
            waitonresponse_1: 'Étape 1 sur 3 : Obtention des réponses...',
            waitonresponse_2: 'Étape 2 sur 3 : Préparation de la réponse...',
            waitonresponse_3: 'Étape 3 sur 3 : Finalisation de la réponse...'
            
        },

        common: {
            clearall: "Effacer",
            credits: 'Crédits',
            contextconversation: "La conversation est hors contexte.",

            deletedefaultprompt:'Ceci est une invite par défaut et ne peut pas être supprimée.',
            dialoglabel_1: 'Nom:',
            dialoglabel_2: 'Invite:',
            dialogadd: 'Ajouter',
            dialogdelete: "Voulez-vous supprimer ",
            dialogdefaultpromptedit: "Ceci est une invite par défaut et ne peut pas être modifiée.",
            dialogdefaultpromptdelete: "Ceci est une invite par défaut et ne peut pas être supprimée.",
            dialogupdate: 'Mettre à jour',
            dialogsamename: "Une invite avec le même nom existe déjà.",
            dialogtitle: 'Invite personnalisée',
            dialogeditprompt: 'Modifier le nom et l\'invite, et l\'enregistrer en tant que raccourci.',
            dialogaddprompt: 'Entrez le nom et l\'invite, et enregistrez-le en tant que raccourci.',
            dialogupdateprompt: "Voulez-vous mettre à jour l'invite?",

            summary: 'Résumé',
            reversesummary: 'Inversé',
            navbartitle: "Commun :",
            navbartopic: 'Archive',
            navbarsave: 'Enregistrer',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Sujets enregistrés',
            
            navbarvariations: 'Créativité de la réponse',
            promptplaceholder:'Demandez-moi à propos de...',
            navbartext1: 'Créez des raccourcis pour les invites utilisées fréquemment.',
            navbartext2: 'Cette page ne conserve pas le contexte. Chaque réponse est directement liée à la question posée et n\'est pas liée aux questions précédentes. Elle utilise moins de crédits que la page Assistant.',
            navbartext3: 'Utilisez la Créativité de la réponse pour obtenir des variations dans les réponses de l\'IA.',
            note: 'Cette page consomme moins de crédits. Chaque nouvelle réponse est indépendante des questions et réponses précédentes.',
                                
            conversationlanguage:'Cette conversation est en ',
            responselanguage:"Envoyez-moi une réponse en ",
            
            shortcuts: 'Invites',
            shortcutgrammar: 'Grammaire',
            shortcutkeywords: 'Mots-clés',
            shortcutsummary: 'Résumé',
            shortcutcompact: 'Compact',
            shortcutstory: 'Écrire une histoire',
            shortcutimprove: 'Améliorer',
            shortcutemail: 'Email',
            shortcutdescription: 'Décrire',

            promptgrammar: 'Corrigez la grammaire du texte suivant : ',
            promptkeywords: 'Extrayez les mots-clés les plus importants du texte suivant : ',
            promptsummary: 'Faites un résumé du texte suivant : ',
            promptcompact: 'Compactez le texte suivant : ',
            promptstory: "Écrivez l'histoire sur : ",
            promptimprove: 'Améliorez le texte suivant : ',
            promptemail: 'Rédigez un email sur : ',
            promptdescription: 'Rédigez une description de : ',
           
        },

        compareai:
        {
            navbartitle: "Comparer les modèles d'IA :",
        },

        comprehensiveresponses: {
                cleardata: "Les données seront effacées. Voulez-vous continuer ?",
                navbartitle: 'Ma bibliothèque :',
                displaymodenormal: 'Standard',
                displaymodedetailed: 'Détaillé',
                displaymodecomprehensive: 'Complet',
               
                prepareresponse: 'Préparation de la réponse...',
                prepareresponse_1: 'Veuillez patienter pendant que nous préparons notre réponse.',
                note: 'Cette page fournit des informations contextuelles détaillées, utiles pour créer des documents, des articles, des travaux, des histoires, et plus encore.',
                note_1: 'Obtenez la meilleure réponse de l\'IA en comparant et en combinant les résultats de plusieurs modèles d\'IA sur cette page.',
               
                sendrequest: 'Envoyer une requête',
                showresponse: 'Afficher',
                hideresponse: 'Masquer',
                sendrequestagain: 'Envoyer une autre requête',
                minimumcredits: 'Un solde minimum de 3 000 crédits est requis pour générer une réponse détaillée.'
            },


        contactus: {
            title: 'Contactez-nous',
            subtitle1: "Parlez-nous de votre expérience avec DedaAI et suggérez des améliorations et de nouvelles fonctionnalités.",
            subtitle2: "Contactez-nous concernant vos besoins commerciaux et DedaAI vous aidera avec des solutions.",
            placeholdername: 'Nom',
            placeholdercompanyname: 'Nom de l\'entreprise',
            placeholderemail: 'Email',
            placeholdersubject: 'Sujet',
            placeholdertext: 'Texte',
            buttonsend: 'Envoyer',

        },

        copilot: {
            navbartext1: 'Copilot vous aide à trouver des réponses et à explorer votre sujet choisi plus en profondeur.',
            navbartext2: "Utilisez la 'créativité de réponse' pour obtenir plus de variations dans les réponses de l'IA.",
            note : 'Chaque réponse comprend suggestions pour une exploration plus approfondie.'
        },

        credits: {
           
            creditlimit:'Le nombre maximum de crédits est de 400 000. Si vous en ajoutez plus, vous dépasserez la limite.',
            

            title : 'Obtenir des crédits',
            text1 : 'Aucune souscription requise. Payez seulement pour les mots que vous utilisez. Si vous avez besoin de crédits, ajoutez-en simplement.',
            text2 : 'Paiement unique de 7.99 $',
            text3 : '100000 crédits (~ 300 pages de texte).',
            text4 : '+10 % de frais de service de paiement.',
            text5 : 'Vous avez',
            text6 : 'crédits disponibles.',
            text7 : '*Les paiements ne sont pas remboursables.',

            text12: 'paiement unique de 12,99 $', 
            text13: '200 000 crédits (~600 pages de texte).',
            
            paymenttext1: '7,99 $ paiement unique',
            paymenttext2: '12,99 $ paiement unique',
            creditstext1: '100 000 crédits (~300 pages de texte)',
            creditstext2: '200 000 crédits (~600 pages de texte)',
            buttontext1: 'Continuer avec le paiement de 7,99 $',
            buttontext2: 'Continuer avec le paiement de 12,99 $',
            taxtext: '( +10% de taxe )',
        },

        creditssuccess: {
            thankyou: 'Merci pour votre paiement.',
            totalcredits: 'Total de crédits disponibles: ',
        },

        dialog: {
            cleardata: 'Voulez-vous effacer les données?',
            cleartemplatedata: 'Voulez-vous effacer les données du modèle?',
            clearresponse: 'Voulez-vous effacer les données de réponse?',
            deletetemplatestep: 'Voulez-vous supprimer cette étape ?',
            yes: 'Oui',
            cancel: 'Annuler',
            ok: 'Ok',
        },

        documentanalysis: {  

            attachfile:'Joindre un fichier',

            fileexists: 'Un fichier portant ce nom a déjà été ajouté.', 
            filesizeoverlimit: 'La taille totale des fichiers dépasse la limite de 20 Mo.', 
            filenotsupported: 'Les fichiers de ce type ne sont pas pris en charge.', 
            filenotattached: 'Veuillez joindre le fichier pour la recherche.',
            filesmaxnumber: "Vous pouvez joindre jusqu'à trois fichiers.",

            navbartitle_2: "Recherche de Documents:",
            navbarsavedtitles: 'Sujets',  

            navbartext1: "Joignez des documents TXT, PDF et DOCS.",  
            navbartext2: "Si les documents sont attachés, l'invite s'appliquera à leur contenu.",  
            navbartext3: 'Utilisez le bouton \'Effacer\' pour commencer une nouvelle conversation avec un nouveau contexte.',  
            note: "Joignez des documents TXT, PDF et DOCS. L'invite sera appliquée au contenu des documents.",  
        
            preparefile: 'Préparation d’un fichier...',  
            preparefiletext: 'Cela peut prendre plus de temps selon la taille du fichier.'
        },

        general: {
            accept: 'Accepter',
            cancel: 'Annuler',
            delete: 'Supprimer',
            searchname: 'Nom',
            searchauthor: 'Auteur',
        },

        home: {
            advicetitle: "Conseil",
            advice: "Obtenez des conseils de DedaAI sur divers sujets et explorez davantage en demandant l'aide de DedaAI.",
            art: "Art",
            assistant: "Assistant",

            boughtcredits: 'Achat de crédits...',
            businesssolutions: "Solutions professionnelles",

            chatgeneralcopilotheader: 'Chat, Copilote et Général',
            chatgeneralcopilottext: 'Discutez avec l’IA. La conversation se déroule dans un contexte, chaque nouvelle réponse étant liée aux précédentes.',
            chatgeneralcopilottext_1: 'Discutez avec l’IA, créez des invites personnalisées et réutilisez-les. Cette page utilise moins de crédits. Chaque réponse est indépendante des réponses précédentes.',
            chatgeneralcopilottext_2: 'Chaque réponse de l’IA contient jusqu’à 5 invites connexes pour approfondir les réponses.',
            chatchat: 'Chat : ',
            chatgeneral: 'Général : ',
            chatcopilot: 'Copilote : ',      
            country: "Pays",
            customversion: "Une personnalisation complète est disponible. Contactez DedaAI pour plus d'informations.",
            common: "Commun",
            commontext: "Améliorez votre écriture en évitant les prompts longs et en utilisant des raccourcis pour les tâches courantes.",
            compareaiheader: "Comparer les modèles d'IA et sélectionner la meilleure réponse",
            compareaitext: "Les modèles diffèrent dans leurs réponses. Choisissez entre les modèles d'IA et sélectionnez la meilleure réponse.",

            comprehensiveresponsesheader: 'Ma bibliothèque',
            comprehensiveresponsestext_tooltip: 'Créez une bibliothèque personnalisée en fonction de vos centres d’intérêt. Rassemblez et enregistrez des informations approfondies sur un large éventail de sujets, allant des sciences et des arts à l’histoire, à la nature et aux thèmes du quotidien.',
            comprehensiveresponsestext_1: 'Créez une bibliothèque personnalisée en fonction de vos centres d’intérêt. Rassemblez et enregistrez des informations approfondies sur un large éventail de sujets, allant des sciences et des arts à l’histoire, à la nature et aux thèmes du quotidien. Essayez les exemples suivants :',
            comprehensiveresponsestext1: '- Créer une petite entreprise',
            comprehensiveresponsestext1_1: 'Structure juridique, plans d’affaires, licences et stratégies de marketing...',
            comprehensiveresponsestext2: '- Écrire un roman sur le tigre dans la jungle',
            comprehensiveresponsestext2_1: 'Génération d’idées et planification, rédaction, correction, publication...',
            comprehensiveresponsestext3: '- Napoléon',
            comprehensiveresponsestext3_1: 'Jeunesse, ascension au pouvoir, campagnes militaires, réformes politiques...',
            comprehensiveresponsestext4: '- Un article sur l’exploration de la Lune',
            comprehensiveresponsestext4_1: 'Formulation d’une question de recherche, identification et accès aux sources, évaluation de la fiabilité des sources, méthodes correctes de citation, synthèse des informations en un argument cohérent.',
            comprehensiveresponsestext5: '- Espagne aux XVe et XVIe siècles',
            comprehensiveresponsestext5_1: 'Unification, monarchie, inquisition, explorations,...',
            comprehensiveresponsestext6: '- Voyager à l’étranger',
            comprehensiveresponsestext6_1: 'Un guide détaillé couvrirait les outils nécessaires, les précautions de sécurité, des instructions étape par étape,...',

            compacttitle: "Réduire le texte",
            compact: "Réduisez la longueur du texte. Supprimez les informations inutiles ou redondantes, simplifiez les phrases et optimisez la structure globale tout en conservant son sens et sa clarté.",
            
            documentanalysisheader: 'Recherche de Documents',
            documentanalysistext: 'Joignez plusieurs documents, recherchez-les et analysez-les. Trouvez des réponses et extrayez des sujets.',
            descriptiontitle: "Fournir une description",
            description: "Fournissez une description d'un objet en fonction des informations fournies. Spécifiez les faits ou les propriétés d'un objet et laissez DedaAI faire le reste du travail.",
            
            examples: "Exemples",
            emailstitle: "Emails et fils de discussion",
            emails: "Créez des emails personnalisés adaptés à chaque client en utilisant notre Outil de Modèles. Créez un modèle pour chaque client avec leurs préférences, mettez à jour avec des faits pertinents et laissez l'IA générer un email pour vous. Utilisez notre page Commune pour résumer de longs fils de discussion par email.",

            famousperson: "Personne célèbre",
            famouspersontitle: "Discuter avec une personne célèbre",
            famouspersonchat: "Engagez des conversations avec des personnalités historiques et apprenez à les connaître grâce à des expériences d'apprentissage interactives.",
            features1: 'Recherche de Documents',
            features_1: 'Attachez des fichiers TXT, PDF et DOC et recherchez-y des données importantes.',
            features2: 'TESTS dans l\'Éducation',
            features_2: 'Une plateforme intuitive permettant aux professeurs, enseignants, étudiants et parents de concevoir des tests sans effort.',
            features3: 'Stratégies de Trading',
            features_3: 'Créez des stratégies de trading en utilisant des données boursières historiques.',
            features4: 'Notes',
            features_4: 'Organisez vos données dans des notes et interrogez-les facilement. Utilisez les Modèles DedaAI® pour générer facilement des modèles pour toute tâche. Évitez les tâches répétitives en organisant votre travail avec des modèles.',
            features5: 'Créer des Articles',
            features_5: 'Construisez une bibliothèque personnalisée en fonction de vos centres d\'intérêt. Collectez et enregistrez des informations détaillées sur un large éventail de sujets, allant de la science et de l\'art à l\'histoire, la nature et les sujets du quotidien.',
            features6: 'Rechercher dans les bases de données',
            features_6: 'Recherchez dans les bases de données en utilisant votre langue maternelle.',
            features7: 'Support client',
            features_7: 'Support client automatisé via des chatbots alimentés par l\'IA.',

            grammartitle: "Vérifier la grammaire",
            grammar: "Vérifiez et corrigez la grammaire du texte fourni.", 

            history: "Histoire",

            introduction: "Introduction",
            introductiontext1:'',
            interviewtitle: "Se préparer à un entretien",
            interview:"Demandez à DedaAI comment se préparer efficacement à un entretien et anticiper les types de questions qui peuvent être posées.",
            improvetitle: "Améliorer le texte",
            improve: "Apportez des améliorations pour améliorer la qualité, la clarté, la cohérence et l'efficacité du texte.",
           
            knowledge: "Testez vos connaissances",
            keywordstitle: "Trouver les mots clés",
            keywords: "Identifiez et extrayez les mots ou les phrases les plus significatifs et pertinents qui capturent les idées principales, les thèmes ou les concepts du texte.",
            
            meetingtitle: "Préparer une réunion",
            meeting: "Améliorez votre préparation de réunion en créant des plans de réunion clairs et concis et en développant chaque sujet avec des détails supplémentaires.",
            moto: "Votre entreprise, nos solutions d'IA.",

            performancereviewtitle: "Évaluation de performance",
            performancereview:"En tant que manager, si vous avez la tâche d'écrire des évaluations de performance annuelles, simplifiez le processus en créant des modèles pour chaque employé à l'aide de notre Outil de Modèles.",
            presentationtitle: "Présentation",
            presentation: "Préparez-vous à une présentation. En plus de poser des questions, veillez à fournir à DedaAi toutes les informations supplémentaires ou le contexte lié à votre sujet de présentation. Cela permettra à DedaAi d'offrir des réponses plus adaptées et précises, améliorant ainsi la qualité globale de votre préparation.",
            programming: "Programmation",

            reporttitle: "Rapport",
            report: "Rédigez un rapport en utilisant notre Outil de Modèles. Créez des modèles pour différents types de rapports et réutilisez-les en ne changeant que les faits.",
            
            storytitle: "Écrire une histoire",
            science: "Science",
            summarytitle: "Résumer le texte",
            summary:"Fournissez un aperçu concis et condensé des idées principales, des points clés et des détails importants d'un texte donné. Cela implique de capturer les informations essentielles et de les présenter de manière abrégée, sans inclure de détails inutiles ou superflus.",
            
            translationtitle: "Traduction",
            translation: "Traduisez des documents, des articles, des rapports, etc. en utilisant notre page de Traduction.",
            testheader: 'Tests',
            testtitle:'Créer un test',
            testtext: "Tests pour aider les étudiants à étudier à l’université.",
            templatesamplesintro: "Utilisez les modèles DedaAITemplates® pour générer facilement des modèles pour n'importe quelle tâche. Évitez les tâches répétitives en organisant votre travail avec des modèles.",
            texthome1: "Nous construisons des solutions d'IA open source personnalisables, parfaitement ajustées, privées et portables.",
            texthome2: 'Nous sommes une plateforme AI multi-modèle',
            texthome3: 'Nous proposons les solutions personnalisées suivantes',
            textompareaimodels: 'Comparer les modèles AI',
            textcomprehensiveresponses: 'Réponses complètes',
            textassistant: 'Chat',
            textcommon: 'Commun',
            texttranslations: 'Traductions',
            texttemplates: 'Notes',
            texttests: 'Tests d’étude universitaire',
            textcopilot: 'Copilote',
            texttutor: 'Tuteur',
            textquiz: 'Quiz',
            textdocumentanalysis: "Recherche de documents",
            textmultiairesponses: "Il combine les réponses de différents modèles d'IA et fournit la meilleure réponse.",
            textgeneral: "Utilisez ceci pour des questions générales en dehors d'un contexte spécifique. Chaque réponse est indépendante des interactions précédentes. Cela utilise moins de crédits.",
            textcopilotdescription: 'Utilisez Copilot pour développer les réponses. Chaque réponse est accompagnée de suggestions pour une exploration plus approfondie.', 
            textchatdescription: "Discutez avec l'IA sur divers sujets tout en conservant le contexte tout au long de la conversation.", 
            texttranslationdescription: 'Traduisez du texte dans différentes langues.', 
            texttutordescription: "Apprenez en interagissant avec l'IA à travers des questions et des réponses.",

            textjobinterview: 'Entretien d\'embauche',  
            testjobinterviewdescription: 'Préparez-vous pour votre nouvel emploi en vous entraînant à répondre aux questions courantes des entretiens pour gagner en confiance et améliorer vos réponses.',

            textstocks: 'Stratégies de Trading sur Actions',
            textstocksdescription: "Créez des stratégies de trading sur actions et trouvez des opportunités d'achat avec l'aide de l'IA.",
            vacationtitle: "Vacances",
            vacation: "Laissez DedaAI vous donner des idées pour vos prochaines vacances.",

            writeastory: "Exploitez le pouvoir de votre imagination en créant un récit captivant avec des détails spécifiques de l'intrigue et laissez DedaAI lui donner vie.",
        
        },

        introduction: {
            introduction: "Introduction",
            text1: "DedaAI vous offre des outils pour faciliter votre interaction avec ChatGPT.",
            text2: "ChatGPT est un algorithme d'intelligence artificielle qui vous aide à rechercher, apprendre et écrire avec l'aide de l'IA.",
            text3: "CE N'EST PAS INTERNEchT. Il ne peut pas répondre à des questions comme \"Quel temps fait-il aujourd'hui?\". Pensez à lui comme à quelqu'un qui a lu BEAUCOUP de livres, qui a accumulé une vaste quantité de connaissances et qui peut vous aider de nombreuses façons.",
            text4: "Explorez avec DedaAI.",
            text5: "DedaAI vous offre les éléments suivants:",

            text6: "DedaAITemplates®:",
            text7: "Notre outil propriétaire pour la création de modèles réutilisables pour tout type de travail.",
            text8: "Assistant:",
            text9: "Page interactive qui garde votre conversation avec l'IA dans un contexte.",
            text10: "Commun:",

            text11: "Page conçue pour des questions aléatoires où chaque question et réponse est indépendante des questions précédentes. Elle dispose de touches accélérées pour les tâches les plus courantes.",
            text12: "Traduction:",
            text13: "Fournit une traduction de texte sans saisie excessive de prompts. Il suffit de sélectionner une langue et de fournir un texte.",
            text14: "Tutor",
            text15: "Apprenez et testez vos connaissances sur n'importe quel sujet en interagissant avec l'IA.",
        },

        jobonterview:
        {
            cleardata: 'Les données seront effacées. Voulez-vous continuer ?',

            navbartitle_2: "Entretien d'embauche :",
            navbartext1: "Veuillez fournir un bref aperçu de votre expérience, de vos compétences, de votre niveau de maîtrise et de vos domaines d'expertise, puis soumettez-le. En fonction de vos informations, vous recevrez plusieurs domaines clés ainsi que des questions d'entretien associées. Vous pouvez développer chaque question pour générer des réponses plus détaillées et pertinentes.",
            navbartext2: "Utilisez cette page pour vous préparer à tout entretien, conversation ou discussion.",
            navbartext3: "Enregistrez les questions pour les consulter à tout moment.",
            note: 'Veuillez saisir vos compétences et votre expérience, puis soumettre.',

            of: 'de',

            preparing: 'Préparation en cours',
            promptplaceholder : 'Ajouter éducation, expérience et compétences.',

            save: 'Enregistrer',

            waitontopics: "En attente des sujets d'entretien d'embauche...",
        },


        login: {
            answernotcorrect: "La réponse n'est pas correcte.",
            buttonlogin: 'Connexion',
            buttonlogout: 'Déconnexion',
            
            forgotpassword: 'Mot de passe oublié?',
            
            nvalidemail: 'Email invalide.',
            invalidanswer: 'Réponse invalide.',
            newpassword: 'Veuillez créer un nouveau mot de passe',
            
            logoutlabel: "Veuillez cliquer sur Déconnexion.",
            logintext: "Vous êtes maintenant connecté. Veuillez continuer avec notre page d'accueil.",
            logouttext: 'Vous avez été déconnecté.',
            loginsuccess: 'Vous vous êtes connecté avec succès.',
            
            placeholderemail: 'votreemail@email.com',
            placeholderpassword: 'Mot de passe',
            passwordchanged: 'Votre mot de passe a été modifié.',
            provideanswer: 'Veuillez fournir une réponse.',
            
            signup: "S'inscrire",
            submit: "Soumettre",
            
            titlelogin: 'Connexion',
            titlelogout: 'Déconnexion',
            text: "Si vous n'avez pas de compte, veuillez ",
            
            wrongpassword: 'Le mot de passe doit contenir au moins 8 caractères alphanumériques.',

            userexists: 'Un utilisateur avec le même email existe déjà !',
                    
        },

        mainmenu: {
            aboutus: "À propos de nous",
            assistant: 'Copilot',

            betterresponses: 'Réponses Multi-AI',

            common: "Commun",
            credits:"Crédits",
            contactus: "Contactez-nous",
            compareai: 'Comparer les modèles d\'IA',
            comprehensiveresponses: 'MA BIBLIOTHÈQUE',
          
            documentanalysis: 'Recherche de Documents',

            home: "Accueil",

            jobinterview: "Entretien d'embauche",

            login: "Se connecter",
            logout:"Se déconnecter",
           
            quiz: 'Questionnaire',

            signup: "S'inscrire",
           
            translation:'Traduction',
            templates: 'Notes',
            tests: "TESTS",

            writing:"Chat",
        },

        quiz: {
            navbartitle: "Questionnaire:",
            reset: "Réinitialiser",
            somethingwrong:"Quelque chose s'est mal passé. Veuillez réessayer.",
            note:'Prêt pour un quiz ? Entrez un sujet pour commencer.',
        },

        signup: {
            answer:"Réponse",
           
            buttonsignup: "S'inscrire",

            noemail:"'utilisateur avec cet e-mail n'existe pas.",

            signup: "S'inscrire",
            signuptext: "Vous recevrez 10000 crédits gratuits lors de votre inscription.",

            securityquestions:"Questions de sécurité",
            securityquestion:"Question de sécurité:",
           
           
            placeholderemail: "votreemail@exemple.com",
            placeholderconfirmemail: "Confirmez l'email",
            placeholderpassword: "Mot de passe",
            placeholderconfirmpassword: "Confirmez le mot de passe",

            question_1:"Quel est le nom de jeune fille de votre mère ?",
            question_2:"Quel est le nom de la ville où vous êtes né(e) ?",
        },

        status: {
            accountcreated: 'Votre compte a été créé. Vous disposez de 10000 crédits gratuits à utiliser.',
            addcredits: 'Veuillez ajouter des crédits.',
            attachfile: 'Joindre un fichier texte',  
            attachmaxthreefiles: "Jusqu'à trois fichiers peuvent être joints.",

            copy:'Copier',

            deletetopic: 'Voulez-vous supprimer le sujet',
            deepseeknotsupported: 'Cette page ne prend pas en charge le modèle DeepSeek.',

            enteraname: "Veuillez entrer un nom.",
            emailverification: "Veuillez entrer un code de sécurité envoyé à votre adresse e-mail. Si vous ne le voyez pas, vérifiez votre adresse e-mail ou consultez votre dossier Spam.",
            enteratext: 'Veuillez entrer un texte.',
            emailmismatch: 'Incompatibilité de l\'email.',
            enteratextandsubmit: 'Entrez un texte et soumettez.',
            exampletext1: 'Utilisez ceci comme exemple pour "discuter" avec n\'importe quelle personne célèbre.',
            exampletext2: 'Cet exemple vous montre comment créer un e-mail.',
            exampletext3: 'Cet exemple montre comment commencer à rédiger un article ou un document de n\'importe quel type.',
            exampletext4: 'Utilisez ceci comme exemple pour obtenir des conseils sur divers sujets.',
            exampletext5: 'Utilisez ceci comme exemple pour commencer une conversation.',
            exampletext6: 'Cet exemple montre comment créer une histoire. Suivez cet exemple pour créer vos histoires.',
            
            exampletext8: 'Entrez un texte et cliquez sur Soumettre. Utilisez la page AI Tutor pour vous préparer à un entretien et tester vos connaissances sur n\'importe quel sujet.',
            exampletext9: 'Entrez une suggestion et cliquez sur Soumettre pour tout type d\'e-mails.',
            exampletext10: 'Entrez une suggestion et soumettez.',

           
            exampletext19: 'Créer et enregistrer des invites personnalisées (Invites) pour des tâches répétitives.',

            exampletext20: 'Envoyez pour créer un e-mail.',
            exampletext21: 'Envoyez pour obtenir une évaluation.',
            exampletext22: 'Envoyez pour voir un résultat.',
            exampletext23: 'Envoyez pour générer un rapport.',
            entersecuritycode: "Veuillez entrer le code de sécurité.",

            footertext1: 'DedaAI utilise l\'algorithme ChatGPT fourni par ',
            footertext2: 'Toutes les conditions d\'utilisation sont définies par ',
            footertext3: 'la politique',

            globalsearch: 'Rechercher sur le web',

            invalidemail: "Email invalide.",
            invalidconfirmemail: "Confirmation de l'email invalide.",
            invalidsecuritycode: 'Code de sécurité invalide.',
            invalidanswer:"Réponse invalide.",

            loginfailed: 'Échec de la connexion.',

            notopictosave: 'Il n\'y a aucun sujet à enregistrer.',
            namenotdefined: 'Le nom n\'est pas défini.',
            noresponsetosave: 'Il n\'y a aucune réponse à enregistrer.',
            noemail: 'L’utilisateur avec cet email n’existe pas.',

            passwordmismatch: 'Incompatibilité du mot de passe.',
            passwordlength: "Le mot de passe doit comporter au moins 8 caractères alphanumériques.",
            pleaselogin: 'Veuillez vous connecter.',
            providetopic: 'Veuillez fournir un sujet.',
            provideanswer: 'Veuillez fournir une réponse.',
            promptempty: 'La suggestion est vide.',
            pleaseselectlanguage: 'Veuillez sélectionner une langue.',

            responsetype: 'Type de réponse',

            selectmodel: "Sélectionner le modèle d'IA",
            selectmodelnote: "Remarque : En raison de la sortie fréquente de nouveaux modèles d'IA, la liste des modèles pris en charge peut changer.",
            selectlanguage: 'Sélectionnez la langue, entrez un texte et soumettez-le.',
            signupsuccess: 'Vous vous êtes inscrit avec succès à DedaAI. Vous avez 5 000 crédits gratuits à utiliser.'  
        },

        templates: {
            add: 'Ajouter une note',
            notes: 'Notes',
            responses: 'Réponses',
            notesandresponses: "Notes et réponses",
            dialognewprompt: 'Nouvelle note',
            dialogupdateprompt: 'Mettre à jour la note',


            addtooltip : 'Ajouter une note',
            previewtooltip : 'Aperçu des notes',
                        
            createtemplate:'Ajouter des notes', 
            createtemplatetooltip: 'Construisez votre séquence : Ajoutez des notes une par une. Sauvegardez votre travail : Cliquez sur "Archive" pour enregistrer la séquence finale.',

            addprompt: 'Ajouter une prompt',
            addprompt_label1: "Titre,qui,quoi,etc...",
            addprompt_label2: "Description, faits, etc...",
            clearall: "Effacer",
            credits: 'Crédits:',
            close: 'Fermer',

            delete: 'Supprimer',

            newpromptempty: "Please, enter data.",
          
            navbartitle: "Remarques :",
            navbarsave: 'Enregistrer',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Sujets enregistrés',

            navbarvariations: 'Créativité de réponse',
            promptplaceholder:'Demandez-moi à propos de ...',
            navbartext1: "Créez une séquence logique de notes mettant en évidence les faits clés. Il s'agit d'une approche modulaire pour organiser votre travail autour de l'IA.",
            navbartext2: "Éliminez l'écriture de longues prompts en divisant la tâche en faits, description, quoi, qui, etc., et en les ajoutant individuellement en tant qu'étapes à l'aide de 'Créer une prompt'.",
            navbartext3: "Enregistrez le modèle et utilisez-le à nouveau avec un ensemble de données différent. Cela élimine la nécessité d'écrire de longues prompts de manière répétée.",
            navbartext4: "Exemple: Disons qu'il y a cinq clients avec des préférences différentes. Vous pouvez créer un modèle d'e-mail pour chaque client et modifier uniquement les faits à chaque fois que vous devez envoyer un e-mail.",
            navbartext5: "Regardez les exemples de la page d'accueil et utilisez-les comme point de départ.",
            navbartext6: "Utilisez la créativité de réponse pour obtenir des variations dans les réponses de l'IA.",
           
            responselanguage:"Envoyez-moi une réponse en ",

            hide: 'Masquer',
            hideprompttext: "La dernière étape doit être une invite qui s'appliquera au contexte du modèle.",
           
            hideprompt: 'Masquer la prompt',
            preview: 'Aperçu',
            
            placeholderwho:'Titre, qui, quoi, etc ...',
            placeholderwhat: 'Description, faits, etc ...',

            showprompt: "Afficher l'invite",
            showprompttext: "L'invite s'appliquera au contexte du modèle.",
            update: 'Mise à jour',
         
            whowarning: "Veuillez ajouter 'Titre, qui, quoi, etc ...'",
            whatwarning:"'Description, faits, ...' est vide. Voulez-vous le laisser vide ?",
           
        },

        templatesamples: {
            templatesamples: 'Exemples de modèles',
            prepareameeting: 'Préparer une réunion',
            writeareport:'Rédiger un rapport',
            performancereview:'Évaluation de performance',
            email: 'Email',
            travelexpense: 'Frais de voyage',

        },
        translation: {
            clearall: "Effacer",
            credits: 'Crédits',
            summary: 'Résumé',
            reversesummary: 'Inversé',
            navbartitle: "Traduction:",
            navbarsave: 'Enregistrer',
            navbarsavedtitles: 'Sujets',
            navbarsaveplaceholder: 'Enregistrer sous ...',
            translateto: 'Traduire en: ',
            
            navbarvariations: 'Créativité de réponse',
            promptplaceholder:'Tapez un texte à traduire ...',
            navbartext1: 'Sélectionnez une langue, saisissez un texte à traduire et soumettez.',
            navbartext2: "n raison des limitations de l'IA concernant la quantité de texte pouvant être traitée à la fois, divisez les grands textes en paragraphes ou en chapitres et traduisez-les un par un.",
            navbartext3: 'Enregistrez votre travail et continuez à tout moment.',
          
            showprompts: 'Afficher les indications',
            hideprompts: 'Masquer les indications',
        },

        tutor: {
            askquestion:'Question',

            clearall: "Effacer",
            credits: 'Crédits',
           
            navbartitle: "Tuteur:",
            navbarsave: 'Enregistrer',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Sujets enregistrés',
            navbarlanguage:"Langue: ",

            navbarvariations: 'Créativité des réponses',
            
            navbartext1: 'Apprenez ou testez vos connaissances sur n\'importe quel sujet. Entrez un sujet, cliquez sur \'Question\', fournissez une réponse et soumettez.',            
            navbartext2: 'Enregistrez votre conversation. Revoyez-la ou continuez à tout moment.',
            navbartext3: 'Utilisez la créativité des réponses pour obtenir des variations dans les réponses de l\'IA.',
            
            note: 'Veuillez entrer un sujet et cliquer sur "Question". Après cela, fournissez votre réponse et soumettez-la.',
            promptplaceholder:'Tapez une réponse ...',
            responselanguage:"Envoyez-moi une réponse en .",

            tutortema: 'Sujet',
            question: 'Question ?',

            sametopic: "Il y a déjà un sujet avec ce nom. Voulez-vous l'écraser?",
            samplemessage: 'Sélectionnez n\'importe quel sujet, cliquez sur "Question ?" et soumettez une réponse.'
        },

    },

    Portuguese: {
        aitest: {
            accept: 'Aceitar',
            account: 'Minha Conta',
            accountcapital: 'CONTA',
            active: 'Em uso',
            activated: "Ativado ligado/desligado",
            activity: 'Conta',
            alltestssubtitle: 'Todos os Testes',
            addfreetestdialog: "Você quer adicionar teste gratuito",
            //accountverification: "Verificar identidade",
            accountverificationtext: "Certifique-se de que sua verificação de identidade esteja completa. A conta não será válida sem isso.",
            areas: 'Área de teste: ',
            
            buytestdialog: "Voulez-vous acheter le test",
            buytest: 'Acheter',
            buytestfree: 'Gratuit',
            boughttest: "Vous venez d'acheter le test",
            by: 'par',

            cancel: 'Cancelar',
            changeaccount:"Nova Conta",
            changeaccounttext: "Você já possui a conta de pagamento. Se deseja alterá-la, você precisa criar uma nova conta.",
            createaccount: 'Criar Conta',
            createaccounttext: "Se você planeja vender seus testes, primeiro deve criar uma conta para receber pagamentos.",
            createaccountbutton: 'Criar Conta',
            createaccounttitle: 'Criar Conta',
            creatorname: 'Autor',
            createtest:'Criar Teste',
            createtesttitle: 'CRIAR TESTE',
            choosetesttitle:'TESTES GERAIS',
            cannotbepurchased: 'Este teste não pode ser comprado.',
            collegetests:'Testes de Estudo para Faculdade',

            dialogquestion: "Pergunta:",
            dialoganswer_1: "Resposta 1:",
            dialoganswer_2: "Resposta 2:",
            dialoganswer_3: "Resposta 3:",
            dialogmodifytest: 'Modificar teste',
            dialogupdate: 'Atualizar',
            description: 'Descrição:',
            descriptionprompt: 'Adicionar descrição do teste',

            expired: 'Expirado',

            free: 'Grátis',
            freevspaidtest: "Testes Gratuitos ou Pagos",

            generatesubtopics: 'Gerar subtópicos',  
            generatequestions: 'Gerar perguntas',

            howtocreatetest: "Como criar um teste",

            language: 'Idioma: ',
            login: 'Por favor faça login.',

            moreanswertitle: "Mais sobre ...",
            mytests: 'Meus Testes',
            mytestalert: 'Este teste foi criado por você e não pode ser comprado.',

            navbartitle: "Teste:",
            newsubtopics: "Você quer criar novos subtópicos a partir de um contexto dado?",
            notactive: "Não está em uso",
            notactivated: "Não ativado",
            nocreatornametosave: "Nome do autor está em falta.",
            nodescriptiontosave: "Descrição está em falta.",
            noareatosave: 'Área de teste está ausente.',

            opentest: 'Selecionar um Teste',

            paidtestwarning: 'Este é um teste pago e estará disponível para compra. A DedaAI irá cobrar 12% de cada venda como taxa para custos de processamento de pagamento. Você deseja ativar este teste?',
            placeholdergeneratetestid: 'ID do Teste',
            placeholderopentest: 'ID do Teste',
            problemsavingfile: "Houve um problema ao salvar o arquivo.",
            prompttestname: 'Nome do Teste',
            previewquestions: "Este é um teste de pré-visualização pago e apenas as cinco primeiras perguntas são exibidas.", 
            purchasedtests:'Testes Comprados',

            questions: 'Perguntas:',
            questionsbutton: 'Perguntas',
            questionslimit: "Você atingiu o número máximo de perguntas permitidas para este teste.",
            
            resettooltip: "Resposta de reset",
            reetanswer: "Você quer redefinir as respostas?",

            sameauthor: "Outro autor com o mesmo nome já existe. Por favor, escolha outro nome.",
            sametestname: "Há outro teste com o mesmo nome de outro autor e não pode ser atualizado.",
            savetestname: 'Nome do Teste',
            savedtests:'Meus Testes',
            savetest: 'Salvar Teste',
            save: 'Salvar',
            savechosentest: "Você quer salvar suas respostas?",
            saveanswers: "Salvar",
            selecttest:'Testes Gerais',
            selecttestarea: 'Selecione uma área de teste',
            selecttestlanguage: 'Selecione um idioma de teste',
            selectedtestinfo: 'Você selecionou o seguinte teste para compra:',
            showcontext: 'Contexto',
            somethingwentwrong: 'Algo deu errado. Por favor, tente novamente.',
            subtopics: 'Subtópicos',
            startreceivingpayments: "Crie uma conta para começar a receber pagamentos.",
            subtopicssubtext: 'Os subtópicos são gerados a partir do contexto e ajudarão na criação de perguntas mais detalhadas.',

            test: "Nota do teste:",
            testid: 'Gerar ID de teste',
            testname: 'Nome do teste',
            testexists: ' já está na lista de testes escolhidos.',
            topic: 'Contexto:',
            testprice: 'Preço: $',
            tests:'Testes:',
            totalearnings: 'Total de ganhos: $',
            topicplaceholder: 'Digite um contexto e prossiga com "Questões"',
            transfermoney: 'Transferir Dinheiro',
            transactions: 'Transações',
            transfermoneybutton: 'Transferir',
            testarea: 'área: ',
            testlanguage: 'idioma: ',
            text1: 'Clique no subtópico para selecioná-lo.',
            text2: 'O teste não utilizado não possui compras ou todas as compras expiraram. Este teste pode ser excluído.',
            text3: "O teste deve ser ativado para se tornar disponível para uso. Durante a criação, o teste NÃO ESTÁ ATIVO e não está disponível para uso. Quando você estiver satisfeito com seu conteúdo, torne-o público ativando a caixa de seleção.",
            text4: 'Crie um teste com a ajuda da IA. Insira um contexto, clique em "Gerar Perguntas" e a IA gerará perguntas com respostas. Edite perguntas e respostas conforme necessário. Quando o teste estiver pronto, ative-o para se tornar público.',
            text8: 'Escolha o teste ',
            text9: 'Criar teste ',
            text10: "Prepare testes usando nossa plataforma de testes para ajudar alunos, funcionários e amigos com seus exames e avaliações. Envolva e desafie seus alunos, funcionários ou amigos com testes bem elaborados.",
            text11: "Você deseja comprar o teste ",
            text12: "Você poderá usá-lo por 6 meses a partir de hoje.",
            text13: "Venda seus testes e monetize seu conhecimento e experiência. Ganhe enquanto ajuda a comunidade a expandir seu conhecimento. Envolva e desafie seus alunos, funcionários ou amigos com testes bem elaborados.",
            text14: "Encontre os testes que melhor atendem às suas necessidades na preparação para exames e avaliações. Aprofunde seu aprendizado expandindo as respostas corretas e aprimorando sua compreensão de cada tópico. Comece sua jornada para o sucesso hoje e eleve seu conhecimento.",
            text15: "Este teste foi criado por você e não pode ser selecionado.",
            text17: "Este teste será apagado. Deseja continuar apagando este teste?",
            text18: " Deseja ativar este teste para torná-lo público?",
            text19: "Deseja desativar este teste?",
            text21: "O teste não pode ser editado enquanto estiver no estado ATIVO (em uso).",
            text22: "As perguntas são geradas três de cada vez. As respostas corretas são colocadas aleatoriamente. Você pode mudar um contexto antes que as próximas perguntas sejam criadas para obter perguntas mais específicas sobre um contexto.",
            text23: "O teste expirou e não pode ser exibido.",
            text24: "O contexto deve ser fornecido antes de gerar subtópicos.",
            text25: "Deseja gerar subtópicos a partir de um contexto fornecido?",
            text26: 'Este é um teste pago. O teste não pode ser ativado porque você não criou uma conta para aceitar pagamentos. Por favor, crie uma conta clicando em "Conta."',
            text27: "Este é um teste pago e estará disponível para compra. A DedaAI cobrará 18% do preço de compra como taxa e para custos de processamento de pagamento. Você deseja ativar este teste?",
            text30: 'Obtenha vantagem competitiva',
            text31: "Esteja na vanguarda dos avanços em IA, desbloqueie novas oportunidades, impulsione a inovação e supere os concorrentes na entrega de soluções inteligentes que atendem às demandas do mundo digital de hoje.",
            text32: 'Soluções personalizadas que atendem às necessidades do seu negócio',
            text33: 'Fornecemos soluções especificamente adaptadas para atender às necessidades únicas do seu negócio e perfeitamente alinhadas com seus requisitos e objetivos.',
            text34: 'Desenvolvimento de estratégia de IA, análise de dados e modelagem',
            text35: 'Com nossa proficiência em desenvolvimento de estratégia de IA, análise de dados e modelagem, oferecemos uma abordagem holística para ajudar as organizações a aproveitar o poder da inteligência artificial, otimizar seus processos orientados por dados e impulsionar a inovação em seus respectivos setores.',
            text36: 'IA na tomada de decisões orientadas por dados',
            text37: 'Temos compreensão das tecnologias de inteligência artificial e sua aplicação na análise e interpretação de grandes conjuntos de dados para tomar decisões informadas. Isso envolve aproveitar algoritmos e técnicas de IA para extrair insights valiosos, identificar padrões e prever resultados que podem impulsionar processos de tomada de decisão eficazes.',
            text38: 'Vender testes',
            text40: 'Selecione um Contexto:',
            text41: '"O botão Gerar Subtópicos" gerará subtópicos relacionados ao contexto. Selecione um subtópico de cada vez e clique em "Gerar Perguntas" para criar perguntas relacionadas.',
            text42: 'Você pode oferecer seus testes gratuitamente ou pode vender seus testes e monetizar seu conhecimento e expertise. Para cada teste vendido, a DedaAI cobrará uma taxa de transação e manutenção de 12%.',
            text43: 'Se você criar testes pagos, deve criar uma conta para começar a coletar pagamentos.',      

            updatetest: "Queres atualizar o teu teste ",
            userexists: 'Usuário já existe.',

            viewallquestions: "Ver Todos",

            waitonresponse: 'Aguardando resposta...',
              
        },
        assistant: {
            clearall: "Limpar",
            credits: 'Créditos',
            contextconversation: "A conversa está dentro de um contexto.",

            summary: 'Resumo',
            reversesummary: 'Reverso',
            navbartitle_1: "Copilot:",
            navbartitle_2: "Chat:",
            navbarsave: 'Salvar',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Tópicos salvos',

            navbarvariations: 'Criatividade de resposta',
            promptplaceholder:'Pergunte-me sobre...',
            navbartext1: 'O chat acompanha o contexto e mantém perfeitamente o fluxo da sua conversa.',
            navbartext2: 'Use o botão \'Resumo\' para resumir uma conversa longa.',
            navbartext3: 'Use o botão \'Limpar\' para iniciar uma nova conversa com um novo contexto.',
            navbartext4: 'Use \'Criatividade de resposta\' para obter mais variações nas respostas de IA.',
            note: 'A conversa está dentro de um contexto. Cada nova resposta está relacionada às respostas anteriores.',

            summaryprompt: 'Remova as perguntas e resuma o texto a seguir:',
            responselanguage:"Envie-me uma resposta em.",
            conversationlanguage:'Esta conversa está em ',
            whatisthetopic: 'Qual é o tópico no seguinte texto:',
            relatedquestions: "Dê uma resposta no seguinte formato: '@@@Tópico: '. Dê-me três perguntas relacionadas à instrução. Adicione o prefixo '@@@' a cada pergunta e não mostre números de sequência e o prefixo 'Pergunta'.",
            related: 'Relacionado',
            summarizetext: 'Resuma o seguinte texto:',
           
        },

        betterresponses: {
            navbartitle: 'Respostas Multi-AI:',
            note: 'Esta página combina diferentes respostas de modelos de IA e fornece a melhor resposta. Consome mais créditos e leva mais tempo para fornecer uma resposta. Cada resposta é independente de perguntas e respostas anteriores.',

            waitonresponse_1: 'Passo 1 de 3: Obtendo respostas...',
            waitonresponse_2: 'Passo 2 de 3: Preparando resposta...',
            waitonresponse_3: 'Passo 3 de 3: Finalizando resposta...',
           
        },

        compareai: {
            navbartitle: 'Comparar Modelos de IA:',
        },

        comprehensiveresponses: {
            cleardata: "Os dados serão apagados. Deseja continuar?",
            navbartitle: 'Minha Biblioteca:',
            displaymodenormal: 'Padrão',
            displaymodedetailed: 'Detalhado',
            displaymodecomprehensive: 'Abrangente',
           
            prepareresponse: 'Preparando resposta...',
            prepareresponse_1: 'Por favor, aguarde enquanto preparamos nossa resposta.',
            note: 'Esta página fornece informações contextuais detalhadas, úteis para criar documentos, artigos, trabalhos, histórias e muito mais.',
            note_1: 'Obtenha a melhor resposta de IA comparando e combinando resultados de vários modelos de IA nesta página.',
            
            sendrequest: 'Enviar pedido',
            showresponse: 'Mostrar',
            hideresponse: 'Esconder',
            sendrequestagain: 'Enviar pedido novamente',
            minimumcredits: 'É necessário um saldo mínimo de 3.000 créditos para gerar uma resposta detalhada.'
        },

        common: {
            clearall: "Limpar",
            credits: 'Créditos',
            contextconversation: "A conversa está fora de contexto.",

            deletedefaultprompt:'Este é um prompt padrão e não pode ser excluído.',
            dialoglabel_1: 'Nome:',
            dialoglabel_2: 'Prompt:',
            dialogadd: 'Adicionar',
            dialogdelete: "Você quer deletar ",
            dialogdefaultpromptedit: "Este é um prompt padrão e não pode ser editado.",
            dialogdefaultpromptdelete: "Este é um prompt padrão e não pode ser deletado.",
            dialogupdate: 'Atualizar',
            dialogsamename: "Um prompt com o mesmo nome já existe.",
            dialogtitle: 'Prompt personalizado',
            dialogeditprompt: 'Edite o nome e o prompt, e salve como um atalho.',
            dialogaddprompt: 'Insira o nome e o prompt, e salve como um atalho.',
            dialogupdateprompt: "Você quer atualizar o prompt?",
            summary: 'Resumo',
            reversesummary: 'Reverso',
            navbartitle: "Comum:",
            navbartopic: 'Arquivo',
            navbarsave: 'Salvar',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Tópicos salvos',

            navbarvariations: 'Criatividade da resposta',
            promptplaceholder:'Pergunte-me sobre ...',
            navbartext1: 'Crie atalhos para prompts utilizados com frequência.',
            navbartext2: 'Esta página não mantém o contexto. Cada resposta está diretamente relacionada à pergunta feita e não está relacionada a perguntas anteriores. Ela usa menos créditos do que a página do Assistente.',
            navbartext3: 'Use Criatividade de resposta para obter variações nas respostas de IA.',
            note: "Esta página consome menos créditos. Cada nova resposta é independente de perguntas e respostas anteriores.",
        
            conversationlanguage:'Esta conversa está em ',
            responselanguage:"Envie uma resposta em ",

            shortcuts: 'Comandos',
            shortcutgrammar: 'Gramática',
            shortcutkeywords: 'Palavras-chave',
            shortcutsummary: 'Resumo',
            shortcutcompact: 'Compacto',
            shortcutstory: 'Escrever uma história',
            shortcutimprove: 'Melhorar',
            shortcutemail: 'E-mail',
            shortcutdescription: 'Descrever',

            promptgrammar: 'Corrija a gramática do seguinte texto: ',
            promptkeywords: 'Extraia as palavras-chave mais importantes do seguinte texto: ',
            promptsummary: 'Faça um resumo do seguinte texto: ',
            promptcompact: 'Compacte o seguinte texto: ',
            promptstory: 'Escreva a história sobre: ',
            promptimprove: 'Melhore o seguinte texto: ',
            promptemail: 'Escreva um e-mail sobre: ',
            promptdescription: 'Escreva uma descrição de: ',
           
        },

        contactus: {
            title: 'Entre em contato',
            subtitle1: "Conte-nos sobre sua experiência com o DedaAI e sugira melhorias e novos recursos.",
            subtitle2: "Entre em contato conosco sobre suas necessidades de negócios e a DedaAI o ajudará com soluções.",
            placeholdername: 'Nome',
            placeholdercompanyname: 'Nome da empresa',
            placeholderemail: 'E-mail',
            placeholdersubject: 'Assunto',
            placeholdertext: 'Texto',
            buttonsend: 'Enviar',

        },

        copilot: {
           navbartext1: 'O Copilot ajuda você a encontrar respostas e explorar seu tópico escolhido de forma mais profunda.',
           navbartext2: "Use 'Criatividade na resposta' para obter mais variações nas respostas da IA.",       
           nota: 'Cada resposta inclui sugestões para exploração adicional.'
        },

        credits: {
            creditlimit:'O número máximo de créditos é 400 000. Se adicionar mais, você excederá o limite.',

            title: 'Obter créditos',
            text1: 'Nenhuma assinatura necessária. Pague apenas pelas palavras que você usa. Se precisar de créditos, adicione mais.',
            text2: 'Pagamento único de $7.99',
            text3: '100000 créditos (~300 páginas de texto).',
            text5: 'Você tem',
            text6: 'créditos disponíveis.',
            text7: '*Os pagamentos não são reembolsáveis.',

            text12: 'Pagamento único de $12,99',
            text13: '200.000 créditos (~600 páginas de texto).',

            paymenttext1: 'Pagamento único de $7,99',
            paymenttext2: 'Pagamento único de $12,99',
            creditstext1: '100.000 créditos (~300 páginas de texto)',
            creditstext2: '200.000 créditos (~600 páginas de texto)',
            buttontext1: 'Continuar com o pagamento de $7,99',
            buttontext2: 'Continuar com o pagamento de $12,99',
            taxtext: '( +10% de imposto )',

        },
        creditssuccess: {
            thankyou: 'Obrigado pelo seu pagamento.',
            totalcredits: 'Total de créditos disponíveis: ',
        },

        dialog: {
            cleardata: 'Você deseja limpar os dados?',
            cleartemplatedata: 'Você deseja limpar os dados do modelo?',
            clearresponse: 'Você deseja limpar os dados de resposta?',
            deletetemplatestep: 'Você deseja excluir esta etapa?',
            yes: 'Sim',
            cancel: 'Cancelar',
            ok: 'Ok',
        },

        documentanalysis: {
            
            attachfile:'Anexar arquivo',

            fileexists: 'Um arquivo com este nome já foi adicionado.', 
            filesizeoverlimit: 'O tamanho total dos arquivos excede o limite de 20 MB.', 
            filenotsupported: 'Arquivos deste tipo não são suportados.', 
            filenotattached: 'Por favor, anexe o arquivo para a pesquisa.',
            filesmaxnumber: 'Você pode anexar até três arquivos.',

            navbartitle_2: "Pesquisa de Documentos:",
            navbarsavedtitles: 'Tópicos',

            navbartext1: 'Anexe documentos TXT, PDF e DOCS.',   
            navbartext2: "Se os documentos estiverem anexados, o prompt se aplicará ao seu conteúdo.",
            navbartext3: 'Use o botão \'Limpar\' para iniciar uma nova conversa com um novo contexto.',
            note: 'Anexe documentos TXT, PDF e DOCS. O prompt será aplicado ao conteúdo dos documentos.',
        
            preparefile: 'Preparando um arquivo...',  
            preparefiletext: 'Pode levar mais tempo dependendo do tamanho do arquivo.'
        },

        general: {
            accept: 'Aceitar',
            cancel: 'Cancelar',
            delete: 'Excluir',
            searchname: 'Nome',
            searchauthor: 'Autor'
        },

        home: {

            art: "Arte",
            assistant: "Assistente",
            advicetitle: "Conselho",
            advice: "Obtenha conselhos do DedaAI sobre vários tópicos e explore mais pedindo ao DedaAI por assistência adicional.",

            boughtcredits: 'Comprando créditos...',
            businesssolutions: "Soluções Empresariais",

            chatgeneralcopilotheader: 'Chat, Copiloto e Geral',  
            chatgeneralcopilottext: 'Converse com a IA. A conversa ocorre dentro de um contexto, com cada nova resposta relacionada às anteriores.',  
            chatgeneralcopilottext_1: 'Converse com a IA, crie prompts personalizados e reutilize-os. Esta página consome menos créditos. Cada resposta é independente das respostas anteriores.',  
            chatgeneralcopilottext_2: 'Cada resposta da IA contém até 5 prompts relacionados para expandir ainda mais as respostas.',  
            chatchat: 'Chat: ',  
            chatgeneral: 'Geral: ',  
            chatcopilot: 'Copiloto: ',
            country: "País",
            common: "Comum",
            commontext: "Melhore sua escrita evitando instruções longas e utilizando atalhos para tarefas comuns.",
            compacttitle: "Compactar o texto",
            compact: "Reduza o comprimento do texto. Remova informações desnecessárias ou redundantes, simplifique frases e otimize a estrutura geral, mantendo seu significado e clareza.",
            customversion: "A personalização total está disponível. Entre em contato com DedaAI para mais informações.",
            compareaiheader: "Comparar modelos de IA e selecionar a melhor resposta.",
            compareaitext: "Os modelos diferem nas respostas. Escolha entre os modelos de IA e selecione a melhor resposta.",
         
           
            comprehensiveresponsesheader: 'Minha Biblioteca',  
            comprehensiveresponsestext_tooltip: 'Crie uma biblioteca personalizada com base em seus interesses. Colete e salve informações detalhadas sobre uma ampla gama de temas, desde ciência e arte até história, natureza e assuntos do dia a dia.',  
            comprehensiveresponsestext_1: 'Crie uma biblioteca personalizada com base em seus interesses. Colete e salve informações detalhadas sobre uma ampla gama de temas, desde ciência e arte até história, natureza e assuntos do dia a dia. Experimente os seguintes exemplos:',  
            comprehensiveresponsestext1: '- Abrir um pequeno negócio',  
            comprehensiveresponsestext1_1: 'Estrutura jurídica, planos de negócios, licenciamento e estratégias de marketing...',  
            comprehensiveresponsestext2: '- Escrever um romance sobre o tigre na selva',  
            comprehensiveresponsestext2_1: 'Geração de ideias e esboço, redação, revisão, publicação...',  
            comprehensiveresponsestext3: '- Napoleão',  
            comprehensiveresponsestext3_1: 'Vida inicial, ascensão ao poder, campanhas militares, reformas políticas...',  
            comprehensiveresponsestext4: '- Um artigo sobre a exploração da Lua',  
            comprehensiveresponsestext4_1: 'Formulação de uma pergunta de pesquisa, identificação e acesso a fontes, avaliação da credibilidade das fontes, métodos adequados de citação, síntese das informações em um argumento coerente.',  
            comprehensiveresponsestext5: '- Espanha nos séculos XV - XVI',  
            comprehensiveresponsestext5_1: 'Unificação, monarquia, inquisição, explorações...',  
            comprehensiveresponsestext6: '- Viajar internacionalmente',  
            comprehensiveresponsestext6_1: 'Um guia detalhado cobriria as ferramentas necessárias, precauções de segurança, instruções passo a passo...',
            
            documentanalysisheader: 'Pesquisa de Documentos',
            documentanalysistext: 'Anexe vários documentos e pesquise-os e analise-os. Encontre respostas e extraia tópicos.',
            descriptiontitle: "Fornecer uma descrição",
            description: "Forneça uma descrição de um item com base nas informações fornecidas. Especifique fatos ou propriedades de um item e deixe o DedaAI fazer o resto do trabalho.",

            examples: "Exemplos",
            emailstitle: "E-mails e conversas por e-mail",
            emails: "Crie e-mails personalizados para clientes individuais usando nossa Ferramenta de Modelo. Crie um modelo para cada cliente com suas preferências, atualize com fatos relevantes e deixe o AI gerar um e-mail para você. Use nossa página Comum para resumir longas conversas por e-mail.",

            famousperson: "Pessoa famosa",
            famouspersontitle: "Conversar com uma pessoa famosa",
            famouspersonchat: "Engaje-se em conversas com figuras históricas e aprenda sobre elas por meio de experiências interativas de aprendizado.",
            features1: 'Pesquisa de Documentos',
            features_1: 'Anexe arquivos TXT, PDF e DOC e pesquise neles por dados importantes.',
            features2: 'TESTES na Educação',
            features_2: 'Uma plataforma intuitiva para professores, alunos e pais criarem testes com facilidade.',
            features3: 'Estratégias de Trading',
            features_3: 'Crie estratégias de trading usando dados históricos do mercado de ações.',
            features4: 'Notas',
            features_4: 'Organize seus dados em notas e consulte-os com facilidade. Utilize os DedaAITemplates® para gerar modelos para qualquer tarefa sem esforço. Evite tarefas repetitivas organizando seu trabalho com modelos.',
            features5: 'Criar Artigos',
            features_5: 'Construa uma biblioteca personalizada com base nos seus interesses. Colete e salve informações detalhadas sobre uma ampla gama de tópicos, desde ciência e arte até história, natureza e assuntos do cotidiano.',
            features6: 'Pesquisar Bancos de Dados',
            features_6: 'Pesquise bancos de dados usando seu idioma nativo.',
            features7: 'Suporte ao cliente',
            features_7: 'Suporte ao cliente automatizado via chatbots com tecnologia de IA.',

            grammartitle: "Verificar a gramática",
            grammar: "Verifique e corrija a gramática do texto fornecido.",   

            history: "História",

            introduction: "Introdução",
            introductiontext1:'',
            interviewtitle: "Preparar para uma entrevista",
            interview:"Pergunte ao DedaAI como se preparar efetivamente para uma entrevista e antecipe os tipos de perguntas que podem ser feitas.",
            improvetitle: "Melhorar o texto",
            improve: "Faça melhorias para aprimorar a qualidade, clareza, coerência e eficácia do texto.",
               
            knowledge: "Teste seu conhecimento",
            keywordstitle: "Encontrar as palavras-chave",
            keywords: "Identifique e extraia as palavras ou frases mais significativas e relevantes que capturam as principais ideias, temas ou conceitos do texto.",

            meetingtitle: "Preparar uma reunião",
            meeting: "Melhore sua preparação para reuniões criando esboços claros e concisos e expandindo cada um com detalhes adicionais para cada tópico.",
            moto: "Seu Negócio, Nossas Soluções em IA",

            performancereviewtitle: "Avaliação de desempenho",
            performancereview:"Como gerente, se você tem a tarefa de escrever avaliações de desempenho de final de ano, agilize o processo criando um modelo para cada funcionário usando nossa Ferramenta de Modelo.",
            presentationtitle: "Apresentação",
            presentation: "Prepare-se para uma apresentação. Além de fazer perguntas, forneça ao DedaAi todas as informações adicionais ou contexto relacionado ao tópico da sua apresentação. Isso permitirá que o DedaAi ofereça respostas mais personalizadas e precisas, melhorando a qualidade geral da sua preparação.",
            programming: "Programação",

            reporttitle: "Relatório",
            report: "Escreva um relatório usando nossa Ferramenta de Modelo. Crie modelos para diferentes tipos de relatórios e reutilize-os apenas alterando os fatos.",
                
            storytitle: "Escrever uma história", 
            science: "Ciência",
            summarytitle: "Resumir o texto",
            summary:"Forneça uma visão geral concisa e condensada das principais ideias, pontos-chave e detalhes significativos dentro de um determinado texto. Isso envolve capturar as informações essenciais e apresentá-las de forma resumida, sem incluir detalhes desnecessários ou irrelevantes.",  
                
            translationtitle: "Tradução",
            translation: "Traduza documentos, artigos, relatórios, etc. usando nossa página de Tradução.",
            testheader: 'Testes',
            testtitle:'Criar teste',
            testtext: "Testes para ajudar os estudantes a estudar na faculdade.",
            texthome1: 'Construímos soluções de inteligência artificial de modelos de código aberto personalizáveis, ajustados com precisão, privados e portáteis.',
            texthome2: 'Somos uma Plataforma de IA Multimodal',
            texthome3: 'Oferecemos as seguintes soluções personalizadas',
            textompareaimodels: 'Comparar Modelos de IA',
            textcomprehensiveresponses: 'Respostas Abrangentes',
            textassistant: 'Chat',
            textcommon: 'Comum',
            texttranslations: 'Traduções',
            texttemplates: 'Notas',
            texttests: 'Testes de Estudo Universitário',
            textcopilot: 'Copiloto',
            texttutor: 'Tutor',
            textquiz: 'Questionário',
            textdocumentanalysis: 'Pesquisa de Documentos',
            templatesamplesintro:"Utilize os modelos DedaAITemplates® para gerar facilmente modelos para qualquer tarefa. Evite tarefas repetitivas organizando seu trabalho com modelos.",
             
            textmultiairesponses: 'Combina respostas de diferentes modelos de IA e fornece a melhor resposta.',
            textgeneral: 'Use para perguntas gerais fora de um contexto específico. Cada resposta é independente de interações anteriores. Usa menos créditos.',
            textcopilotdescription: 'Use o Copilot para expandir respostas. Cada resposta vem com sugestões para exploração adicional.',
            textchatdescription: 'Converse com a IA sobre vários tópicos, mantendo o contexto durante toda a conversa.',
            texttranslationdescription: 'Traduza texto para vários idiomas.',
            texttutordescription: 'Aprenda interagindo com a IA por meio de perguntas e respostas.',

            textjobinterview: 'Entrevista de emprego',
            testjobinterviewdescription: 'Prepare-se para o seu novo emprego praticando perguntas comuns de entrevista para ganhar confiança e melhorar as suas respostas.',
            textstocks: 'Estratégias de Negociação de Ações',
            textstocksdescription: 'Crie estratégias de negociação de ações e encontre oportunidades de compra com a ajuda da IA.',

            vacationtitle: "Férias",
            vacation: "Deixe o DedaAI lhe dar algumas ideias para as suas próximas férias.",
                
            writeastory: "Aproveite o poder da sua imaginação criando uma narrativa emocionante com detalhes de enredo específicos e deixe o DedaAI dar vida a ela.",
            
            },

        introduction: {
            introduction: "Introdução",
            text1: "DedaAI oferece ferramentas para facilitar sua interação com o ChatGPT.",
            text2: "ChatGPT é um algoritmo de IA que ajuda você a pesquisar, aprender e escrever com a ajuda da IA.",
            text3: "NÃO É A INTERNET. Não pode responder perguntas como \"Qual é o clima de hoje?\". Pense nele como alguém que leu MUITOS livros, acumulou uma vasta quantidade de conhecimento e pode ajudá-lo de muitas maneiras.",
            text4: "Explore com a DedaAI.",
            text5: "DedaAI oferece o seguinte:",

            text6: "DedaAITemplates®:",
            text7: "Nossa ferramenta proprietária para criação de modelos reutilizáveis para qualquer tipo de trabalho.",
            text8: "Assistente:",
            text9: "Página interativa que mantém sua conversa com a IA dentro de um contexto.",
            text10: "Comum:",

            text11: "Página projetada para perguntas aleatórias em que cada pergunta e resposta é independente das perguntas anteriores. Possui teclas aceleradas para as tarefas mais comuns.",
            text12: "Tradução:",
            text13: "Fornece tradução de texto sem digitação excessiva de prompts. Basta selecionar um idioma e fornecer um texto.",
            text14: "Tutor",
            text15: "Aprenda e teste seu conhecimento sobre qualquer tópico interagindo com a IA.",
        },

        jobinterview:
        {
            cleardata: "Os dados serão apagados. Você quer continuar?",
            note: "Por favor, insira suas habilidades e experiência, depois envie.",
            of: "de",
            preparing: "Preparando",
            promptplaceholder : 'Adicionar educação, experiência e habilidades.',
            navbartext1: "Por favor, forneça uma visão geral breve de sua experiência, habilidades, proficiência e áreas de especialização, e então envie. Com base nas suas informações, você receberá várias áreas-chave de foco junto com perguntas de entrevista relacionadas. Você pode expandir cada pergunta para gerar respostas mais detalhadas e perspicazes.",  
            navbartext2: "Use esta página para se preparar para qualquer entrevista, conversa ou discussão.",  
            navbartext3: "Salve perguntas para revisá-las a qualquer momento.",

            save: "Salvar",
            navbartitle_2: "Entrevista de Emprego:",
            waitontopics: "Aguardando os tópicos da entrevista de emprego...",

        },

        login: {
            answernotcorrect:'A resposta não está correta.',

                buttonlogin: 'Entrar',
                buttonlogout: 'Sair',

                forgotpassword: 'Esqueceu a senha?',

                nvalidemail: 'Email inválido.',
                invalidanswer: 'Resposta inválida.',
                newpassword:'Por favor, crie uma nova senha',

                logoutlabel: "Por favor, clique em Sair.",
                logintext: 'Você está logado agora. Por favor, prossiga com nossa página inicial.',
                logouttext: 'Você foi desconectado.',
                loginsuccess: 'Você fez login com sucesso.',

                placeholderemail: 'seuemail@email.com',
                placeholderpassword: 'Senha',
                passwordchanged:'Sua senha foi alterada.',
                provideanswer: 'Por favor, forneça uma resposta.',

                signup: 'cadastre-se',
                submit: "Enviar",

                titlelogin: 'Login',
                titlelogout: 'Logout',
                text: 'Se você não tem uma conta, por favor ',

                wrongpassword: 'A senha deve ter pelo menos 8 caracteres alfanuméricos.',

                userexists: 'Usuário com o mesmo email já existe!',

        },

        mainmenu: {
            aboutus: "Sobre nós",
            assistant: 'Copilot',

            betterresponses: 'Respostas Multi-AI',

            common: "Comum",
            credits:"Créditos",
            contactus: "Contate-nos",
            compareai: 'Comparar Modelos de IA',
            comprehensiveresponses: 'MINHA BIBLIOTECA',

            documentanalysis: 'Pesquisa de Documentos',

            home: "Início",

            jobinterview:'Entrevista de emprego',

            login: "Entrar",
            logout:"Sair",
           
            quiz: "Questionário",

            signup: 'Cadastre-se',
        
            translation:'Tradução',
            templates: 'Notas',
            tests: "TESTES",

            writing:"Chat",

        },

        quiz: {
            navbartitle: "Questionário:",
            reset: "Reiniciar",
            somethingwrong:"Algo deu errado. Por favor, tente novamente.allge",
            note:'Pronto para um questionário? Digite um tópico para começar.'
        },

        signup: {
            answer:"Resposta",

            buttonsignup: "Cadastre-se",

            noemail:'Usuário com este e-mail não existe.',

            signup: "Cadastre-se",
            signuptext: "Você receberá 10000 créditos gratuitos ao se cadastrar.",
            securityquestions:"Perguntas de segurança",
            securityquestion:"Pergunta de segurança:",
          
            placeholderemail: "seuemail@exemplo.com",
            placeholderconfirmemail: "Confirmar email",
            placeholderpassword: "Senha",
            placeholderconfirmpassword: "Confirmar senha",

            question_1:"Qual é o sobrenome de solteira da sua mãe?",
            question_2:"Qual é o nome da cidade onde você nasceu?"
        },

        status: {
            accountcreated: 'Sua conta foi criada. Você tem 10000 créditos gratuitos para usar.',
            addcredits: 'Por favor, adicione créditos.',
            attachfile: 'Anexar arquivo de texto',
            attachmaxthreefiles: 'Até três arquivos podem ser anexados.',

            copy:'Copiar',

            deletetopic: 'Você quer deletar o tópico',
            deepseeknotsupported: 'Esta página não suporta o modelo DeepSeek.',

            emailmismatch: 'Email não corresponde.',
            emailverification: "Por favor, insira um código de segurança enviado para o seu endereço de e-mail. Se você não o vê, verifique novamente seu endereço de e-mail ou procure na pasta de Spam.",
            enteraname: "Por favor, digite um nome.",
            enteratext: 'Por favor, digite um texto.',
            enteratextandsubmit: 'Digite um texto e envie.',
            entersecuritycode: "Por favor, insira o código de segurança.",
            exampletext1: 'Use isso como um exemplo para "conversar" com qualquer pessoa famosa.',
            exampletext10: 'Digite um prompt e envie.',
            exampletext19: 'Crie e salve prompts personalizados (Prompts) para tarefas repetitivas.',
            exampletext2: 'Este exemplo mostra como criar um email.',
            exampletext20: 'Enviar para criar um email.',
            exampletext21: 'Enviar para obter uma revisão.',
            exampletext22: 'Enviar para ver um resultado.',
            exampletext23: 'Enviar para gerar um relatório.',
            exampletext3: 'Este exemplo mostra como começar a escrever um artigo ou um documento de qualquer tipo.',
            exampletext4: 'Use isso como um exemplo para obter conselhos sobre vários tópicos.',
            exampletext5: 'Use isso como um exemplo de como iniciar uma conversa.',
            exampletext6: 'Este exemplo mostra como criar uma história. Siga este exemplo para criar suas histórias.',
            exampletext8: 'Digite um texto e clique em Enviar. Use a página AI Tutor para se preparar para uma entrevista e testar seu conhecimento sobre qualquer tópico.',
            exampletext9: 'Digite um prompt e clique em Enviar para qualquer tipo de emails.',

            footertext1: 'DedaAI está usando o algoritmo ChatGPT fornecido por ',
            footertext2: ' Todos os termos de uso são definidos por ',
            footertext3: 'política',

            globalsearch: 'Pesquisar na web',

            invalidanswer: "Resposta inválida.",
            invalidconfirmemail: "Confirmação de email inválida.",
            invalidemail: "Email inválido.",
            invalidsecuritycode: 'Código de segurança inválido.',

            loginfailed: 'Falha ao fazer login.',

            namenotdefined: 'Nome não definido.',
            noemail: 'Usuário com este email não existe.',
            noresponsetosave: 'Não há respostas para salvar.',
            notopictosave: 'Não há tópico para salvar.',

            passwordlength: "A senha deve ter no mínimo 8 caracteres alfanuméricos.",
            passwordmismatch: 'Senha não corresponde.',
            pleaselogin: 'Por favor, faça login.',
            pleaseselectlanguage: 'Por favor, selecione um idioma.',
            provideanswer: 'Por favor, forneça uma resposta.',
            providetopic: 'Por favor, forneça um tópico.',
            promptempty: 'O prompt está vazio.',

            responsetype: 'Tipo de resposta',

            selectlanguage: 'Selecione o idioma, digite um texto e envie.',
            selectmodel: "Selecionar Modelo de IA",
            selectmodelnote: 'Nota: Devido ao lançamento frequente de novos módulos de IA, a lista de módulos suportados pode mudar.',
            signupsuccess: 'Você se registrou com sucesso no DedaAI. Você tem 2.500 créditos gratuitos para usar.',

        },

        templates: {
            add: 'Adicionar nota',
            notes: 'Notas',
            responses: 'Respostas',
            notesandresponses: "Notas e respostas",
            dialognewprompt: 'Nova nota',
            dialogupdateprompt: 'Atualizar nota',
            
            
            
            createtemplate:'Adicionar notas', 
            createtemplatetooltip: 'Construa sua sequência: Adicione notas uma por uma. Salve seu trabalho: Clique em "Arquivo" para armazenar a sequência final.',
            addprompt: 'Adicionar prompt',
            addprompt_label1: "Título, quem, o que, etc...",
            addprompt_label2: "Descrição, fatos, etc...",
            clearall: "Limpar",
            credits: 'Créditos:',
            close: 'Fechar',

            delete: 'Excluir',
          
            navbartitle: "Notas:",
            navbarsave: 'Salvar',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Tópicos salvos',

            navbarvariations: 'Criatividade na resposta',
            promptplaceholder:'Pergunte-me sobre ...',
            navbartext1: 'Crie uma sequência lógica de anotações destacando os fatos principais. Esta é uma abordagem modular para organizar seu trabalho em torno da IA.',
            navbartext2: 'Elimine a escrita de prompts longos dividindo a tarefa em fatos, descrição, o que, quem, etc., e adicione-os individualmente como etapas usando "Criar prompt".',
            navbartext3: 'Salve o modelo e use-o novamente com um conjunto diferente de dados. Isso elimina a necessidade de escrever prompts longos repetidamente.',
            navbartext4: 'Exemplo: Digamos que existam cinco clientes com preferências diferentes. Você pode criar um modelo de email para cada cliente e modificar apenas os fatos sempre que precisar enviar um email.',
            navbartext5: 'Veja exemplos na página inicial e use-os como ponto de partida.',
            navbartext6: 'Use a Criatividade na resposta para obter variações nas respostas da IA.',
           
            responselanguage:"Envie-me uma resposta em ",

         
            hide: 'Esconder',
            hideprompt: 'Ocultar prompt',
            hideprompttext: 'A última etapa deve ser um prompt que será aplicado ao contexto do template.',
            
            preview: 'Visualizar',
            
            placeholderwho:'Título, quem, o que, etc ...',
            placeholderwhat: 'Descrição, fatos, etc ...',

            showprompt: 'Mostrar prompt',
            showprompttext: 'O prompt será aplicado ao contexto do template.',  

            update: 'Atualizar',
         
            whowarning: "Por favor, adicione 'Título, quem, o que, etc ...'",
            whatwarning:"'Descrição, fatos, ...' está vazio. Deseja deixá-lo vazio?",
            
           
        },

        templatesamples: {
            templatesamples: 'Exemplos de Modelo',
            prepareameeting: 'Preparar uma reunião',
            writeareport:'Escrever um relatório',
            performancereview:'Avaliação de desempenho',
            email: 'Email',
            travelexpense: 'Despesas de viagem',

        },

        translation: {
            clearall: "Limpar",
            credits: 'Créditos',
            summary: 'Resumo',
            reversesummary: 'Reverso',
            navbartitle: "Tradução:",
            navbarsave: 'Salvar',
            navbarsavedtitles: 'Tópicos salvos',
            navbarsaveplaceholder: 'Salvar como ...',
            translateto: 'Traduzir para: ',
            
            navbarvariations: 'Criatividade de resposta',
            promptplaceholder:'Digite um texto para traduzir ...',
            navbartext1: 'Selecione um idioma, digite um texto para traduzir e envie.',
            navbartext2: 'Devido às limitações da IA em relação à quantidade de texto que pode ser processado de uma vez, divida textos grandes em parágrafos ou capítulos e traduza-os um por um.',
            navbartext3: 'Salve seu trabalho e continue a qualquer momento.',
          
            showprompts: 'Mostrar sugestões',
            hideprompts: 'Ocultar sugestões',
        },
        tutor: {

            askquestion:'Pergunta',

            clearall: "Limpar",
            credits: 'Créditos',
           
            navbartitle: "Tutor:",
            navbarsave: 'Salvar',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Tópicos salvos',
            navbarlanguage:"Idioma: ",

            navbarvariations: 'Criatividade de resposta',
           
            navbartext1: 'Aprenda ou teste seu conhecimento sobre qualquer tópico. Digite um tópico, clique em \'Pergunta\', forneça uma resposta e envie.',
            navbartext2: 'Salve sua conversa. Revise-a ou continue a qualquer momento.',
            navbartext3: 'Use a Criatividade de resposta para obter variações nas respostas da IA.',
            nota: 'Por favor, insira um tópico e clique em "Pergunta." Depois disso, forneça sua resposta e envie-a.',

            promptplaceholder:'Digite uma resposta ...',
            responselanguage:"Envie-me uma resposta em .",

            tutortema: 'Tópico',
            question: 'Pergunta?',

            sametopic: "Já existe um tópico com esse nome. Você deseja sobrescrevê-lo?",
            samplemessage: 'Selecione qualquer tópico, clique em "Pergunta?" e envie uma resposta.'
        }
        
    },

    Spanish: {
        aitest: {
            accept: 'Aceptar',
            account: 'Mi cuenta',
            accountcapital: 'CUENTA',
            active: 'En uso',
            activated: "Activado encendido/apagado",
            activity: 'Cuenta',
            alltestssubtitle: 'Todos los tests',
            addfreetestdialog: "¿Quieres agregar un test gratuito",
            accountverification: "Verificar identidad",
            accountverificationtext: "Asegúrate de que tu verificación de identidad esté completa. La cuenta no será válida sin ella.",
            areas:'Área de prueba: ',  
            
            buytestdialog: "¿Quieres comprar el test",
            buytest: 'Comprar',
            buytestfree: 'Gratis',
            boughttest: 'Acabas de comprar el test',
            by: 'por',

            cancel: 'Cancelar',
            cannotbepurchased: 'Esta prueba no se puede comprar.',
            changeaccount: "Nueva cuenta",
            changeaccounttext: "Ya tienes la cuenta de pago. Si deseas cambiarla, necesitas crear una nueva cuenta.",
            createaccount: 'Crear cuenta',
            createaccounttext: "Si planeas vender tus pruebas, primero debes crear una cuenta para recibir pagos.",
            creatorname: 'Autor',
            createtest:'Crear Prueba',
            createtesttitle: 'CREAR PRUEBA',
            createaccountbutton: 'Crear cuenta',
            createaccounttitle: 'Crear cuenta',
            choosetesttitle:'PRUEBAS GENERALES',
           
            collegetests: 'Pruebas de estudio universitario',

            dialogquestion: "Pregunta:",
            dialoganswer_1: "Respuesta 1:",
            dialoganswer_2: "Respuesta 2:",
            dialoganswer_3: "Respuesta 3:",
            dialogmodifytest: 'Modificar prueba',
            dialogupdate: 'Actualizar',
            description: 'Descripción:',
            descriptionprompt: 'Agregar descripción de la prueba',

            expired: 'Caducado',

            free: 'Gratis',
            freevspaidtest: "Pruebas gratuitas o de pago",

            generatesubtopics: 'Generar subtemas',
            generatequestions: 'Generar preguntas',

            howtocreatetest: "Cómo crear una prueba",

            language: 'Idioma: ',
            login: 'Por favor inicia sesión.',

            moreanswertitle: "Más sobre ...",
            mytests: 'Mis Pruebas',
            mytestalert: 'Esta prueba fue creada por ti y no se puede comprar.',

            navbartitle: "Prueba:",
            newsubtopics: "¿Quieres crear nuevos subtemas a partir de un contexto dado?",
            notactive: "No está en uso",
            notactivated: "No activado",
            nocreatornametosave: "Falta el nombre del autor.",
            nodescriptiontosave: "Falta la descripción.",
            noareatosave:'Falta el área de prueba.',

            opentest: 'Selecciona una prueba',

            paidtestwarning: 'Este es un test de pago y estará disponible para su compra. DedaAI cobrará un 12% de cada venta como tarifa por costos de procesamiento de pagos. ¿Quieres activar este test?',
            placeholdergeneratetestid: 'ID de prueba',
            placeholderopentest: 'ID de prueba',
            problemsavingfile: "Hubo un problema al guardar el archivo.",
            prompttestname: 'Nombre de la prueba',
            previewquestions: "Esta es una vista previa de prueba paga y solo se muestran las primeras cinco preguntas.", 
            purchasedtests:'Pruebas compradas',

            questions: 'Preguntas:',
            questionsbutton: 'Preguntas',
            questionslimit: "Has alcanzado el número máximo de preguntas permitidas para esta prueba.",

            resettooltip: "Restablecer respuestas",
            resetanswers: '¿Quieres restablecer las respuestas?',

            sameauthor: "Ya existe otro autor con el mismo nombre. Por favor, elige otro nombre.",
            sametestname: "Hay otro examen con el mismo nombre de otro autor y no se puede actualizar.",
            savechosentest: "¿Quieres guardar tus respuestas?",
            saveanswers: "Guardar",
            savetestname: 'Nombre de la prueba',
            savedtests:'Mis Pruebas',
            savetest: 'Guardar prueba',
            save: 'Guardar',
            selecttest:'Pruebas Generales',
            selecttestarea:'Selecciona un área de prueba.',
            selecttestlanguage: 'Selecciona un idioma de prueba',
            selectedtestinfo: 'Has seleccionado la siguiente prueba para su compra:',
            somethingwentwrong: 'Algo salió mal. Por favor, inténtalo de nuevo.',
            showcontext: 'Contexto',
            startreceivingpayments: "Crea una cuenta para comenzar a recibir pagos.",
            subtopics: 'Subtemas',
            subtopicssubtext: 'Los subtemas se generan a partir del contexto y ayudarán a crear preguntas más detalladas.',

            test: "Puntuación del examen:",
            testid: 'Generar ID de prueba',
            testname: 'Nombre de la prueba',
            testexists: ' ya está en la lista de pruebas compradas.',
            topic: 'Contexto:',
            testprice: 'Precio: $',
            tests:'Pruebas:',
            totalearnings: 'Total de ganancias: $',
            topicplaceholder: 'Ingrese un contexto y continúe con "Generar Preguntas"',
            transfermoney: 'Transferir dinero',
            transactions: 'Transacciones',
            transfermoneybutton: 'Transferir',
            testarea: 'área: ',  
            testlanguage: 'idioma: ',
            text1: 'Haz clic en el subtópico para seleccionarlo.',
            text2: 'La prueba no utilizada no tiene compras o todas las compras han caducado. Esta prueba se puede eliminar.',
            text3: "La prueba debe ser activada para estar disponible para su uso. Durante la creación, la prueba NO ESTÁ ACTIVA y no está disponible para su uso. Cuando estés satisfecho con su contenido, hazla pública activando la casilla.",
            text4: 'Crea una prueba con la ayuda de IA. Ingresa un contexto, haz clic en "Generar Preguntas" y la IA generará preguntas con respuestas. Edita preguntas y respuestas según sea necesario. Una vez que la prueba esté lista, actívala para hacerla pública.',
            text8: 'Elegir prueba ',
            text9: 'Crear prueba ',
            text10: "Prepara pruebas utilizando nuestra plataforma de pruebas para ayudar a estudiantes, empleados y amigos con sus exámenes y evaluaciones. Involucra y desafía a tus estudiantes, empleados o amigos con pruebas bien diseñadas.",
            text11: "¿Desea comprar la prueba ",
            text12: "Podrá usarla durante 6 meses a partir de hoy.",
            text13: "Vende tus pruebas y monetiza tu conocimiento y experiencia. Gana mientras ayudas a la comunidad a expandir su conocimiento. Involucra y desafía a tus estudiantes, empleados o amigos con pruebas bien diseñadas.",
            text14: "Encuentra las pruebas que mejor se adapten a tus necesidades en la preparación para exámenes y evaluaciones. Profundiza en tu aprendizaje ampliando las respuestas correctas y mejorando tu comprensión de cada tema. Comienza tu camino hacia el éxito hoy y eleva tu conocimiento.",
            text15: "Esta prueba fue creada por usted y no se puede seleccionar.",
            text17: "Este test será eliminado. ¿Desea continuar con la eliminación de este test?",
            text18: " ¿Desea activar esta prueba para hacerla pública?",
            text19: "¿Desea desactivar esta prueba?",
            text21: "La prueba no se puede editar mientras esté en estado ACTIVO (en uso).",
            text22: "Las preguntas se generan de tres en tres. Las respuestas correctas se colocan al azar. Puedes cambiar un contexto antes de que se creen las siguientes preguntas para obtener preguntas más específicas sobre un contexto.",
            text23: "La prueba ha caducado y no se puede mostrar.",
            text24: "Se debe proporcionar un contexto antes de generar subtemas.",
            text25: "¿Desea generar subtemas a partir de un contexto dado?",
            text26: 'Esta es una prueba paga. La prueba no se puede activar porque no creaste una cuenta para aceptar pagos. Por favor, crea una cuenta haciendo clic en "Cuenta".',
            text27: "Este es un test de pago y estará disponible para su compra. DedaAI cobrará el 18% del precio de compra como tarifa y para costos de procesamiento de pagos. ¿Deseas activar este test?",
            text30: 'Obtén una ventaja competitiva',
            text31: 'Estar a la vanguardia de los avances en IA, desbloquear nuevas oportunidades, impulsar la innovación y superar a los competidores en la entrega de soluciones inteligentes que satisfacen las demandas del mundo digital actual.',
            text32: 'Soluciones personalizadas que se adaptan a las necesidades de tu negocio',
            text33: 'Proporcionamos soluciones adaptadas específicamente para satisfacer las necesidades únicas de tu negocio y perfectamente alineadas con tus requisitos y objetivos.',
            text34: 'Desarrollo de estrategias de IA, análisis de datos y modelado',
            text35: 'Con nuestra experiencia en el desarrollo de estrategias de IA, análisis de datos y modelado, ofrecemos un enfoque holístico para ayudar a las organizaciones a aprovechar el poder de la inteligencia artificial, optimizar sus procesos basados en datos e impulsar la innovación en sus respectivas industrias.',
            text36: 'IA en la toma de decisiones basada en datos',
            text37: 'Tenemos un entendimiento de las tecnologías de inteligencia artificial y su aplicación en el análisis e interpretación de grandes conjuntos de datos para tomar decisiones informadas. Esto implica aprovechar algoritmos y técnicas de IA para extraer valiosos conocimientos, identificar patrones y predecir resultados que pueden impulsar procesos de toma de decisiones efectivos.',
            text38: 'Vendre des tests',
            text40: 'Sélectionner un contexte :',
            text41: '"El botón "Generar Subtemas" generará subtemas relacionados con el contexto. Selecciona un subtema uno a la vez y haz clic en "Generar Preguntas" para crear preguntas relacionadas.',
            text42: 'Puedes ofrecer tus pruebas de forma gratuita o puedes vender tus pruebas y monetizar tu conocimiento y experiencia. Por cada prueba vendida, DedaAI cobrará una tarifa de transacción y mantenimiento del 12%.',
            text43: 'Si creas pruebas de pago, debes crear una cuenta para comenzar a recibir pagos.',

            userexists: 'El usuario ya existe.',
            updatetest: "¿Quieres actualizar tu examen ",

            viewallquestions: "Ver todo",
            
            waitonresponse: 'Esperando respuesta...',

        },

        assistant: {
            clearall: "Limpiar",
            credits: 'Créditos',
            contextconversation: "La conversación se desarrolla dentro de un contexto.",
            summary: 'Resumen',
            reversesummary: 'Inverso',
            navbartitle_1: "Copilot:",
            navbartitle_2: "Chat:",
            navbarsave: 'Guardar',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Temas guardados',

            navbarvariations: 'Creatividad de respuestas',
            promptplaceholder:'Pregúntame sobre ...',
            navbartext1: 'Chat realiza un seguimiento del contexto y mantiene sin problemas el flujo de tu conversación.',
            navbartext2: 'Usa el botón \'Resumen\' para resumir una conversación larga.',
            navbartext3: 'Usa el botón \'Limpiar\' para comenzar una nueva conversación con un nuevo contexto.',
            navbartext4: 'Usa \'Creatividad de respuestas\' para obtener más variaciones en las respuestas de IA.',
            note: "La conversación se desarrolla dentro de un contexto. Cada nueva respuesta está relacionada con las respuestas anteriores.",
            summaryprompt: 'Elimina las preguntas y resume el siguiente texto:',
            responselanguage:"Envíame una respuesta en.",
            conversationlanguage:'Esta conversación está en',
            whatisthetopic: '¿Cuál es el tema en lo siguiente?:',
            relatedquestions: "¿Puede proporcionar una respuesta en el siguiente formato: '@@@Tema: '? ¿Cuáles son tres preguntas relacionadas con la indicación? Agregue el prefijo '@@@' a cada pregunta y no muestre números de secuencia ni el prefijo 'Pregunta'.",
            related: 'Relacionado',
            summarizetext: 'Resumir el siguiente texto:',
        },

        betterresponses: {
            navbartitle: 'Respuestas Multi-AI:',
            note: 'Esta página combina diferentes respuestas de modelos de IA y proporciona la mejor respuesta. Consume más créditos y toma más tiempo para proporcionar una respuesta. Cada respuesta es independiente de preguntas y respuestas anteriores.',

            waitonresponse_1: 'Paso 1 de 3: Obteniendo respuestas...',
            waitonresponse_2: 'Paso 2 de 3: Preparando respuesta...',
            waitonresponse_3: 'Paso 3 de 3: Finalizando respuesta...',
            
        },

        common: {
            clearall: "Borrar",
            credits: 'Créditos',
            contextconversation: "La conversación está fuera de contexto.",

            deletedefaultprompt:'Este es un mensaje predeterminado y no se puede eliminar.',
            dialoglabel_1: 'Nombre:',
            dialoglabel_2: 'Indicación:',
            dialogadd: 'Agregar',
            dialogdelete: "¿Quieres eliminar ",
            dialogdefaultpromptedit: "Esta es una indicación predeterminada y no se puede editar.",
            dialogdefaultpromptdelete: "Esta es una indicación predeterminada y no se puede eliminar.",
            dialogupdate: 'Actualizar',
            dialogsamename: "Ya existe una indicación con el mismo nombre.",
            dialogtitle: 'Indicación personalizada',
            dialogeditprompt: 'Edita el nombre y la indicación, y guárdalo como un acceso directo.',
            dialogaddprompt: 'Ingresa el nombre y la indicación, y guárdalo como un acceso directo.',
            dialogupdateprompt: "¿Quieres actualizar la indicación?",

            summary: 'Resumen',
            reversesummary: 'Inverso',
            navbartitle: "Común:",
            navbartopic: 'Archivo',
            navbarsave: 'Guardar',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Temas guardados',

            navbarvariations: 'Creatividad de respuesta',
            promptplaceholder:'Pregúntame sobre...',
            navbartext1: 'Crea accesos directos para los mensajes que usas con frecuencia.',
            navbartext2: 'Esta página no mantiene el contexto. Cada respuesta está directamente relacionada con la pregunta realizada y no está relacionada con preguntas anteriores. Utiliza menos créditos que la página de Asistente.',
            navbartext3: 'Utiliza la Creatividad de respuesta para obtener variaciones en las respuestas de IA.',
            note: 'Esta página consume menos créditos. Cada nueva respuesta es independiente de las preguntas y respuestas anteriores.',
        
            conversationlanguage:'Esta conversación está en ',
            responselanguage:"Envíame una respuesta en ",

            shortcuts: 'Indicaciones',
            shortcutgrammar: 'Gramática',
            shortcutkeywords: 'Palabras clave',
            shortcutsummary: 'Resumen',
            shortcutcompact: 'Compacto',
            shortcutstory: 'Escribe una historia',
            shortcutimprove: 'Mejorar',
            shortcutemail: 'Correo electrónico',
            shortcutdescription: 'Describir',

            promptgrammar: 'Corrige la gramática del siguiente texto: ',
            promptkeywords: 'Extrae las palabras clave más importantes del siguiente texto: ',
            promptsummary: 'Haz un resumen del siguiente texto: ',
            promptcompact: 'Compacta el siguiente texto: ',
            promptstory: 'Escribe la historia sobre: ',
            promptimprove: 'Mejora el siguiente texto: ',
            promptemail: 'Escribe un correo electrónico sobre: ',
            promptdescription: 'Escribe una descripción de: ',
           
        },

        compareai:
        {
            navbartitle: 'Comparar modelos de IA:',
        },

        comprehensiveresponses: {
                cleardata: "Los datos se borrarán. ¿Quieres continuar?",
                navbartitle: 'Mi Biblioteca:',
                displaymodenormal: 'Estándar',
                displaymodedetailed: 'Detallado',
                displaymodecomprehensive: 'Comprensivo',
               
                prepareresponse: 'Preparando respuesta...',
                prepareresponse_1: 'Por favor, espere mientras preparamos nuestra respuesta.',
                note: 'Esta página proporciona información contextual detallada, útil para crear documentos, artículos, trabajos, historias y más.',
                note_1: 'Obtenga la mejor respuesta de IA comparando y combinando resultados de múltiples modelos de IA en esta página.',
               
                sendrequest: 'Enviar solicitud',
                showresponse: 'Mostrar',
                hideresponse: 'Ocultar',
                sendrequestagain: 'Enviar solicitud de nuevo',
                minimumcredits: 'Se requiere un saldo mínimo de 3,000 créditos para generar una respuesta detallada.'
            },

        contactus: {
            title: 'Contáctenos',
            subtitle1: "Cuéntanos sobre tu experiencia con DedaAI y sugiere mejoras y nuevas características.",
            subtitle2: "Contáctenos sobre las necesidades de su negocio y DedaAI le ayudará con soluciones.",
            placeholdername: 'Nombre',
            placeholdercompanyname: 'Nombre de la empresa',
            placeholderemail: 'Correo electrónico',
            placeholdersubject: 'Asunto',
            placeholdertext: 'Texto',
            buttonsend: 'Enviar',

        },

        copilot: {
          navbartext1: 'Copilot te ayuda a encontrar respuestas y explorar tu tema elegido más a fondo.',
          navbartext2: "Utiliza 'Creatividad en las respuestas' para obtener más variaciones en las respuestas de la IA.",
        
          note:'Cada respuesta incluye sugerencias para una exploración adicional.'
        
        },

        credits: {
           

            creditlimit:'El número máximo de créditos es 400 000. Si añades más, estarás por encima del límite.',

            title: 'Obtener créditos',
            text1: 'No se requiere suscripción. Pague solo por las palabras que use. Si necesita créditos, simplemente agregue más.',
            text2: 'Pago único de $7.99',
            text3: '100000 créditos (~300 páginas de texto).',
           
           
            text5: 'Tiene',
            text6: 'créditos disponibles.',
            text7: '*Los pagos no son reembolsables.',

            text12: '$12.99 pago único',
            text13: '200 000 créditos (~600 páginas de texto).',

            paymenttext1: '$7.99 pago único',
            paymenttext2: '$12.99 pago único',
            creditstext1: '100 000 créditos (~300 páginas de texto)',
            creditstext2: '200 000 créditos (~600 páginas de texto)',
            buttontext1: 'Continuar con el pago de $7.99',
            buttontext2: 'Continuar con el pago de $12.99',
            taxtext: '( +10% de impuestos )',

        },
        creditssuccess: {
            thankyou: 'Gracias por su pago.',
            totalcredits: 'Créditos totales disponibles: ',
        },

        dialog: {
            cleardata: '¿Desea borrar los datos?',
            cleartemplatedata: '¿Desea borrar los datos de la plantilla?',
            clearresponse: '¿Desea borrar los datos de la respuesta?',
            deletetemplatestep: '¿Quieres eliminar este paso?',
            yes: 'Sí',
            cancel: 'Cancelar',
            ok: 'Aceptar',
        },

        documentanalysis: {  

            attachfile:'Adjuntar archivo',

            fileexists: 'Ya se ha añadido un archivo con este nombre.',
            filesizeoverlimit: 'El tamaño total de los archivos supera el límite de 20 MB.', 
            filenotsupported: 'Archivos de este tipo no son compatibles.', 
            filenotattached: 'Por favor, adjunta el archivo para la búsqueda.',
            filesmaxnumber:'Puedes adjuntar hasta tres archivos.',

            navbartitle_2: "Búsqueda de Documentos:",
            navbarsavedtitles: 'Temas',

            navbartext1: 'Adjunte documentos TXT, PDF y DOCS.',   
            navbartext2: "Si los documentos están adjuntos, el aviso se aplicará a su contenido.",
            navbartext3: 'Utiliza el botón \'Limpiar\' para comenzar una nueva conversación con un nuevo contexto.',
            note: 'Adjunte documentos TXT, PDF y DOCS. La instrucción se aplicará al contenido de los documentos.',
        
            preparefile: 'Preparando un archivo...',  
            preparefiletext: 'Puede tardar más dependiendo del tamaño del archivo.'
        
        },

        general: {
            accept: 'Aceptar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            searchname: 'Nombre',
            searchauthor: 'Autor',
        },

        home: {
            assistant: "Asistente",
            advicetitle: "Consejo",
            advice: "Obtenga consejos de DedaAI sobre diversos temas y explore más solicitando la ayuda adicional de DedaAI.",
            art: "Arte",

            boughtcredits: 'Comprando créditos...',
            businesssolutions: "Soluciones empresariales",

            chatgeneralcopilotheader: 'Chat, Copiloto y General',
            chatgeneralcopilottext: 'Chatea con IA. La conversación se desarrolla dentro de un contexto, con cada nueva respuesta relacionada con las anteriores.',
            chatgeneralcopilottext_1: 'Chatea con IA, crea indicaciones personalizadas y úsalas nuevamente. Esta página usa menos créditos. Cada respuesta es independiente de las respuestas anteriores.',
            chatgeneralcopilottext_2: 'Cada respuesta de la IA contiene hasta 5 indicaciones relacionadas para ampliar aún más las respuestas.',
            chatchat: 'Chat: ',
            chatgeneral: 'General: ',
            chatcopilot: 'Copiloto: ',
            compareaiheader: "Comparar modelos de IA y seleccionar la mejor respuesta",
            compareaitext: "Los modelos difieren en sus respuestas. Elige entre modelos de IA y selecciona la mejor respuesta.",
           
            comprehensiveresponsesheader: 'Mi Biblioteca',  
            comprehensiveresponsestext_tooltip: 'Crea una biblioteca personalizada según tus intereses. Recopila y guarda información detallada sobre una amplia variedad de temas, desde ciencia y arte hasta historia, naturaleza y temas cotidianos.',  
            comprehensiveresponsestext_1: 'Crea una biblioteca personalizada según tus intereses. Recopila y guarda información detallada sobre una amplia variedad de temas, desde ciencia y arte hasta historia, naturaleza y temas cotidianos. Prueba los siguientes ejemplos:',  
            comprehensiveresponsestext1: '- Iniciar un pequeño negocio',  
            comprehensiveresponsestext1_1: 'Estructura legal, planes de negocio, licencias y estrategias de marketing...',  
            comprehensiveresponsestext2: '- Escribir una novela sobre el tigre en la jungla',  
            comprehensiveresponsestext2_1: 'Lluvia de ideas y esquema, redacción, edición, publicación...',  
            comprehensiveresponsestext3: '- Napoleón',  
            comprehensiveresponsestext3_1: 'Vida temprana, ascenso al poder, campañas militares, reformas políticas...',  
            comprehensiveresponsestext4: '- Un artículo sobre la exploración de la Luna',  
            comprehensiveresponsestext4_1: 'Formulación de una pregunta de investigación, identificación y acceso a fuentes, evaluación de la credibilidad de las fuentes, métodos adecuados de citación, síntesis de la información en un argumento coherente.',  
            comprehensiveresponsestext5: '- España siglos XV - XVI',  
            comprehensiveresponsestext5_1: 'Unificación, monarquía, inquisición, exploraciones...',  
            comprehensiveresponsestext6: '- Viajar internacionalmente',  
            comprehensiveresponsestext6_1: 'Una guía detallada cubriría las herramientas necesarias, precauciones de seguridad, instrucciones paso a paso...',

            country: "País",
            common: "Común",
            commontext: "Mejore su escritura evitando prompsts largos y utilizando atajos para tareas comunes.",
            compacttitle: "Compactar el texto",
            compact: "Reduzca la longitud del texto. Elimine información innecesaria o redundante, simplifique las oraciones y optimice la estructura general manteniendo su significado y claridad.",
            customversion: "La personalización completa está disponible. Contacta a DedaAI para obtener más información.",
            
            documentanalysisheader: 'Búsqueda de Documentos',
            documentanalysistext: 'Adjunta múltiples documentos y búscalos y analízalos. Encuentra respuestas y extrae temas.',
            descriptiontitle: "Proporcionar una descripción",
            description: "Proporcione una descripción de un objeto basada en la información proporcionada. Especifique hechos o propiedades de un objeto y deje que DedaAI haga el resto del trabajo.",
                

            examples: "Ejemplos",
            emailstitle: "Emails y cadenas de correos electrónicos",
            emails: "Cree correos electrónicos personalizados para cada cliente utilizando nuestra Herramienta de Plantillas. Cree una plantilla para cada cliente con sus preferencias, actualícela con datos relevantes y permita que la IA genere un correo electrónico por usted. Utilice nuestra página Common para resumir largas cadenas de correos electrónicos.",

            famousperson: "Persona famosa",
            famouspersontitle: "Charlar con una persona famosa",
            famouspersonchat: "Participe en conversaciones con figuras históricas y conózcalas a través de experiencias de aprendizaje interactivas.",
            features1: 'Búsqueda de Documentos',
            features_1: 'Adjunta archivos TXT, PDF y DOC y búscalos para encontrar datos importantes.',
            features2: 'EXÁMENES en Educación',
            features_2: 'Una plataforma intuitiva para que profesores, maestros, estudiantes y padres diseñen exámenes sin esfuerzo.',
            features3: 'Estrategias de Trading',
            features_3: 'Crea estrategias de trading utilizando datos históricos del mercado de valores.',
            features4: 'Notas',
            features_4: 'Organiza tus datos en notas y consúltalas fácilmente. Utiliza DedaAITemplates® para generar plantillas para cualquier tarea sin esfuerzo. Evita tareas repetitivas organizando tu trabajo con plantillas.',
            features5: 'Crear Artículos',
            features_5: 'Construye una biblioteca personalizada basada en tus intereses. Recopila y guarda información detallada sobre una amplia gama de temas, desde ciencia y arte hasta historia, naturaleza y temas cotidianos.',
            features6: 'Buscar en Bases de Datos',
            features_6: 'Busca en bases de datos usando tu idioma nativo.',
            features7: 'Soporte al cliente',
            features_7: 'Soporte al cliente automatizado mediante chatbots potenciados por IA.',
            
            grammartitle: "Verificar la gramática",
            grammar: "Verifique y corrija la gramática del texto proporcionado.",

            history: "Historia",

            introduction: "Introducción",
            introductiontext1:'',
            interviewtitle: "Prepararse para una entrevista",
            interview:"Pregúntale a DedaAI cómo prepararse efectivamente para una entrevista y anticipar los tipos de preguntas que se pueden hacer.",
            improvetitle: "Mejorar el texto",
            improve: "Realice mejoras para mejorar la calidad, claridad, coherencia y efectividad general del texto.",    
            
            knowledge: "Ponga a prueba sus conocimientos",
            keywordstitle: "Encontrar las palabras clave",
            keywords: "Identifique y extraiga las palabras o frases más significativas y relevantes que capturan las ideas principales, temas o conceptos del texto.",

            moto: "Tu negocio, nuestras soluciones de IA.",
            meetingtitle: "Preparar una reunión",
            meeting: "Mejore la preparación de sus reuniones creando esquemas claros y concisos y expandiéndolos con detalles adicionales para cada tema.",
                  
            performancereviewtitle: "Evaluación de desempeño",
            performancereview:"Si como gerente le han asignado la tarea de escribir evaluaciones de desempeño al final del año, simplifique el proceso creando una plantilla para cada empleado utilizando nuestra Herramienta de Plantillas.",
            presentationtitle: "Presentación",
            presentation: "Prepare una presentación. Además de hacer preguntas, asegúrese de proporcionar a DedaAi cualquier información adicional o contexto relacionado con el tema de su presentación. Esto permitirá que DedaAi ofrezca respuestas más personalizadas y precisas, mejorando la calidad general de su preparación.",  
            programming: "Programación",
            
            reporttitle: "Informe",
            report: "Escriba un informe utilizando nuestra Herramienta de Plantillas. Cree plantillas para diferentes tipos de informes y reutilícelas cambiando solo los datos.",

            storytitle: "Escribir una historia",
            science: "Ciencia",
            summarytitle: "Resumir el texto",
            summary:"Proporcione una descripción concisa y resumida de las ideas principales, puntos clave y detalles significativos dentro de un texto dado. Esto implica capturar la información esencial y presentarla de forma abreviada, sin incluir detalles innecesarios o irrelevantes.",

            testheader: 'Pruebas',
            testtitle:'Crear prueba',
            testtext: "Tests para ayudar a los estudiantes a estudiar en la universidad.",
            texthome1: 'Construimos soluciones de inteligencia artificial de modelos de código abierto personalizables, ajustados con precisión, privados y portátiles.',
            texthome2: 'Somos una Plataforma de IA Multimodal',
            texthome3: 'Ofrecemos las siguientes soluciones personalizadas',
            textompareaimodels: 'Comparar Modelos de IA',
            textcomprehensiveresponses: 'Respuestas Comprensivas',
            textassistant: 'Chat',
            textcommon: 'Común',
            texttranslations: 'Traducciones',
            texttemplates: 'Notas',
            texttests: 'Pruebas de estudio universitario',
            textcopilot: 'Copiloto',
            texttutor: 'Tutor',
            textquiz: 'Cuestionario',
            textdocumentanalysis: 'Búsqueda de Documentos',
            templatesamplesintro: "Utilice DedaAITemplates® para generar fácilmente plantillas para cualquier tarea. Evite tareas repetitivas organizando su trabajo con plantillas.",
            translationtitle: "Traducción",
            translation: "Traduzca documentos, artículos, informes, etc. utilizando nuestra página de Traducción.",
        
            textmultiairesponses: 'Combina respuestas de diferentes modelos de IA y proporciona la mejor respuesta.',
            textgeneral: 'Úsalo para preguntas generales fuera de un contexto específico. Cada respuesta es independiente de interacciones previas. Utiliza menos créditos.',
            textcopilotdescription: 'Usa Copilot para ampliar respuestas. Cada respuesta incluye sugerencias para seguir explorando.',
            textchatdescription: 'Chatea con IA sobre diversos temas manteniendo el contexto a lo largo de la conversación.',
            texttranslationdescription: 'Traduce texto a varios idiomas.',
            texttutordescription: 'Aprende interactuando con IA mediante preguntas y respuestas.',
            textjobinterview: 'Entrevista de trabajo', 
            testjobinterviewdescription: 'Prepárate para tu nuevo trabajo practicando preguntas comunes de entrevista para ganar confianza y mejorar tus respuestas.',
            textstocks: 'Estrategias de Trading de Acciones',
            textstocksdescription: 'Crea estrategias de trading de acciones y encuentra oportunidades de compra con la ayuda de la IA.',

            vacationtitle: "Vacaciones",
            vacation: "Permita que DedaAI le dé algunas ideas para sus próximas vacaciones.",
            
            writeastory: "Aproveche el poder de su imaginación creando una narrativa emocionante con detalles específicos de la trama y permita que DedaAI la haga cobrar vida.",
            
        },
        introduction: {
            introduction: "Introducción",
            text1: "DedaAI te ofrece herramientas para facilitar tu interacción con ChatGPT.",
            text2: "ChatGPT es un algoritmo de IA que te ayuda a buscar, aprender y escribir con la ayuda de la IA.",
            text3: "NO ES INTERNET. No puede responder preguntas como \"¿Cómo está el clima hoy?\". Piensa en él como alguien que ha leído MUCHOS libros, que ha acumulado una vasta cantidad de conocimiento y que puede ayudarte de muchas maneras.",
            text4: "Explora con DedaAI.",
            text5: "DedaAI te ofrece lo siguiente:",

            text6: "DedaAITemplates®:",
            text7: "Nuestra herramienta propietpanisaria para crear plantillas reutilizables para cualquier tipo de trabajo.",
            text8: "Asistente:",
            text9: "Página interactiva que mantiene tu conversación con la IA dentro de un contexto.",
            text10: "Común:",

            text11: "Página diseñada para preguntas aleatorias donde cada pregunta y respuesta es independiente de las preguntas anteriores. Tiene teclas aceleradas para las tareas más comunes.",
            text12: "Traducción:",
            text13: "Proporciona traducción de texto sin escribir excesivamente las indicaciones. Simplemente selecciona un idioma y proporciona un texto.",
            text14: "Tutor",
            text15: "Aprende y prueba tus conocimientos sobre cualquier tema interactuando con la IA.",
        },

        jobinterview:
        {
            cleardata: "Los datos serán borrados. ¿Desea continuar?",

            note: "Por favor, introduzca sus habilidades y experiencia, luego envíe.",
            navbartext1: "Por favor, proporciona un breve resumen de tu experiencia, habilidades, nivel de competencia y áreas de especialización, luego envíalo. Según tu información, recibirás varias áreas clave de enfoque junto con preguntas de entrevista relacionadas. Puedes ampliar cada pregunta para generar respuestas más detalladas y perspicaces.",
            navbartext2: "Usa esta página para prepararte para cualquier entrevista, conversación o discusión.",
            navbartext3: "Guarda las preguntas para revisarlas en cualquier momento.",

            of: "de",

            preparing: "Preparando",
            promptplaceholder : 'Agregar educación, experiencia y habilidades.',

            save: "Guardar",

            navbartitle_2: "Entrevista de trabajo:",

            waitontopics: "Esperando los temas de la entrevista de trabajo...",
        },

        login: {
            answernotcorrect:'La respuesta no es correcta.',

                buttonlogin: 'Iniciar sesión',
                buttonlogout: 'Cerrar sesión',

                forgotpassword: '¿Olvidaste tu contraseña?',

                nvalidemail: 'Correo electrónico no válido.',
                invalidanswer: 'Respuesta no válida.',
                newpassword:'Por favor crea una nueva contraseña',

                logoutlabel: "Por favor haz clic en Cerrar sesión.",
                logintext: 'Ahora estás conectado. Por favor continúa en nuestra página de inicio.',
                logouttext: 'Has cerrado sesión.',
                loginsuccess: 'Has iniciado sesión exitosamente.',

                placeholderemail: 'tucorreo@correo.com',
                placeholderpassword: 'Contraseña',
                passwordchanged:'Tu contraseña ha sido cambiada.',
                provideanswer: 'Por favor proporciona una respuesta.',

                signup: 'regístrate',
                submit: "Enviar",

                titlelogin: 'Iniciar sesión',
                titlelogout: 'Cerrar sesión',
                text: 'Si no tienes una cuenta, por favor ',

                wrongpassword: 'La contraseña debe tener al menos 8 caracteres alfanuméricos.',

                userexists: '¡Ya existe un usuario con el mismo correo electrónico!',
        },

        mainmenu: {
            aboutus: "Acerca de nosotros",
            assistant: 'Copilot',

            betterresponses: 'Respuestas Multi-AI',

            common: "Común",
            compareai: 'Comparar modelos de IA',
            comprehensiveresponses: 'MI BIBLIOTECA',
            credits:"Créditos",
            contactus: "Contáctenos",

            documentanalysis: 'Búsqueda de Documentos',

            home: "Inicio",

            jobinterview: 'Entrevista de trabajo',

            login: "Iniciar sesión",
            logout:"Cerrar sesión",
           
            quiz:"Cuestionario",

            signup: 'Registrarse',
        
            translation:'Traducción',
            templates: 'Notas',
            tests: "PRUEBAS",
            
            writing: "Chat",
          
        },

        quiz: {
            navbartitle: "Cuestionario:",
            reset: "Reiniciar",
            somethingwrong:"Algo salió mal. Por favor, inténtalo de nuevo.",
            note:'¿Listo para un examen? Introduce un tema para comenzar.'
        },

        signup: {
            answer:"Respuesta",

            buttonsignup: "Registrarse",

            noemail:'El usuario con este correo electrónico no existe.',

            signup: "Registrarse",
            signuptext: "Obtendrás 10000 créditos gratis al registrarte.",
            securityquestions:"Preguntas de seguridad",
            securityquestion:"Pregunta de seguridad:",
           

            placeholderemail: "tucorreo@ejemplo.com",
            placeholderconfirmemail: "Confirmar correo",
            placeholderpassword: "Contraseña",
            placeholderconfirmpassword: "Confirmar contraseña",

            question_1:"¿Cuál es el apellido de soltera de tu madre?",
            question_2:"¿Cuál es el nombre de la ciudad donde naciste?"
        },

        status: {
            accountcreated: 'Se ha creado su cuenta. Tiene 10000 créditos gratuitos para usar.',
            addcredits: 'Por favor agregue créditos.',
            attachfile: 'Adjuntar archivo de texto',  
            attachmaxthreefiles: 'Se pueden adjuntar hasta tres archivos.',

            copy:'Copiar',

            deletetopic: '¿Quieres eliminar el tema',
            deepseeknotsupported: 'Esta página no soporta el modelo DeepSeek.',

            enteraname: "Por favor ingrese un nombre.",
            enteratextandsubmit: 'Ingrese un texto y envíe.',
            exampletext1: 'Utilice esto como ejemplo para "chatear" con cualquier persona famosa.',
            exampletext2: 'Este ejemplo muestra cómo crear un correo electrónico.',
            exampletext3: 'Este ejemplo muestra cómo empezar a escribir un artículo o un documento de cualquier tipo.',
            exampletext4: 'Utilice esto como ejemplo para obtener consejos sobre varios temas.',
            exampletext5: 'Utilice esto como ejemplo para iniciar una conversación.',
            exampletext6: 'Este ejemplo muestra cómo crear una historia. Siga este ejemplo para crear sus historias.',
            
            exampletext8: 'Ingrese un texto y haga clic en Enviar. Utilice la página AI Tutor para prepararse para una entrevista y poner a prueba sus conocimientos sobre cualquier tema.',
            exampletext9: 'Ingrese un tema y haga clic en Enviar para cualquier tipo de correos electrónicos.',
            exampletext10: 'Ingrese un tema y envíe.',
            exampletext19: 'Crea y guarda mensajes personalizados (Prompts) para tareas repetitivas.',
            exampletext20: 'Enviar para crear un correo electrónico.',
            exampletext21: 'Enviar para obtener una revisión.',
            exampletext22: 'Enviar para ver un resultado.',
            exampletext23: 'Enviar para generar un informe.',
            emailverification: "Por favor, ingresa un código de seguridad enviado a tu dirección de correo electrónico. Si no lo ves, verifica tu dirección de correo electrónico o busca en tu carpeta de Spam.",
            enteratext: 'Por favor ingrese un texto.',
            emailmismatch: 'Correo electrónico no coincide.',
            entersecuritycode: "Por favor, ingrese el código de seguridad.",

            footertext1: 'DedaAI está utilizando el algoritmo ChatGPT proporcionado por ',
            footertext2: ' Todos los términos de uso están definidos por ',
            footertext3: 'política',

            globalsearch: 'Buscar en la web',

            invalidemail: "Correo electrónico inválido.",
            invalidconfirmemail: "Confirmación de correo electrónico inválida.",
            invalidanswer:"Respuesta inválida.",
            invalidsecuritycode: 'Código de seguridad no válido.',

            loginfailed: 'Inicio de sesión fallido.',

            noresponsetosave: 'No hay respuestas para guardar.',
            notopictosave: 'No hay tema para guardar.',
            namenotdefined: 'El nombre no está definido.',
            noemail: 'El usuario con este correo electrónico no existe.',

            passwordmismatch: 'Contraseña no coincide.',
            passwordlength: "La contraseña debe tener un mínimo de 8 caracteres alfanuméricos.",
            pleaselogin: 'Por favor inicie sesión.',
            providetopic: 'Por favor proporcione un tema.',
            provideanswer: 'Por favor proporcione una respuesta.',
            promptempty: 'El cuadro de texto está vacío.',
            pleaseselectlanguage: 'Por favor, seleccione un idioma.',

            responsetype: 'Tipo de respuesta',

            selectmodel: "Seleccionar modelo de IA",
            selectmodelnote: 'Nota: Debido a la frecuente liberación de nuevos módulos de IA, la lista de módulos soportados puede cambiar.',
            selectlanguage: 'Seleccione el idioma, ingrese un texto y envíelo.',
            signupsuccess: 'Te has registrado exitosamente en DedaAI. Tienes 5,000 créditos gratuitos para usar.'
        },

        templates: {
            add: 'Agregar nota',
            notes: 'Notas',
            responses: 'Respuestas',
            notesandresponses: "Notas y respuestas",
            dialognewprompt: 'Nueva nota',
            dialogupdateprompt: 'Actualizar nota',

            addtooltip: 'Agregar una nota',
            previewtooltip: 'Vista previa de notas',
           
            createtemplate:'Agregar notas', 
            createtemplatetooltip: 'Construye tu secuencia: Agrega notas una por una. Guarda tu trabajo: Haz clic en "Archivo" para almacenar la secuencia final.',
            addprompt: 'Añadir prompt',
            addprompt_label1: "Titre, qui, quoi, etc...",
            addprompt_label2: "Description, faits, etc...",
            clearall: "Borrar",
            credits: 'Créditos:',
            cloe:'Cerrar',

            delete: 'Eliminar',
           
            navbartitle: "Notas:",
            navbarsave: 'Guardar',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Temas guardados',

            navbarvariations: 'Creatividad de respuesta',
            promptplaceholder:'Pregúntame sobre ...',
            navbartext1: 'Crea una secuencia lógica de notas destacando los hechos clave. Este es un enfoque modular para organizar tu trabajo en torno a la IA.',            
            navbartext2: 'Elimine la escritura de largos prompts dividiendo la tarea en hechos, descripción, qué, quién, etc., y añádalos individualmente como pasos usando Crear prompt.',
            navbartext3: 'Guarde la plantilla y úsela de nuevo con un conjunto de datos diferente. Esto elimina la necesidad de escribir largos prompts repetidamente.    ',
            navbartext4: 'Ejemplo: Digamos que hay cinco clientes con diferentes preferencias. Puede crear una plantilla de correo electrónico para cada cliente y modificar solo los hechos cada vez que necesite enviar un correo electrónico.',
            navbartext5: 'Mira ejemplos de la página de inicio y úsalos como punto de partida.',
            navbartext6: 'Utiliza la creatividad de respuesta para obtener variaciones en las respuestas de IA.',
           
            responselanguage:"Envíame una respuesta en ",

            
            hide: 'Ocultar',
            hideprompt: 'Ocultar prompt',
            hideprompttext: 'El último paso debe ser un prompt que se aplicará al contexto de la plantilla.',
           
            preview: 'Vista previa',
            
            placeholderwho:'Título, quién, qué, etc ...',
            placeholderwhat: 'Descripción, hechos, etc ...',

            showprompt: 'Mostrar aviso',
            showpromptext: 'El aviso se aplicará al contexto de la plantilla.',

            update: 'Actualizar',
       
            whowarning: "Por favor añade 'Título, quién, qué, etc ...'",
            whatwarning:"'Descripción, hechos, ...' está vacío. ¿Quieres dejarlo vacío?",
            
           
        },

        templatesamples: {
            templatesamples: 'Ejemplos de plantillas',
            prepareameeting: 'Preparar una reunión',
            writeareport:'Escribir un informe',
            performancereview:'Revisión de desempeño',
            email: 'Correo electrónico',
            travelexpense: 'Gastos de viaje',

        },

        translation: {
            clearall: "Borrar",
            credits: 'Créditos',
            summary: 'Resumen',
            reversesummary: 'Inverso',
            navbartitle: "Traducción:",
            navbarsave: 'Guardar',
            navbarsavedtitles: 'Temas',
            navbarsaveplaceholder: 'Guardar como ...',
            translateto: 'Traducir a: ',
            
            navbarvariations: 'Creatividad de respuesta',
            promptplaceholder:'Escribe un texto para traducir ...',
            navbartext1: 'Selecciona un idioma, escribe un texto para traducir y envía.',
            navbartext2: 'Debido a las limitaciones de la IA en la cantidad de texto que se puede procesar al mismo tiempo, divide el texto largo en párrafos o capítulos y tradúcelos uno por uno.',
            navbartext3: 'Guarda tu trabajo y continúa en cualquier momento.',
          
            showprompts: 'Mostrar sugerencias',
            hideprompts: 'Ocultar sugerencias',
        },

        tutor: {
            askquestion:'Pregunta',

            clearall: "Borrar",
            credits: 'Créditos',
           
            navbartitle: "Tutor:",
            navbarsave: 'Guardar',
            navbarsaveplaceholder: '',
            navbarsavedtitles: 'Temas',
            navbarlanguage:"Idioma: ",
            navbarvariations: 'Creatividad de respuesta',
           
            navbartext1: 'Aprende o prueba tus conocimientos sobre cualquier tema. Ingresa un tema, haz clic en \'Pregunta\', proporciona una respuesta y envía.',            
            navbartext2: 'Guarda tu conversación. Revísala o continúa en cualquier momento.',
            navbartext3: 'Utiliza la Creatividad de respuesta para obtener variaciones en las respuestas de la IA.',

            note: 'Por favor, ingrese un tema y haga clic en "Pregunta". Después de eso, proporcione su respuesta y envíela.',
            promptplaceholder:'Escribe una respuesta ...',
            responselanguage:"Envíame una respuesta en .",

            tutortema: 'Tema',
            question: '¿Pregunta?',
            sametopic: "Ya hay un tema con este nombre. ¿Quieres sobrescribirlo?",
            samplemessage: 'Selecciona cualquier tema, haz clic en "¿Pregunta?" y envía una respuesta.',
        }

    },

    English: {
    
            aitest: {
                accept: 'Accept', 
                account: 'My Account',
                accountcapital: 'ACCOUNT',
                accountverificationtext: "Make sure your identity verification is complete. Account will not be valid without it.",
                active: 'In use',
                activated: "Active on/off",
                activity: 'Account',
                alltestssubtitle: 'All Tests',
                addfreetestdialog: "Do you want to add free test",

                area: 'Area: ',
                areas: 'Test area: ',
                noareatosave: 'Test area is missing.',
 
                buytestdialog: "Do you want to buy the test",
                buytest: 'Buy',
                buytestfree: 'Free',
                boughttest: 'You just bought the test',
                by: 'by',
                buytesttitle: "Buy test",
                buytesttext1: "Test name:",
                buytesttext2: "Price:",
                buytesttext3: "You will be able to use this test for up to six months from today.",
                buytesttext4: "You have purchased test:",

                cancel: 'Cancel',
                changeaccount: "New Account",
                changeaccounttext: "You already have the payment account. If you want to change it, you need to create a new account.",
                creatorname: 'Author',
                createaccount: 'Create Account',
                createaccounttext: "If you plan to sell your tests you must first create an account to receive payments.",
                createaccounttitle: 'Create Account',
                createaccountbutton: 'Create Account',
                createtest:'Create Test',
                createtesttitle: 'CREATE TEST',
                choosetesttitle: 'GENERAL TESTS',
                cannotbepurchased: 'This test cannot be purchased.',

                dialogquestion: "Question:",
                dialoganswer_1: "Answer 1:",
                dialoganswer_2: "Answer 2:",
                dialoganswer_3: "Answer 3:",
                dialogupdate: 'Update',
                description: 'Description:',
                descriptionprompt: 'Add test description',
                dialogmodifytest: 'Modify test',
            
                expired: 'Expired',

                free: 'Free',
                freevspaidtest:" Freee or Paid Tests",

                generatesubtopics: 'Generate subtopics',
                generatequestions: 'Generate questions',

                howtocreatetest: "How to create a test",

                language: 'Language: ',
                login: 'Please login.',

                moreanswertitle: "More about ...", 
                modifytestempty: 'One of the test fields is empty.',
                mytests: 'My Tests',

                mytestalert: 'This test is created by you and cannot be purchased.',

                navbartitle: "Test:",
                newsubtopics: "Do you want to create new subtopics from a given context?",
                notactive: "Not in use",
                notactivated: "Not activated",

                noavailabletests: 'There are no available tests.',
                nocreatornametosave: "Author name is missing.",
                nodescriptiontosave: "Description is missing.",
                nolanguagetosave: 'Test language is missing.',
                noschooltosave: 'School is missing.',

                opentest: 'Select a Test',

                paidtestwarning: 'This is a paid test and will be available for purchase. DedaAI will collect 12% from each sale as a fee for payment processing costs. Do you want to activate this test?',
                placeholdergeneratetestid: 'Test ID',
                placeholderopentest: 'Test ID',
                problemsavingfile: "There was a problem while saving the file.",
                prompttestname: 'Test name',
                previewquestions: "This is a paid test preview and only first five questions are displayed.", 
                purchasedtests: 'Purchased Tests',
                pleaselogin:'Please, login.',

                questions: 'Questions:',
                questionsbutton: 'Questions',
                questionslimit: "You have reached the maximum number of questions allowed for this test.",

                resettooltip: "Reset answers",
                resetanswers: "Would you like to reset your answers?",
                returntotests: 'Return to Tests',

                sameauthor: "Another author with the same name already exists. Please, choose another name.",
                sametestname: "There is another test with the same name by another author and it cannot be updated.",
                savechosentest: "Do you want to save your answers?",
                saveanswers: "Save",
                savetestname: 'Test name',
                savedtests:'My Tests',
                savetest: 'Save Test',
                save: 'Save',
                school: 'Faculty:',
                schoolyear: 'Year of study:',
                selecttest:'General Tests',
                selecttestarea: 'Select a test area',
                selecttestlanguage: 'Select a test language',
                selectedtestinfo: 'You have selected the following test for purchase:',
                selecttestschool: 'Select a school',
                selectschoolwarning: 'Please select a faculty.',
                selecttestschoolyear: 'Select a school year',
                showcontext: 'Context',
                somethingwentwrong: 'Something went wrong. Please try again.',
                startreceivingpayments: "Create an account to start receiving payments.",
                subtopics: 'Subtopics',
                subtopicssubtext: 'Subtopics are generated from the context and will help in creating more detailed questions.',

                test: "Test score:",
                testid: 'Generate Test ID',
                testname: 'Test name',
                testexists: ' is already in the list of purchased tests.',
                topic: 'Context:',
                testprice: 'Price: $',
                topicplaceholder: 'Enter a context and proceed with "Generate questions"',
                totalearnings: 'Total earnings: $',
                transfermoney: 'Transfer Money',
                transactions: 'Transactions',
                transfermoneybutton: 'Transfer',
                testarea: 'area: ',
                testlanguage: 'language: ',
                text1: 'Click on the subtopic to select it.',
                text2: 'Not in use test has no purchases or all purchases have expired. This test can be deleted.',
                text3: "Test must be activated to become available for use. During the creation test is NOT ACTIVE and not available for use.  When you are satisfied with its content make it public by activating check box.",
                text4: 'Create a test with the help of AI. Enter a context, click on "Generate Questions" and AI will generate questons with answers. Edit questions and answers as needed. Once test is ready, activate it to become public.',
                text8: 'General tests',
                text9: 'Create test ',
                text10: "Prepare tests using our testing platform to help students, employees, and friends with their exams and assessments. Engage and challenge your students, employees, or friends with well-designed tests.",
                text11: "Do you want to buy test ",
                text12: "You will be able to use it for 6 months from today.",
                text13: "Sell your tests and monetize your knowledge and expertise. Earn while helping the community expand its knowledge. Engage and challenge your students, employees, or friends with well-designed tests.",
                text14: "Find the tests that best match your needs in preparation for exams and assessments. Dive deeper into your learning by expanding on correct answers and enhancing your understanding of each topic. Start your journey to success today and elevate your knowledge.",
                text15: "This test is created by you and cannot be selected.",
                text17: "This test will be deleted. Continue with deleting this test?",
                text18: " Do you want to activate this test to become public?",
                text19: "Do you want to deactivate this test?",
                text21: "Test cannot be edited while in ACTIVE (in use) state.",
                text22: "Questions are generated three at a time. Correct answers are placed randomly. You may change a context before next questions are created to obtain more specific questions about a context.",
                text23: "Test has expired and cannot be displayed.",
                text24: "Context must be provided prior to generating subtopics.",
                text25: "Do you want to generate subtopics from a given context?",
                text26: 'This is a paid test. The test cannot be activated because you did not create an account to accept payments. Please create an account by clicking on "Account."',
                text27: "This is a paid test and will be available for purchase. DedaAI will collect 18% of the purchase price as a fee and for payment processing costs. Do you want to activate this test?",
                text30: 'Get competitive edge', 
                text31: "Be at the forefront of AI advancements, unlock new opportunities, drive innovation, and outperform competitors in delivering intelligent solutions that meet the demands of today's digitally-driven world.",               
                text32: 'Custom solutions that match your business needs',
                text33: 'We provide solutions tailored specifically to meet the unique needs of your business and perfectly aligned with your requirements and objectives.',
                text34: ' AI strategy development, data analysys and modeling',
                text35: 'With our proficiency in AI strategy development, data analysis, and modeling, we offer a holistic approach to help organizations harness the power of artificial intelligence, optimize their data-driven processes, and drive innovation in their respective industries.',
                text36: 'AI in data-driven decission making',
                text37: 'We have understanding of artificial intelligence technologies and their application in analyzing and interpreting large datasets to make informed decisions. It involves leveraging AI algorithms and techniques to extract valuable insights, identify patterns, and predict outcomes that can drive effective decision-making processes.',
                text38: 'Sell Tests',
                text40: 'Select a Context:',
                text41: '"Generate Subtopics" button will generate subtopics related to the context. Select a subtopic one at a time and click on "Generate Questions" to create  related questions.',
                text42: 'You may offer your tests for free or you may sell your tests and monetize on your knowledge and expertise. For each sold test DedaAI will collect 12% transaction and maintenance fee.',
                text43: 'If you create paid tests you must create an account to start collecting payments.',

                userexists: 'User already exists.',
                updatetest: "Do you want to update your test ",
                updateformulas:"Formulas",
                translatetext:"Transl",

                viewallquestions: 'View all',

                waitonresponse: 'Waiting on response...',
                //new text
                collegeteststitle: 'COLLEGE TESTS',
                collegetests: 'College Study Tests',
                createcollegetests:'Create College Tests',
                createcollegeteststitle: 'CREATE COLLEGE TESTS',
                firstyear: "First year",
                secondyear: "Second year",
                thirdyear: "Third year",
                forthyear: "Forth year",
                showanswersonly: "Show correct answers",
                showquestionsonly: "Show only questions",
            },  

          
            assistant: {
                clearall: "Clear",
                credits: 'Credits',
                contextconversation: 'Conversation is within a context.',
                summary: 'Summary',
                reversesummary: 'Reverse',
                navbartitle_1: "Copilot:",
                navbartitle_2: "Chat:",
                navbarsave: 'Save',
                navbarsaveplaceholder: '',
                navbarsavedtitles: 'Topics',

                navbarvariations: 'Response creativity',
                promptplaceholder:'Ask me about ...',
                         
                navbartext1: 'Chat keeps track of context and seamlessly maintains the flow of your conversation.',   
                navbartext2: 'Use \'Summary\' button to summarize long conversation.',
                navbartext3: 'Use \'Clear\' button to start new conversation with a new context.',
                navbartext4: 'Use \'Response creativity\' to obtain more variations in AI responses.',
                summaryprompt: 'Remove questions and summarize the following text:',
                responselanguage:"Send me a response in.",
                conversationlanguage:'This conversation is in ',
                whatisthetopic: 'What is the topic in the following:',
                relatedquestions: "Give an answer in the following format: '@@@Topic: '.  Give me three related questions to the prompt. Add prefix '@@@' to each question and do not show sequence numbers and 'Question' prefix. ",
                related: 'Related',
                summarizetext: 'Summarize the following text:',

                note: 'Conversation is within a context. Each new response is related to previous responses.'

            },

            betterresponses: {
                navbartitle: 'Multi-AI Responses:',
                note: 'This page combines different AI models responses and provides the best response. It consumes more credits and takes more time to provide an answer. Each response is independent of previous questions and responses.',
              
                waitonresponse_1: 'Pass 1 of 3: Getting responses...',
                waitonresponse_2: 'Pass 2 of 3: Preparing response...',
                waitonresponse_3: 'Pass 3 of 3: Finalizing response...',
            },

            common: {
                clearall: "Clear",
                credits: 'Credits',
                contextconversation: 'Conversation is outside of context.',


                deletedefaultprompt: 'This is a default prompt and cannot be deleted.',

                dialoglabel_1: 'Name:',
                dialoglabel_2: 'Prompt:',
                dialogadd: 'Add',
                dialogdelete: "Do you want to delete ",
                dialogdefaultpromptedit: "This is a default prompt and cannot be edited.",
                dialogdefaultpromptdelete: "This is a default prompt and canont be deleted.",
                dialogupdate: 'Update',
                dialogsamename: "Prompt with the same name already exists.",
                dialogtitle: 'Custom prompt',
                dialogtitle_1: 'Custom prompts',
               
                dialogeditprompt: 'Edit the name and prompt, and save it as a shortcut.',
                dialogaddprompt: 'Enter the name and prompt, and save it as a shortcut.',
                dialogupdateprompt: "Do you want to update the prompt?",

                summary: 'Summary',
                reversesummary: 'Reverse',
                
                navbartitle: "General:",
                navbartopic:'Archive',
                navbarsave: 'Save',
                navbarsaveplaceholder: '',
                navbarsavedtitles: 'Topics',

                navbarvariations: 'Response creativity',
                promptplaceholder:'Ask me about ...',
                      
                navbartext1: 'Create shortcuts for frequently used prompts.',
                navbartext2: 'This page does not maintain the context. Each response is directly related to the question asked and is not related to previous questions. It usses less credits than Assistant page.',
                navbartext3: 'Use Response creativity to obtaion variations in AI responses.',
                note: 'This page consumes fewer credits. Each new response is independent of prior questions and answers.',
            
                conversationlanguage:'This conversation is in ',
                responselanguage:"Send me a response in ",
                
                shortcuts: 'Prompts',

                shortcutgrammar: 'Grammar',
                shortcutkeywords: 'Keywords',
                shortcutsummary: 'Summary',
                shortcutcompact: 'Compact',
                shortcutstory: 'Write a story',
                shortcutimprove: 'Improve',
                shortcutemail: 'Email',
                shortcutdescription: 'Describe',

                promptgrammar: 'Correct the grammar of the following text: ',
                promptkeywords: 'Extract the most important keywords from the following text: ',
                promptsummary: 'Make a summary of the following text: ',
                promptcompact: 'Compact the following text: ',
                promptstory: 'Write the story about: ',
                promptimprove: 'Improve the following text: ',
                promptemail: 'Write an email about: ',
                promptdescription: 'Write a description of: ',

            },

           
            compareai: {
                navbartitle: 'Compare AI Models:',
            },

            comprehensiveresponses: {
                archivelimit:'Topic not saved. Number of saved topics exceeds the limit of 20.',

                cleardata: "Data will be cleared. Do you want to continue?",
                
                navbartitle: 'My Library:',
                displaymodenormal: 'Standard',
                displaymodedetailed: 'Detailed',
                displaymodecomprehensive: 'Comprehensive',
               
                prepareresponse: 'Preparing response...',
                prepareresponse_1: 'Please wait while we prepare our response.',

                note:'This page provides detailed contextual information that is useful for creating documents, articles, papers, stories, and more.',
                note_1: 'Get the best AI response by comparing and combining results from multiple AI models on this page.',
                
                sendrequest: 'Send request',
                showresponse: 'Show',
                hideresponse: 'Hide',
                sendrequestagain: 'Send request again',
                minimumcredits: 'A minimum balance of 3,000 credits is required to generate a detailed response.',
            },

            contactus: {
                title: 'Contact us',
                subtitle1: "Tell us about your DedaAI experience, and suggest improvements and new features.",
                subtitle2: "Contact us about your business needs, and DedaAI will help you with solutions.",
                placeholdername: 'Name',
                placeholdercompanyname: 'Company name',
                placeholderemail: 'Email',
                placeholdersubject: 'Subject',
                placeholdertext: 'Text',
                buttonsend: 'Send',

            },

            copilot: {
                navbartext1: 'Copilot assists you in finding answers and exploring your chosen topic more deeply.',            
                navbartext2: 'Use \'Response creativity\' to obtain more variations in AI responses.',
                
                note:'Each response includes suggestions for further exploration.'
            },

            credits: {
               
                cancelpayment: 'Cancel',
                creditlimit:'Maximum number of credits is 400 000. If you add more you will be over the limit.',
               
                paynow: 'Pay',

                title: 'Get credits',
                text1: 'No subscription required. Pay only for words that you use. If you need credits just add more.',
                text2: '$7.99 one time payment',
                text3: '100 000 credits (~300 pages of text).',
                
                
                text5: 'You have',
                text6: 'available credits.',
                text7: '*Payments are non-refundable.',

                text12: '$12.99 one time payment',
                text13: '200 000 credits (~600 pages of text).',

              
                paymenttext1: '$7.99 one time payment',
                paymenttext2: '$12.99 one time payment',
                paymentfailed: 'Payment is canceled or declined.',
                paymentsuccessful: 'Payment is successful.',
                creditstext1: '100 000 credits (~300 pages of text)',
                creditstext2: '200 000 credits (~600 pages of text)',
                buttontext1: 'Continue with $7.99 payment',
                buttontext2: 'Continue with $12.99 payment',
                taxtext: '( +10% tax )',

            },

            creditssuccess: {
                thankyou: 'Thank you for your payment.',
                totalcredits: 'Total credits available: ',
            },

            dialog: {
                cleardata: 'Do you want to clear data?',
                cleartemplatedata: 'Do you want to clear template data?',
                clearresponse: 'Do you want to clear response data?',
                deletetemplatestep: 'Do you want to delete this step?',
                yes: 'Yes',
                cancel: 'Cancel',
                ok: 'Ok',
            },

            documentanalysis: {  

                attachfile: 'Attach file',
                
                fileexists: 'File with this name has been already added.',
                filesizeoverlimit: 'Total file(s) size is over 20 MB limit',
                filenotsupported: 'Files of this type are not supported.',
                filenotattached: 'Please attach the file for search.',

                filesmaxnumber:'You can attach up to three files.',

                navbartitle_2: "Documents Search:",
                navbarsavedtitles: 'Topics',

                navbartext1: 'Attach TXT, PDF and DOCS documents.', 
                navbartext2: "If the documents are attached, the prompt will apply to their content.",
                navbartext3: 'Use \'Clear\' button to start new conversation with a new context.',
                note: 'Attach TXT, PDF and DOCS documents. The prompt will be applied to documents content.',
                
                preparefile: 'Preparing a file...',
                preparefiletext: 'It may take longer depending on file size.'
            },

            general: {
                accept: 'Accept',
                cancel: 'Cancel',
                delete: 'Delete',
                searchname: 'Name',
                searchauthor: 'Author'
            },

            home: {
               
                advicetitle: "Advice",
                art: "Art",
                advice: "Get advice from DedaAI on various topics and explore more by asking DedaAI for further assistance.",
                assistant: "Assistant",

                boughtcredits: 'Buying credits...',

                chatgeneralcopilotheader: 'Chat, Copilot and General',
                chatgeneralcopilottext: 'Chat with AI. The conversation takes place within a context, with each new response related to the previous ones.',
                chatgeneralcopilottext_1: 'Chat with AI, create custom prompts, and use them again. This page uses fewer credits. Each response is independent of previous responses.',
                chatgeneralcopilottext_2: 'Each AI response contains up to 5 related prompts to further expand the responses.',
                chatchat:'Chat: ',
                chatgeneral: 'General: ',
                chatcopilot: 'Copilot: ',

                compacttitle: "Compact the text",
                compact: "Condense the length of the text. Remove unnecessary or redundant information, simplify sentences, and optimize the overall structure while retaining its meaning and clarity.",
                common: "General",
                commontext: "Improve your writing by avoiding lengthy prompts and utilizing shortcuts for common tasks.",
                country: "Country",
                customversion: "Full customization is available. Contact DedaAI for more information.",
                compareaiheader: "Compare AI models and select the best response",
                compareaitext: "Models differ in responses.  Choose between AI models and select the best response.",
                
                comprehensiveresponsesheader: 'My Library',
                comprehensiveresponsestext_tooltip: 'Build a personalized library based on your interests. Collect and save in-depth information on a wide range of topics, from science and art to history, nature, and everyday subjects.',
                comprehensiveresponsestext_1: 'Build a personalized library based on your interests. Collect and save in-depth information on a wide range of topics, from science and art to history, nature, and everyday subjects. Try the following examples:',
                comprehensiveresponsestext1: '- Start a small business',
                comprehensiveresponsestext1_1: 'Legal structure, business plans, licensing, and marketing strategies ...',
                comprehensiveresponsestext2: '- Write a novel about the tiger in the jungle',
                comprehensiveresponsestext2_1: 'Brainstorming and outlining, drafting, editing, publishing ...',
                comprehensiveresponsestext3:'- Napoleon',
                comprehensiveresponsestext3_1:'Early life, rise to power, military campaigns, political reforms ...',
                comprehensiveresponsestext4:'- An article about Moon exploration',
                comprehensiveresponsestext4_1: 'Formulating a research question, identifying and accessing sources, evaluating source credibility, proper citation methods,synthesizing information into a coherent argument.',
                comprehensiveresponsestext5:'- Spain 15th - 16th century',
                comprehensiveresponsestext5_1: 'Unification, monarchy, inquisition, explorations,...',
                comprehensiveresponsestext6:'- Travel internationally',
                comprehensiveresponsestext6_1: 'Detailed guide would cover necessary tools, safety precautions, step-by-step instructions,...',
               
                descriptiontitle: "Provide a description",
                description: "Provide a description of an item based on the given information. Specify facts or properties of an item and let DedaAI do the rest of work.",
                
                documentanalysisheader: 'Documents Search',
                documentanalysistext: 'Attach multiple documents and search and analyze them. Find answers and extract topics.',
                
                examples: "Examples",
                emailstitle: "Emails and email thread",
                emails: "Create customized emails tailored to individual customers using our Template Tool. Create template for each customer with their preferences, update with relevant facts and let AI generate an email for you. Use our Common page for summarizing long email threads.",

                famousperson: "Famous person",
                famouspersontitle: "Chat with a famous person",
                famouspersonchat: "Engage in conversations with historical figures and learn about them through interactive learning experiences.",
                
                features1: 'Documents Search',
                features_1: 'Attach TXT, PDF and DOC files and search them for important data.',
                features2: 'TESTS in Education',
                features_2: 'An intuitive platform for professors, teachers, students, and parents to design tests effortlessly.',
                features3: 'Trading Strategies',
                features_3: 'Create trading strategies using historical stock data.',
                features4: 'Notes',
                features_4: 'Organize your data in notes and query them with easy. Utilize DedaAITemplates® to effortlessly generate templates for any task. Avoid repetitive tasks by organizing your work with templates.',
                features5: 'Create Articles',
                features_5: 'Build a personalized library based on your interests. Collect and save in-depth information on a wide range of topics, from science and art to history, nature, and everyday subjects.',
                features6: 'Search Databases',
                features_6: 'Search Databases using your native language.',
                features7: 'Customers support',
                features_7: 'Automated customer support via AI-powered chatbots.',

                grammartitle: "Check a grammar",
                grammar: "Check and correct the grammar of provided text.",


                history: "History",

                introduction: "Introduction",
                introductiontext1:'',
                interviewtitle: "Prepare for an interview",
                interview:"Ask DedaAI on how to effectively prepare for an interview and anticipate the types of questions that may be asked.",
                improvetitle: "Improve the text",
                improve: "Make enhancements in order to enhance text quality, clarity, coherence, and overall effectiveness.",
                
                knowledge: "Test your knowledge",
                keywordstitle: "Find the key words",
                keywords: "Identify and extract the most significant and relevant words or phrases that capture the main ideas, themes, or concepts of the text.",

                meetingtitle: "Prepare a meeting",
                meeting: "Enhance your meeting preparation by creating clear and concise meeting outlines and expanding each one further with additional details for each topic.",
                moto: "Your Business, Our AI Solutions",

                performancereviewtitle: "Performance review",
                performancereview:"As a manager, if you are tasked with writing end-of-year performance reviews, streamline the process by creating template for each employee using our Template Tool.",
                presentationtitle: "Presentation",
                presentation: "Prepare for a presentation. In addition to asking questions, be sure to provide DedaAi with any additional information or context related to your presentation topic. This will enable DedaAi to offer more tailored and accurate responses, enhancing the overall quality of your preparation.",
                programming: "Programming",

                reporttitle: "Report",
                report: "Write a report using our Template Tool. Create a templates for different kind of reports and reuse them by only changing facts.",
                
                science: "Science",
                storytitle: "Write a story",
                summarytitle: "Summarize the text",
                summary:"Provide a concise and condensed overview of the main ideas, key points, and significant details within a given text. It involves capturing the essential information and presenting it in a shortened form, without including unnecessary or irrelevant details.",
                
                testheader: 'Tests',
                testtitle:'Create test',
                testtext: "Tests to help students study at college.",
                templatesamplesintro: 'Utilize DedaAITemplates® to effortlessly generate templates for any task. Avoid repetitive tasks by organizing your work with templates.',
                translationtitle: "Translation",
                translation: "Translate documents, articles, reports, etc. using our Translation page.",
                texthome1: 'We build customizable, fine-tuned, private, and portable open-source AI model solutions.',
                texthome2: 'We are Multi-model AI Platform',
                texthome3: 'We provide the following custom solutions',

                textompareaimodels: 'Compare AI Models',

                textcomprehensiveresponses: 'My Library',
                textassistant: 'Chat',
                textcommon: 'General',
                texttranslations: 'Translations',
                
                texttemplates: 'Notes',

                texttests: 'College Study Tests',
                textcopilot: 'Copilot',
                texttutor: 'Tutor',
                textquiz: 'Quiz',
                textdocumentanalysis: 'Documents Search',

                textjobinterview: 'Job Interview',

                textstocks: 'Stocks Trading',
                textstocksdescription: 'Create stocks trading strategies and find buy opportunity with AI help.',

                testjobinterviewdescription: 'Get ready for your new job by practicing common interview questions to build confidence and improve your responses.',

                textmultiairesponses: 'It combines responses from different AI models and provides the best answer.',
                textgeneral: 'Use this for general questions outside of a specific context. Each response is independent of previous interactions. It uses fewer credits.',
                textcopilotdescription: 'Use Copilot to expand answers. Each response comes with suggestions for further exploration.',
                textchatdescription: 'Chat with AI about various topics while maintaining context throughout the conversation.',
                texttranslationdescription: 'Translate text into various languages.',
                texttutordescription: 'Learn by interacting with AI through questions and responses.',
                
                vacationtitle: "Vacation",
                vacation: "Let DedaAI give you some ideas about your next vacation.",

                universityofbelgrade: 'University of Belgrade',
                serbia: 'Serbia',
                writeastory: "Harness the power of your imagination by crafting a thrilling narrative with specific plot details and let DedaAI bring it to life.",

            },

            introduction: {
                introduction: "Introduction",
                text1: "DedaAI offers you tools to facilitate your interaction with ChatGPT.",
                text2: "ChatGPT is an AI algorithm that helps you search, learn and write  with the help of AI.",
                text3: "IT IS NOT INTERNET. It cannot answer questions like \"What is today wather?\". Think of it as of someone who read a LOT of books, who accumulated vast amount of knowledge and who can help you in many ways.",
                text4: "Explore with DedaAI.",
                text5: "DedaAI offers you the following:",

                text6: "DedaAITemplates®:",
                text7: "Our propriatory tool for creation of reusable templates for any kind od work.",
                text8: "Assistant:",
                text9: "Interactive page that keeps your conversation with AI within a context.",
                text10: "Common:",

                text11: "Page designed for random questions where each question and response is independent of previous questions. It has accelerated keys for the most common tasks.",
                text12: "Translation:",
                text13: "Provides text translation without excessive typing of prompts. Just select a language and provide a text.",
                text14: "Tutor",
                text15: "Learn and test your knowledge about any topic by interacting with AI.",
                
            },

            jobinterview: {

                cleardata: 'Data will be cleared. Do yu want to continue?',

                note:'Please enter your skills and experience, then submit.',

                of: 'of',

                preparing: 'Preparing',
                promptplaceholder:'Add education, experience, and skills.',

                save: 'Save',
                
                navbartitle_2: "Job Interview:",
                navbartext1: "Please provide a brief overview of your experience, skills, proficiency, and areas of expertise, then submit it. Based on your input, you will receive several key focus areas along with related interview questions. You may expand on each question to generate more detailed and insightful answers.",

                navbartext2: 'Use this page to prepare for any interview, conversation, or discussion.',
                navbartext3: 'Save questions to review them anytime.',

                waitontopics: 'Waiting on job interview topics...',



            },

            login: {
                answernotcorrect:'Answer is not correct.',

                buttonlogin: 'Login',
                buttonlogout: 'Logout',

                forgotpassword: 'Forgot Password?',

                invalidanswer: 'Invalid answer.',
                newpassword:'Please create a new password',

                logoutlabel: "Please click on Logout.",
                logintext: 'You are now logged in. Please proceed with our homepage.',
                logouttext: 'You have been logged out.',
                loginsuccess: 'You have logged in successfully.',

                placeholderemail: 'youremail@email.com',
                placeholderpassword: 'Password',
                passwordchanged:'Your password has been changed.',
                provideanswer: 'Please provide an answer.',

                signup: 'sign up',
                submit: "Submit",

                titlelogin: 'Login',
                titlelogout: 'Logout',
                text: 'If you don\'t have an account, please ',

                wrongpassword: 'Password must be at least 8 alphanumeric characters long.',

                
                userexists: 'User with the same email already exists!',
                
            },

            mainmenu: {
                aboutus: "About us",
                assistant: 'Copilot',

                betterresponses: 'Multi-AI Responses',
                
                common: "General",
                compareai: 'Compare AI Models',
                comprehensiveresponses: 'MY LIBRARY',
                contactus: "Contact us",
                credits:"Credits",

                documentanalysis: 'Documents Search',

                home: "Home",

                jobinterview: 'Job interview',

                login: "Login",
                logout:"Logout",
                
                quiz: 'Quiz',
                signup: 'Sign up',
                
                translation:'Translation',

                templates: 'Notes',
                tests: "COLLEGE TESTS",

                writing:"Chat",

            },

            //New text
            marketing: 
            {
                add:'Add contact',
                companyname:'Company: ',
                contactperson:'Contact person:',

                industry: 'Industry',
              
                load: 'Load',
                navbartitle_2: "Marketing:",
                navbarsave: 'Save',
                navbarsaveplaceholder: '',
                navbarsavedtitles: 'Topics',

               
                summaryprompt: 'Remove questions and summarize the following text:',
                responselanguage:"Send me a response in.",
                conversationlanguage:'This conversation is in ',
                whatisthetopic: 'What is the topic in the following:',
                relatedquestions: "Give an answer in the following format: '@@@Topic: '.  Give me three related questions to the prompt. Add prefix '@@@' to each question and do not show sequence numbers and 'Question' prefix. ",
                related: 'Related',
                summarizetext: 'Summarize the following text:',
                save:'Save',
                send:'Send Emails',
                selectindustry: 'Select an inidustry',

                email: 'Email:',
               
                notes: 'Notes:',
                sentdate: 'Sent date:',

                webaddress: 'Web address'

            },

            quiz: {
                reset:"Reset",
                navbartitle: "Quiz:",
                somethingwrong:"Something went wrong. Please try again.",
                note:'Ready for a quiz? Enter a topic to start.',
            },
           
            signup: {
                signup: "Sign up",
                placeholderemail: "youremail@email.com",
                placeholderconfirmemail: "Confirm email",
                placeholderpassword: "Password",
                placeholderconfirmpassword: "Confirm password",
                buttonsignup: "Sign up",
                signuptext: "You will get 10000 free credits with sign up.",

                securityquestions:"Security questions",
                securityquestion:"Security question:",
                answer:"Answer",
                question_1:"What is your mother's maiden name?",
                question_2:"What is the name of the city where you were born?",

                noemail:'User with this email does not exist.',
                loginfailed: 'Login failed.',
                entersecuritycode: "Please enter security code.",
                invalidsecuritycode: 'Invalid security code.',
                signupsuccess: 'You have successfully registered with DedaAI. You have 5,000 free credits to use.',
            },

            status: {
                accountcreated: 'Your account has been created. You have 10000 free credits to use.',
                addcredits: 'Please add credits.',
                attachfile: 'Attach text file',
                attachmaxthreefiles: 'Up to three files can be attached.',

                copy: 'Copy',

                deletetopic: 'Do you want to delete the topic',
                deepseeknotsupported: 'This page does not support DeepSeek model.',

                enteraname: "Please enter a name.",
                enteratext: 'Please enter a text.',
                emailmismatch: 'Email mismatch.',
                emailverification: "Please enter a security code sent to your email address. If you don't see it,  double-check your email address or look in your Spam folder.",
                enteratextandsubmit: 'Enter a text and submit.',
                exampletext1: 'Use this as an example to "chat" with any famous person.',
                exampletext2: 'This example shows you how to create an email.',
                exampletext3: 'This example shows how to start writting an article or a document of any kind.',
                exampletext4: 'Use this as an example to get advice about various topics.',
                exampletext5: 'Use this as an example how to start conversation.',
                exampletext6: 'This example shows how to create a story. Follow this example to create your stories.',
                exampletext8: 'Enter a text and click on Submit. Use AI Tutor page to prepare for an interview and test your knowledge about any topic.',
                exampletext9: 'Enter a prompt and click on Submit for any type of emails.',
                exampletext10: 'Enter a prompt and submit.',
                exampletext19: 'Create and save custom prompts (Prompts) for repetitive tasks.',
                exampletext20: 'Submit to create an email.',
                exampletext21: 'Submit to get a review.',
                exampletext22: 'Submit to see a result.',
                exampletext23: 'Submit to generate a report.',

                
                footertext1: 'DedaAI is using ChatGPT algorithm provided by ',
                footertext2: ' All terms of use are defined by ',
                footertext3: 'policy',

                globalsearch: 'Search the web',

                invalidemail: "Invalid email.",
                invalidconfirmemail: "Invalid confirm email.",
                invalidanswer:"Invalid answer.",

                notopictosave: 'There is no topic to save.',
                namenotdefined: 'Name is not defined.',
                noresponsetosave: '"There are no responses to save.',

                passwordmismatch: 'Password mismatch.',
                passwordlength: "Password must have minimum 8 alphanumeric characters.",
                pleaselogin: 'Please login.',
                providetopic: 'Please provide a topic.',
                provideanswer: 'Please provide an answer.',
                promptempty: 'Prompt is empty.',
                pleaseselectlanguage: 'Please, select a language.',
                paymenttext: 'Payment amount is $',

                responsetype: 'Response type',

                selectmodel: "Select AI Model",
                selectmodelnote: 'Note: Due to the frequent release of new AI models, the list of supported models may change.',
                selectlanguage: 'Select the language, enter a text and submit it.',
              
            },

            stories: {
                navbartitle: "Title:",

            }, 

             stocks: {
                
                add: 'Add rule',
                addtooltip:'Add rule',
                addprompt: 'Add module',
                addanothersymbol: 'Add Symbol',
                addprompt_label1: "Title,who,what,etc...",
                addprompt_label2: "Description,facts,etc...",
                addsymbol: "Edit",
                analyze: 'Apply strategy',
                addsymbolsgrouptooltip: 'Add symbols group.',
                archive:'Strategies',
                addsymbols:'Add Symbols',
               
                clearall: "Clear",
                clearresponses: 'Clear responses',
                credits: 'Credits:',
                close: 'Finish',
                cancel: 'Cancel',
                createtemplate:'Create strategy',
                createtemplatetooltip: 'Build your strategy: Add rules one by one. Save your work: Click "Archive" to store the strategy.',
                currentsymbols: 'Symbols:',

                delete: 'Delete',
                dialognewprompt: 'New rule',
                dialogupdateprompt: 'Update the rule',
                dialogsymbolstitle: "Stock symbols",
                deletesymbolgroup: 'Do you want to delete this symbols group?',
                disclaimer:'Always double-check results because AI can make mistakes. Select the AI model that provides the best answers. Nothing provided should be considered financial advice, and no responsibility is taken for any stock trading decisions or financial actions made based on AI-generated information.',

                examples: 'Examples',

                fastanalysis: 'Fast analysis',

                finishsymbols: 'Save Symbols',
                getprices: 'Get',

                hide: 'Hide',
                hideprompt: 'Hide prompt',
                hideprompttext: 'Last step must be a prompt that will apply to template context.',
                historicaldata: 'Historical Data',

               

                navbartitle: "Stocks:",
                navbarsave: 'Save',
                navbarsaveplaceholder: '',
                navbarsavedtitles: 'Topics',
                navbarvariations: 'Response creativity',
                navbartext1: 'Examples of strategies:',
                navbartext2: 'Develop a trading strategy as a sequence of rules and analyze stocks by applying it to their historical data.',            
                navbartext3: 'We limit the number of symbols per group to 10 to prevent overwhelming the AI with excessive data. You may create as many groups of symbols as you need.',
                navbartext4: 'Create strategies with simple rules. Ambiguous rules may confuse AI and results may be wrong. Save your strategies and apply them to different sets of stocks.',
                navbartext5: 'Use ADD RULE button to add more rules to the strategy.',
                navbartext6: 'NOTE: The examples use 10 trading days of historical data. If you increase the number of trading days, be sure to adjust the rules accordingly.',
                
                navbarexample1_1: 'This example identifies potential buying opportunities by detecting a price drop following a period of sustained gains. It analyzes historical stock data and generates a buy signal when specific price criteria are met.',
                navbarexample2_1: 'This example identifies a stock that has experienced a price spike following a period of relatively stable trading. When such a spike is detected, it generates a buy recommendation.',
                navbarexample3_1: 'Get stock analysis and buy recommendations based on historical data.',
                notesandresponses: "Rules and responses",
               
                promptplaceholder:'Ask me about ...',
                preview: 'Preview',
                previewtooltip: 'Preview rules',
                placeholderwho:'Title, who, what, etc ...',
                placeholderwhat: 'Description, facts, etc ...',
                price5days: '5 days',
                price10days: '10 days',
                price15days: '15 days',
                price1month: "30 days",
                prepareresponse: 'Preparing response...',
                prepareresponse_1: 'Please wait while we prepare our response.',

                responselanguage:"Send me a response in ",
                rules: 'Strategy',
                responses: 'Responses',
                refreshprices: "Do you want to refresh historical data?",
                removesymbolsgrouptooltip: 'Remove this group.',

                showprompt: 'Show prompt', 
                showprompttext: 'Prompt will apply to template context.',
                strategies: 'Strategies',
                symbolsload: 'Load',
                symbolssave: 'Save',
                savesymbols: 'Save Symbols',

                topicname: 'Strategy name',

                update: 'Update',

                whowarning: "Please add 'Title, who, what, etc ...'",
                whatwarning:"'Description, facts,...' is empty. Do you want to leave it empty?",
                waitonresponse: 'Waiting on response...',
            },

            templates: {
                
                add: 'Add a note',
                notes: 'Notes',
                responses: 'Responses',
                notesandresponses: "Notes and responses",

                addtooltip:'Add a note',
                previewtooltip: 'Preview notes',

                addprompt: 'Add module',
                addprompt_label1: "Title,who,what,etc...",
                addprompt_label2: "Description,facts,etc...",
               
                clearall: "Clear",
                credits: 'Credits:',
                close: 'Close',
               
                cancel: 'Cancel',

                createtemplate:'Add notes',
                createtemplatetooltip: 'Build your sequence: Add notes one by one. Save your work: Click "Archive" to store the final sequence.',

                delete: 'Delete',

                dialognewprompt: 'New note',
                dialogupdateprompt: 'Update the note',

                hide: 'Hide',

                hideprompt: 'Hide prompt',
                hideprompttext: 'Last step must be a prompt that will apply to template context.',

                navbartitle: "Notes:",
                navbarsave: 'Save',
                navbarsaveplaceholder: '',
                navbarsavedtitles: 'Topics',
                navbarvariations: 'Response creativity',
                navbartext1: 'Create a logical sequence of notes highlighting the key facts. This is a modular approach to how to organize your work around AI.',            
                navbartext2: 'Eliminate writing long prompts by deviding task into facts, description, what, who, etc., and add them individually as steps using Add step.',
                navbartext3: 'Save template and use it again with different set of data. It eliminates the need of writing long prompts repeatedly.    ',
                navbartext4: 'Example: Lets say there are five clients with different preferences. You may create an email template for each client and modify only facts each time you need to send an email.',
                navbartext5: 'Look at examples from the Home page and use them as a starting point.',
              
               
                promptplaceholder:'Ask me about ...',
                preview: 'Preview',

               
                placeholderwho:'Title, who, what, etc ...',
                placeholderwhat: 'Description, facts, etc ...',
                responselanguage:"Send me a response in ",

                showprompt: 'Show prompt', 
                showprompttext: 'Prompt will apply to template context.',

                update: 'Update',

                whowarning: "Please add 'Title, who, what, etc ...'",
                whatwarning:"'Description, facts,...' is empty. Do you want to leave it empty?",
                
            },

            templatesamples: {
                templatesamples: 'Template Samples',
                prepareameeting: 'Prepare a meeting',
                writeareport:'Write a report',
                performancereview:'Performance review',
                email: 'Email',
                travelexpense: 'Travel expense',

            },

            translation: {
                clearall: "Clear",
                credits: 'Credits',
                summary: 'Summary',
                reversesummary: 'Reverse',
                navbartitle: "Translation:",
                navbarsave: 'Save',
                navbarsavedtitles: 'Topics',
                navbarsaveplaceholder: 'Save as ...',
                translateto: 'Translate to: ',
                
                navbarvariations: 'Response creativity',
                promptplaceholder:'Type a text to translate ...',
                navbartext1: 'Select a language, enter a text to translate and submit.',
                navbartext2: 'Due to the AI limitations of amount of text that can be processed at a time, divide large text into paragraphs or chapters and translate them one by one.',
                navbartext3: 'Save your work and continue any time.',
              
                showprompts: 'Show prompts',
                hideprompts: 'Hide prompts',
            },
            tutor: {
                askquestion:'Question',
                clearall: "Clear",
               
                credits: 'Credits',
               
                navbartitle: "Tutor:",
                navbarsave: 'Save',
                navbarsaveplaceholder: '',
                navbarsavedtitles: 'Topics',
                navbarlanguage:"Language: ",

                navbarvariations: 'Response creativity',
                navbartext1: 'Learn or test yuor knowledge about any topic. Enter a topic, click on \'Question\', provide an answer and submit.',            
                navbartext2: 'Save your conversation. Review it or continue any time.',
                navbartext3: 'Use Response creativity to obtain variations in AI responses.',
               
                note: 'Please enter a topic and click on "Question." After that, provide your answer and submit it.',

                promptplaceholder:'Type an answer ...',
                responselanguage:"Send me a response in .",

                tutortema: 'Topic',
                question: 'Question?',

                samplemessage: 'Select any topic, click on "Question?" and submit an answer.',
                sametopic: "There is already a topic with this name. Do you want to overwrite it?",
            },
       
    },
   
    Serbian: {
        aitest: {
            accept: 'Prihvati', 
            account: 'Moj nalog',
            accountcapital: 'NALOG',
            active: 'U upotrebi',
            activated: "Aktiviran",
            activity: 'Nalog',
            alltestssubtitle: 'Svi testovi',
            addfreetestdialog: "Želite li da dodate besplatan test",
            //accountverification: "Potvrdite identitet",
            accountverificationtext: "Vaša provera identiteta mora biti uradjena. Nalog neće biti važeći bez nje.",
            areas:'Test oblast: ',
            noareatosave:'Nedostaje test oblast.',
            
            buytestdialog: "Želite li da kupite test",
            buytest: 'Kupi',
            buytestfree: 'Besplatno',
            boughttest: 'Upravo ste kupili test',
            by: 'autor:',

            cancel: 'Ne',
            changeaccount: "Novi račun",
            changeaccounttext: "Već imate račun za plaćanje. Ako želite da ga promenite, morate da napravite novi račun.",
            createaccount: 'Otvori nalog',
            createaccounttext: "Ako planirate da prodajete svoje testove, prvo morate da otvorite nalog kako biste primili uplate.",
            creatorname: 'Autor',
            createtest:'Napravi test',
            createtesttitle: 'NAPRAVI TEST',
            createaccountbutton: 'Kreiraj nalog',
            createaccounttitle: 'Kreiraj nalog',
            choosetesttitle: 'IZABERI TEST',
            cannotbepurchased: 'Ovaj test ne može biti kupljen.',
            
            dialogquestion: "Pitanje:",
            dialoganswer_1: "Odgovor 1:",
            dialoganswer_2: "Odgovor 2:",
            dialoganswer_3: "Odgovor 3:",
            dialogmodifytest: 'Promeni test',
            dialogupdate: 'Sačuvaj',
            description: 'Opis testa:',
            descriptionprompt: 'Dodaj opis testa',

            expired: 'Isteklo',

            free: 'Besplatno',
            freevspaidtest: "Besplatni ili plaćeni testovi",

            generatesubtopics: 'Generiši podteme',
            generatequestions: 'Generiši pitanja',

            howtocreatetest: "Kako kreirati test",

            language: 'Jezik: ',
            login: 'Molimo vas, prijavite se.',

            moreanswertitle: "Više o ...",
            mytests: 'Moji testovi',
            mytestalert: 'Ovo je Vaš test i ne može biti kupljen.',

            navbartitle: "Test:",
            newsubtopics: "Da li želite da kreirate nove podteme iz datog konteksta?",
            notactive: "Nije u upotrebi",
            notactivated: "Nije aktiviran",
            nocreatornametosave: "Nedostaje ime autora.",
            nodescriptiontosave: "Nedostaje opis.",

            opentest: 'Izaberi test',

            paidtestwarning: 'Ovo je plaćeni test i biće dostupan za kupovinu. DedaAI će zadržati 12% od svake prodaje kao naknadu za troškove obrade plaćanja. Da li želite da aktivirate ovaj test?',
            placeholdergeneratetestid: 'ID testa',
            placeholderopentest: 'ID testa',
            problemsavingfile: "Došlo je do problema prilikom zapisa testa.",
            prompttestname: 'Ime testa',
            previewquestions: "Ovo je pregled testa koji se plaća i prikazano je samo prvih pet pitanja.", 
            purchasedtests: 'Kupljeni testovi',

            questions: 'Pitanja:',
            questionsbutton: 'Pitanja',
            questionslimit: "Dostigli ste maksimalan broj dozvoljenih pitanja za ovaj test.",

            resettooltip: "Resetuj odgovore",
            resetanswers: "Da li zelis da resetujes odgovore?",

            sameauthor: "Autor sa istim imenom već postoji. Molim vas, odaberite drugo ime.",
            sametestname: "Postoji još jedan test sa istim imenom od strane drugog autora i ne može se ažurirati.",
            savetestname: 'Ime testa',
            savedtests:'Moji testovi',
            savetest: 'Sačuvaj test',
            save: 'Sačuvaj',
            savechosentest: "Da li želite da sačuvate svoje odgovore?",
            saveanswers: "Sačuvaj",
            selecttest:'Opšti testovi',
            selecttestarea: 'Izaberite oblast testiranja',
            selecttestlanguage: 'Izaberite jezik testa',
            selectedtestinfo: 'Odabrali ste sledeći test za kupovinu:',
            showcontext: 'Tema',
            
            somethingwentwrong: 'Došlo je do greške. Molimo pokušajte ponovo.',
            startreceivingpayments: "Kreirajte nalog da biste počeli da primate uplate.",
            subtopics: 'Podtema',
            subtopicssubtext: 'Podteme su izvedene iz glavne teme i pomoći će u dobijanju detaljnih pitanja.',

            test: "Rezultat testa:",
            testid: 'Generiši ID testa',
            testname: 'Ime testa',
            testexists: ' već postoji u listi kupljenih testova.',
            topic: 'Tema:',
            testprice: 'Cena: $',
            tests:'Testovi:',
            totalearnings: 'Ukupna zarada: $',
            topicplaceholder: 'Unesite temu i nastavite sa "Generiši Pitanja"',
            transfermoney: 'Prenesi novac',
            transactions: 'Transakcije',
            transfermoneybutton: 'Prenesi',
            testarea: 'oblast: ',
            testlanguage: 'jezik: ',
            text1: 'Kliknite na podtemu da je odaberete.',
            text2: 'Test koji nije u upotrebi nema kupovina ili su sve kupovine istekle. Ovaj test može biti obrisan.',
            text3: "Test mora biti aktiviran da bi postao dostupan za korišćenje. Tokom kreiranja test NIJE AKTIVAN i nije dostupan za korišćenje. Kada ste zadovoljni njegovim sadržajem, učinite ga javnim aktiviranjem čekboks.",
            text4: 'Kreirajte test uz pomoć AI. Unesite kontekst, kliknite na "Generiši pitanja" i AI će generisati pitanja sa odgovorima. Uredite pitanja i odgovore po potrebi. Kada je test spreman, aktivirajte ga da postane javan.',
            text8: 'Izaberite test ',
            text9: 'Kreirajte test ',
            text10: "Pripremite testove koristeći našu platformu za testiranje kako biste pomogli studentima, zaposlenima i prijateljima sa njihovim ispitima i procenama. Pomognite u sticanju znanja pomoću dobro pripremljenih testova.",
            text11: "Želite li da kupite test ",
            text12: "Moći ćete ga koristiti 6 meseci od danas.",
            text13: "Prodajte svoje testove i monetizujte svoje znanje i stručnost. Zarađujte dok pomažete zajednici da proširi svoje znanje. Uključite se i napravite izazov za svoje djake, studente, zaposlene ili prijatelje dobro osmišljenim testovima.",
            text14: "Pronađite testove koji najbolje odgovaraju vašim potrebama u pripremi za ispite i procene. Uđite dublje u svoje učenje proširujući tačne odgovore i poboljšavajući svoje razumevanje svake teme. Započnite svoje putovanje ka uspehu danas i unapredite svoje znanje.",
            text15: "Ovaj test je kreiran od strane vas i ne može biti izabran.",
            text17: "Ovaj test će biti obrisan. Nastavite sa brisanjem ovog testa?",
            text18: "Želite li da aktivirate ovaj test da postane javan?",
            text19: "Želite li da deaktivirate ovaj test?",
            text21: "Test ne može biti menjan dok je u AKTIVNOJ (u upotrebi) stanju.",
            text22: "Pitanja se generišu po tri u isto vreme. Tačni odgovori se postavljaju nasumično. Možete promeniti kontekst pre nego što se kreiraju sledeća pitanja kako biste dobili specifičnija pitanja o kontekstu.",
            text23: "Test je istekao i ne može biti prikazan.",
            text24: "Glavna tema mora postojati pre generisanja podtema.",
            text25: "Da li želite generisati podteme iz datog konteksta?",
            text26: 'Ovo je plaćeni test. Test se ne može aktivirati jer niste kreirali nalog za primanje uplata. Molimo vas da kreirate nalog klikom na "Nalog."',
            text27: "Ovo je plaćeni test i biće dostupan za kupovinu. DedaAI će zadržati 18% od kupovne cene kao naknadu i za troškove obrade plaćanja. Da li želite da aktivirate ovaj test?",
            text30: 'Steknite konkurentsku prednost',
            text31: 'Budite na čelu napredovanja veštačke inteligencije, otključajte nove mogućnosti, podstaknite inovacije i nadmašite konkurente u pružanju inteligentnih rešenja koja zadovoljavaju zahteve današnjeg digitalnog sveta.',
            text32: 'Prilagođena rešenja koja odgovaraju potrebama vašeg poslovanja',
            text33: 'Pružamo rešenja koja su posebno prilagođena da zadovolje jedinstvene potrebe vašeg poslovanja i savršeno usklađena sa vašim zahtevima i ciljevima.',
            text34: 'Razvoj AI strategije, analiza podataka i modelovanje',
            text35: 'Sa našom stručnošću u razvoju AI strategije, analizi podataka i modelovanju, nudimo holistički pristup koji pomaže organizacijama da iskoriste moć veštačke inteligencije, optimizuju svoje procese zasnovane na podacima i podstaknu inovacije u svojim industrijama.',
            text36: 'AI u donošenju odluka zasnovanim na podacima',
            text37: 'Imamo razumevanje tehnologija veštačke inteligencije i njihove primene u analizi i tumačenju velikih skupova podataka kako bismo doneli informisane odluke. To uključuje korišćenje AI algoritama i tehnika za izvlačenje vrednih uvida, identifikaciju obrazaca i predikciju ishoda koji mogu podstaći efikasne procese donošenja odluka.',
            text38: 'Prodaj testove',
            text40: 'Izaberite kontekst:',
            text41: '"Generiši podteme" dugme će generisati podteme vezane za kontekst. Izaberite podtemu jednu po jednu i kliknite na "Generiši pitanja" da biste kreirali povezana pitanja.',
            text42: 'Možete ponuditi svoje testove besplatno ili možete prodavati svoje testove i unovčiti svoje znanje i stručnost. Za svaki prodat test DedaAI će naplatiti 12% takse za transakciju i održavanje.',
            text43: 'Ako pravite plaćene testove morate napraviti nalog da biste počeli da primate uplate.',   

            userexists: 'Korisnik već postoji.',
            updatetest: "Da li želiš da ažuriraš svoj test ",

            viewallquestions: "Pogledaj sve",

            waitonresponse: 'Čekamo na odgovor...',

            collegeteststitle: 'FAKULTETSKI TESTOVI',
            collegetests: 'Fakultetski testovi za učenje',
            createcollegetests:'Napravi fakultetske testove',
            createcollegeteststitle: 'NAPRAVI FAKULTETSKE TESTOVE',
         
        },
        
            assistant: {
                clearall: "Obriši",
                credits: 'Krediti',
                contextconversation: "Razgovor se odvija u kontekstu.",

                summary: 'Sumiraj',
                reversesummary: 'Vrati',
                navbartitle_1: "Copilot",
                navbartitle_2: "Chat:",
                navbarsave: 'Sačuvaj',
                navbarsavedtitles: 'Teme',
                navbarsaveplaceholder: 'Naziv teme ...',
                navbarvariations: 'Raznovrsnost odgovora',
                promptplaceholder:'Pitaj me o nečemu ...',

                navbartext1: 'Ćaskanje prati kontekst i neprimetno održava tok vašeg razgovora.',
                navbartext2: "Koristite dugme 'Sumiraj' da biste saželi dug razgovor.",
                navbartext3: "Koristite dugme 'Obriši' da biste započeli novi razgovor sa novim sardzajem.",
                navbartext4: "Koristite kontrolu 'Raznovrstnost odgovora' da biste dobili više varijacija u odgovorima.",
                note: 'Razgovor se odvija u kontekstu. Svaki novi odgovor je povezan sa prethodnim odgovorima.',

                summaryprompt: 'Rezimiraj sledeci text:',
                responselanguage:"Send me a response in",
                conversationlanguage:'This conversation is in ',
                whatisthetopic: 'Koja je tema u sledecem textu:',
                relatedquestions: "Daj mi odgovor u sledecem formatu: '@@@Tema: '.  Daj mi tri ptanja koja su u vezi sa datom temom. Dodaj prefiks '@@@' svakom pitanju i nemoj da pokazes redni broj kao ni 'Pitanje' ispred recenice. ",
                related: 'Povezano',
                summarizetext: 'Sumiraj sledeci text:',
            },

            betterresponses: {
                navbartitle: "'Multi-AI' odgovori:",
                note: 'Ova stranica kombinuje odgovore različitih AI modela i pruža najbolji odgovor. Troši više kredita i zahteva više vremena da pruži odgovor. Svaki odgovor je nezavistan od prethodnih pitanja i odgovora.',

                waitonresponse_1: 'Korak 1 od 3: Cekamo na odgovore...',
                waitonresponse_2: 'Korak 2 od 3: Priprema odgovora...',
                waitonresponse_3: 'Korak 3 od 3: Finalizacija odgovora...',         

            },

            common: {
                clearall: "Obriši",
                credits: 'Krediti',
                contextconversation: "Razgovor je van konteksta.",
                
                deletedefaultprompt: 'Ovo je prompt koji ne može biti obrisan.',
                dialoglabel_1: 'Ime:',
                dialoglabel_2: 'Poruka:',
                dialogadd: 'Dodaj',
                dialogdelete: "Da li želite da obrišete ",
                dialogdefaultpromptedit: "Ova poruka ne može se promeniti.",
                dialogdefaultpromptdelete: "Ova poruka ne može se obrisati.",
                dialogupdate: 'Sačuvaj',
                dialogsamename: "Poruka sa istim imenom već postoji.",
                dialogtitle: 'Prilagođena poruka',
                dialogeditprompt: 'Izmenite ime i poruku, i sačuvajte je kao prečicu.',
                dialogaddprompt: 'Unesite ime i poruku, i sačuvajte je kao prečicu.',
                dialogupdateprompt: "Da li želite da ažurirate poruku?",

                navbartitle: "Opšta stranica:",
                navbartopic:'Arhiva',
                navbarsave: 'Sačuvaj',
                navbarsaveplaceholder: '',
                navbarsavedtitles: 'Teme',

                navbarvariations: 'Raznolikost odgovora',
                promptplaceholder:'Pitaj me o nečemu ...',
                navbartext1: 'Kreirajte prečice za često korišćena pitanja.',
                navbartext2: 'Ova stranica ne održava kontekst. Svaki odgovor je odgovor na postavljeno pitanje i nije povezan sa prethodnim odgovorima. Koristi manje kredita od Asistent stranice.',
                navbartext3: 'Koristite "Raznovrstnost odgovora" da biste dobili varijacije u AI odgovorima.',
                note: 'Ova stranica troši manje kredita. Svaki novi odgovor je nezavistan od prethodnih pitanja i odgovora.',
            
                responselanguage:"Send me a response in ",

                shortcuts: 'Pitanja',
                shortcutgrammar: 'Gramatika',
                shortcutkeywords: 'Glavne reči',
                shortcutsummary: 'Sumiraj',
                shortcutcompact: 'Kompres',
                shortcutstory: 'Napiši priču',
                shortcutimprove: 'Poboljšaj',
                shortcutemail: 'E-pošta',
                shortcutdescription: 'Opiši',

                promptgrammar: 'Ispravite gramatiku sledećeg teksta: ',
                promptkeywords: 'Izdvojite najvažnije ključne reči iz sledećeg teksta: ',
                promptsummary: 'Napravite sažetak sledećeg teksta: ',
                promptcompact: 'Kompaktujte sledeći tekst: ',
                promptstory: 'Napišite priču o: ',
                promptimprove: 'Poboljšajte sledeći tekst: ',
                promptemail: 'Napišite email o: ',
                promptdescription: 'Napišite opis o: ',
            },

            compareai: {
                navbartitle: 'Uporedite AI modele:',
            },

            comprehensiveresponses: {
                cleardata: "Podaci će biti obrisani. Da li želite da nastavite?",
                navbartitle: 'Moja biblioteka:',
                displaymodenormal: 'Standardan',
                displaymodedetailed: 'Detaljno',
                displaymodecomprehensive: 'Detaljni',
               
                prepareresponse: 'Priprema odgovora...',
                prepareresponse_1: 'Molimo vas da sačekate dok pripremamo naš odgovor.',
                note: 'Ova stranica pruža detaljne kontekstualne informacije, korisne za kreiranje dokumenata, članaka, radova, priča i još mnogo toga.',
                note_1: 'Dobijte najbolji AI odgovor upoređujući i kombinujući rezultate iz više AI modela na ovoj stranici.',
                
                sendrequest: 'Pošalji zahtev',
                showresponse: 'Prikaži',
                hideresponse: 'Sakrij',
                sendrequestagain: 'Pošalji zahtev ponovo',
                inimumcredits: 'Za generisanje detaljnog odgovora, potreban je minimalni iznos od 3.000 kredita.'
            },

            contactus: {
                title: 'Kontaktirajte nas',
                subtitle1: "Recite nam o svom iskustvu sa DedaAI i predložite poboljšanja i nove ideje.",
                subtitle2: "Kontaktirajte nas u vezi sa vašim poslovnim potrebama i DedaAI će vam pomoći sa rešenjima.",
                placeholdername: 'Ime',
                placeholdercompanyname: 'Ime firme',
                placeholderemail: 'E-pošta',
                placeholdersubject: 'Tema',
                placeholdertext: 'Text',
                buttonsend: 'Pošalji',

            },

            copilot: {
               navbartext1: 'Copilot vam pomaže da pronađete odgovore i dublje istražite izabranu temu.',
               navbartext2: "Koristite 'Kreativnost odgovora' da dobijete više varijacija u odgovorima veštačke inteligencije.", 
               note:'Svaki odgovor uključuje preporuke za dalje istraživanje.'
            
            },


            credits: {

                creditlimit:'Maksimalan broj kredita je 400 000. Ako dodate više, premašićete limit.',

                title: 'Dodajte kredite',
                text1: 'Pretplata nije potrebna. Kupite kredite i kada ih potrosite, uvek mozete dodati jos.',
                text2: 'Cena paketa je $7.99.',
                text3: '100000 kredita (~300 stranica texta).',
                
                text5: 'Imate ukupno',
                text6: 'kredita.',
                text7: '*Uplate se ne vracaju.',

                text12: 'Jednokratna uplata od $12.99', 
                text13: '200 000 kredita (~600 stranica teksta).', 

                paymenttext1: '$7.99 jednokratna uplata',
                paymenttext2: '$12.99 jednokratna uplata',
                creditstext1: '100 000 kredita (~300 stranica teksta)',
                creditstext2: '200 000 kredita (~600 stranica teksta)',
                buttontext1: 'Nastavite sa uplatom od $7.99',
                buttontext2: 'Nastavite sa uplatom od $12.99',
                taxtext: '( +10% porez )',

                //New text
                paymentfailed: 'Plaćanje je poništeno ili je kartica odbijena',
                paymentsuccessful: 'Plaćanje je uspešno izvršeno.',
                paynow: 'Kupi',
                cancelpayment: 'Zatvori',
           
            },

            creditssuccess: {
                thankyou: 'Hvala za vasu uplatu.',
                totalcredits: 'Imate ukupno kredita: ',
            },

            dialog: {
                cleardata: 'Da li zeliš da obrišeš odgovore?',
                cleartemplatedata: 'Da li zeliš da obrišeš model?',
                clearresponse: 'Da li zeliš da obrišeš odgovore?',
                deletetemplatestep: 'Da li želite da obrišete ovaj korak?',
                yes: 'Da',
                cancel: 'Zatvori',
                ok: 'Zatvori',
            },

            documentanalysis: {

                attachfile:'Priloži fajl',
                
                fileexists: 'Fajl sa ovim imenom je već dodat.', 
                filesizeoverlimit: 'Ukupna veličina fajlova prelazi ograničenje od 20MB.', 
                filenotsupported: 'Fajlovi ovog tipa nisu podržani.', 
                filenotattached: 'Molimo priložite fajl za pretragu.',
                filesmaxnumber: 'Možete priložiti najviše tri fajla.',

                navbartitle_2: "Pretraga Dokumenata:",
                navbarsavedtitles: 'Teme',

                navbartext1: 'Priložite TXT, PDF i DOCS dokumente.',   
                navbartext2: "Ako su dokumenti dodati, upit će se primeniti na njihov sadržaj.",
                navbartext3: 'Koristite dugme \'Obriši\' da započnete novu konverzaciju sa novim kontekstom.',
                note: 'Priložite TXT, PDF i DOCS dokumente. Upit će biti primenjen na sadržaj dokumenata.',
            
                preparefile: 'Priprema documenta...',
                preparefiletext: 'Može potrajati duže u zavisnosti od veličine dokumenta.'
            },

            general: {
                accept: 'Prihvati',
                cancel: 'Poništi',
                delete: 'Obriši',
                searchname: 'Ime',
                searchauthor: 'Autor'
            },

            home: {
                assistant: "Asistent",
                advicetitle: "Savet",
                advice: "Dobijte savet od DedaAI o raznim temama i istražujte više i dublje tražeći dalju pomoć od DedaAI.",
                art: "Umetnost",

                boughtcredits: 'Kupovina kredita...',               
                businesssolutions: "Poslovna rešenja",

                chatgeneralcopilotheader: 'Ćaskanje, Kopilot i Opšta stranica',  
                chatgeneralcopilottext: 'Ćaskajte sa veštačkom inteligencijom. Razgovor se odvija u okviru konteksta, pri čemu je svaki novi odgovor povezan sa prethodnim.',  
                chatgeneralcopilottext_1: 'Ćaskajte sa veštačkom inteligencijom, kreirajte prilagođene upite i koristite ih ponovo. Ova stranica koristi manje kredita. Svaki odgovor je nezavistan od prethodnih.',  
                chatgeneralcopilottext_2: 'Svaki odgovor veštačke inteligencije sadrži do 5 povezanih upita koji dodatno proširuju odgovore.',  
                chatchat: 'Ćaskanje: ',  
                chatgeneral: 'Opšta stranica: ',  
                chatcopilot: 'Kopilot: ',
                compacttitle: "Skraćivanje teksta",
                compact: "Skraćivanje dužine teksta. Uklonite nepotrebne i redundantne informacije, pojednostavite rečenice i optimizujte ukupnu strukturu uz zadržavanje značenje i jasnoće.",
                country: "Zemlja",
                common: "Opšte",
                commontext: "Poboljsajte svoje pisanje izbegavajući dugačke upute i koristeći prečice za uobičajene zadatke.",
                customversion: "Potpuna prilagodljivost je dostupna. Kontaktirajte DedaAI za više informacija.",
                compareaiheader: "Uporedite AI modele i odaberite najbolji odgovor",
                compareaitext: "Modeli se razlikuju u odgovorima. Izaberite između AI modela i odaberite najbolji odgovor.",
                
                comprehensiveresponsesheader: 'Moja biblioteka',
                comprehensiveresponsestext_tooltip: 'Izgradite personalizovanu biblioteku na osnovu vaših interesa. Sakupljajte i čuvajte detaljne informacije o različitim temama, od nauke i umetnosti do istorije, prirode i svakodnevnih tema.',
                comprehensiveresponsestext_1: 'Izgradite personalizovanu biblioteku na osnovu vaših interesa. Sakupljajte i čuvajte detaljne informacije o različitim temama, od nauke i umetnosti do istorije, prirode i svakodnevnih tema. Isprobajte sledeće primere:',
                comprehensiveresponsestext1: '- Pokrenite mali biznis',
                comprehensiveresponsestext1_1: 'Pravni okvir, poslovni planovi, dozvole i marketinške strategije...',
                comprehensiveresponsestext2: '- Napišite roman o tigru u džungli',
                comprehensiveresponsestext2_1: 'Generisanje ideja i izrada sadržaja, pisanje, uređivanje, objavljivanje...',
                comprehensiveresponsestext3: '- Napoleon',
                comprehensiveresponsestext3_1: 'Rano detinjstvo, uspon na vlast, vojne kampanje, političke reforme...',
                comprehensiveresponsestext4: '- Članak o istraživanju Meseca',
                comprehensiveresponsestext4_1: 'Formulisanje istraživačkog pitanja, pronalaženje i pristupanje izvorima, procena pouzdanosti izvora, ispravne metode citiranja, sintetizovanje informacija u jasnu argumentaciju.',
                comprehensiveresponsestext5: '- Španija, 15. - 16. vek',
                comprehensiveresponsestext5_1: 'Ujedinjenje, monarhija, inkvizicija, istraživačka putovanja...',
                comprehensiveresponsestext6: '- Putujte u inostranstvo',
                comprehensiveresponsestext6_1: 'Detaljni vodič bi obuhvatao potrebna sredstva, mere bezbednosti, korak-po-korak uputstva...',

                descriptiontitle: "Opis",
                description: " Navedite ime stvari i osnovne karakterstike i pustite da vam DedaAI da veoma lep opis.",
                documentanalysisheader: 'Pretraga Dokumenata',
                documentanalysistext: 'Priložite više dokumenata i pretražite ih i analizirajte. Pronađite odgovore i izdvojite teme.',

                examples: 'Primeri',
                emailstitle: "E-pošta i nizovi e-pošte",
                emails: "Napisite e-poštu prilagođene svakom klijentu koristeći DedaAI tehniku pravljenja modela. Napravite model za svakog klijenta sa njihovim zeljama i mogucnostima, ažurirajte sa relevantnim činjenicama i dozvolite da DedaAI generiše e-poštu za vas. Koristite našu Opštu stranicu ako želite da sažete dug niz e-pošte.",
                
                famousperson: "Istorijska ličnost",
                famouspersontitle: "Razgovarajte sa poznatom osobom",
                famouspersonchat: "Vodite razgovore sa istorijskim ličnostima i saznajte više o njima.",
                features1: 'Pretraga dokumenata',
                features_1: 'Priložite TXT, PDF i DOC fajlove i pretražujte ih u potrazi za važnim podacima.',
                features2: 'TESTOVI u obrazovanju',
                features_2: 'Intuitivna platforma za profesore, nastavnike, studente i roditelje za jednostavno kreiranje testova.',
                features3: 'Strategije trgovanja akcijama',
                features_3: 'Kreirajte strategija za trgovinu akcijama koristeći istorijske podatke o akcijama.',
                features4: 'Beleške',
                features_4: 'Organizujte svoje podatke u beleškama i lako ih pretražujte. Koristite DedaAITemplates® za jednostavno generisanje šablona za bilo koji zadatak. Izbegnite ponavljajuće poslove organizujući svoj rad pomoću šablona.',
                features5: 'Kreirajte članke',
                features_5: 'Izgradite personalizovanu biblioteku na osnovu vaših interesovanja. Sakupljajte i čuvajte detaljne informacije o širokom spektru tema, od nauke i umetnosti do istorije, prirode i svakodnevnih tema.',
                features6: ' Pretraživanje baza podataka',
                features_6: 'Pretražujte baze podataka koristeći svoj maternji jezik.',
                features7: 'Podrška korisnicima',
                features_7: 'Automatska podrška korisnicima putem četbotova pomoću veštačke inteligencije.',

                grammartitle: "Provera gramatike",
                grammar: "Proverite i ispravite gramatiku datog teksta.",

                history: "Istorija",

                interviewtitle: "Priprema za intervju",
                interview:"Pitajte DedaAI kako da se pripremite za intervju i predvidite vrste pitanja koja mogu biti postavljena.",
                improvetitle: "Poboljsanje tekst",
                improve: "Poboljsajte tekst kako biste podigli kvalitet, jasnoću, koherentnost i ukupnu sadrzinu.",

                knowledge: "Testirajte svoje znanje",
                keywordstitle: "Pronađite ključne reči",
                keywords: "Izdvojte najznačajnije i relevantne reči ili fraze koje predstavljaju glavne ideje, teme ili koncept teksta.",

                meetingtitle: "Priprema sastanka",
                meeting: "Pripremite sastanak uz pomoć DedaAI. Navedite temu, dodajte činjenice i pustite DedaAi da vam predloži agendu sastanka.",
                moto:"Vaš posao, naša AI rešenja",

                performancereviewtitle: "Godisnja ocena",
                performancereview:"Kao menadžer, ako treba da napišete godišnji pregled učinka zaposlenih, pojednostavite proces pravljenjem modela za svakog zaposlenog koristeći DedaAI pristup.",
                presentationtitle: "Prezentacija",
                presentation: "Pripremite se za prezentaciju. Osim postavljanja pitanja, obezbedite DediAI sve dodatne informacije ili kontekst vezan za temu vaše prezentacije. To će omogućiti DediAI da pruži bolje i tačnije odgovore, poboljšavajući ukupan kvalitet vaše pripreme.",
                programming: "Programiranje",

                reporttitle: "Izveštaj",
                report: "Napišite izveštaj koristeći DedaAI postupak za stvaranje modela. Napravite model za različite vrste izveštaja i ponovno ih koristite samo promenom činjenice.",

                storytitle: "Napišite priču",
                science: "Nauka",
                summarytitle: "Sumirajte tekst",
                summary:"Sumirajte tekst u kondenzovan pregled glavnih ideja, kljucnih tacaka i znacajnih detalja bez ukljucivanja nepotrebnih i nevaznih detalja.",
                
                templatesamplesintro:"Koristite DedaTemplates® da lako generisete modele za bilo koji zadatak. Organizujte svoj rad pomocu modela i izbegnite pisanje ponavljajućih zadataka.",
                translationtitle: "Prevod",
                translation: "Prevedite dokumente, članke, izveštaje itd. koristeći našu stranicu za prevode.",
                testheader: 'Testovi',
                testtitle:'Napravite test',
                testtext: "Testovi za pomoć studentima pri učenju na fakultetu.",
                texthome1: 'Pravimo prilagođena, fino podešena, privatne i prenosiva AI rešenja na bazi "open source".',
                texthome2: 'Mi smo Multi-model AI Platforma',
                texthome3: 'Pružamo sledeća prilagođena rešenja',
                textompareaimodels: 'Poredite AI modele',
                textcomprehensiveresponses: 'Detaljni odgovori',
                textassistant: 'Chat',
                textcommon: 'Opšta stranica',
                texttranslations: 'Prevodi',
                texttemplates: 'Beleške',
                texttests: 'Testovi za učenje na fakultetu',
                textcopilot: 'Kopilot',
                texttutor: 'Tutor',
                textquiz: 'Kviz',
                textdocumentanalysis: 'Pretraga dokumenta',
                textmultiairesponses: 'Kombinuje odgovore različitih AI modela i pruža najbolji odgovor.', 
                textgeneral: 'Koristite ovo za opšta pitanja van određenog konteksta. Svaki odgovor je nezavisan od prethodnih interakcija. Koristi manje kredita.', 
                textcopilotdescription: 'Koristite Copilot za proširenje odgovora. Svaki odgovor dolazi sa sugestijama za dalje istraživanje.', 
                textchatdescription: 'Razgovarajte sa AI o raznim temama dok održavate kontekst tokom razgovora.', 
                texttranslationdescription: 'Prevodite tekst na razne jezike.', 
                texttutordescription: 'Učite kroz interakciju sa AI putem pitanja i odgovora.',

                textjobinterview: 'Intervju za posao',  
                testjobinterviewdescription: 'Pripremite se za novi posao vežbajući uobičajena pitanja sa intervjua kako biste izgradili samopouzdanje i poboljšali svoje odgovore.',
                textstocks: 'Strategije trgovanja akcijama',
                textstocksdescription: 'Kreirajte strategije trgovanja akcijama i pronađite priliku za kupovinu uz pomoć veštačke inteligencije.',

                vacationtitle: "Odmor",
                vacation: "Dopustite DedaAI da vam pruži ideje za vaš sledeći odmor.",

                writeastory: "Stvorite uzbudljive priče sa određenim detaljima zapleta i dozvolite da ih DedaAI oživi.",

            },

            introduction: {
                introduction: "Uvod",
                text1: "DedaAI vam nudi alate za jednostavnu  interakciju sa ChatGPT-om.",
                text2: "ChatGPT je AI algoritam koji vam pomaže u pretraživanju, učenju i pisanju uz pomoć veštačke inteligencije.",
                text3: "TO NIJE INTERNET. Ne može odgovoriti na pitanja poput \"Kakvo je vreme danas?\". Zamislite ga kao nekoga ko je pročitao PUNO knjiga, koji je stekao ogromno znanje i ko vam može pomoći na mnogo načina.",
                text4: "Istražujte sa DedaAI.",
                text5: "DedaAI vam nudi sledeće:",

                text6: "DedaAITemplates®:",
                text7: "Naš alat za pravljenje modela(šablona) koji se mogu ponovo upotrebiti za bilo koji rad.",
                text8: "Asistent:",
                text9: "Interaktivna stranica koja održava vašu konverzaciju sa AI u kontekstu.",
                text10: "Opšte:",

                text11: "Stranica napravljena za slučajna pitanja gde je svako pitanje i odgovor nezavisan od prethodnih pitanja. Ima ubrzane tastere za najčešće zadatke.",
                text12: "Prevod:",
                text13: "Omogućava prevod teksta bez suvišnog kucanja. Samo odaberite jezik i unesite tekst.",
                text14: "Tutor",
                text15: "Učite i testirajte svoje znanje o bilo kojoj temi interakcijom sa AI-em.",
            },

          
            jobinterview:
            {
                cleardata: 'Podaci će biti obrisani. Da li želite da nastavite?',

                navbartitle_2: "Razgovor za posao:",
                navbartext1: "Molimo vas da date kratak pregled vašeg iskustva, znanja, nivoa stručnosti i oblasti ekspertize, a zatim ga pošaljite. Na osnovu vašeg unosa, dobićete nekoliko ključnih oblasti fokusa zajedno sa povezanim pitanjima za intervju. Možete proširiti svako pitanje kako biste dobili detaljnije i dublje odgovore.",
                navbartext2: "Koristite ovu stranicu za pripremu za bilo koji intervju, razgovor ili diskusiju.",
                navbartext3: "Sačuvajte pitanja kako biste ih mogli pregledati u bilo kom trenutku.",   
                note: 'Molimo opišite svoje znanje i iskustvo, zatim pošaljite.',

                of: 'od',

                preparing: 'Priprema',
                promptplaceholder : 'Unesi obrazovanje, iskustvo i veštine.',

                save: 'Sačuvaj',

                waitontopics: 'Čekanje na teme za razgovor za posao...'
            },

            login: {
                answernotcorrect: 'Odgovor nije tačan.',
                
                buttonlogin: 'Prijava',
                buttonlogout: 'Odjava',

                forgotpassword: 'Zaboravljena lozinka?',

                nvalidemail: 'Nevažeća email adresa.',
                invalidanswer: 'Nevažeći odgovor.',
                newpassword: 'Molimo Vas da kreirate novu lozinku',

                logoutlabel: "Molimo kliknite na Odjava.",
                logintext: 'Sada ste ulogovani. Molimo nastavite sa našom početnom stranicom.',
                logouttext: 'Odjavljeni ste.',
                loginsuccess: 'Uspešno ste se ulogovali.',

                placeholderemail: 'vasemail@email.com',
                placeholderpassword: 'Lozinka',
                passwordchanged: 'Vaša lozinka je promenjena.',
                provideanswer: 'Molimo Vas da pružite odgovor.',

                signup: 'registracija',
                submit: 'Potvrdi',

                titlelogin: 'Prijava',
                titlelogout: 'Odjava',
                text: 'Ako nemate nalog, molimo ',

                wrongpassword: 'Lozinka mora imati najmanje 8 alfanumeričkih karaktera.',

                userexists: 'Korisnik sa istim emailom već postoji!',

            },


            mainmenu: {
                aboutus: "O nama",
                assistant: 'Copilot',

                betterresponses: "'Multi-AI' odgovori",

                common: "Opšta stranica",
                credits:"Krediti",
                contactus: "Kontaktirajte nas",
                compareai: 'Uporedite AI modele',
                comprehensiveresponses: 'MOJA BIBLIOTEKA',

                documentanalysis: 'Pretraga Dokumenata',

                home: "Početna stranica",

                jobinterview:'Razgovor za posao',

                login: "Prijava",
                logout: "Odjava",
               
                quiz: 'Kviz',
               
                signup: 'Registracija',

                translation:'Prevodi',
                templates: 'Beleške',
                tests: "TESTOVI",

                 writing: "Chat",
               
            },

            quiz: {
                navbartitle: "Kviz:",
                reset: "Reset",
                somethingwrong:"Došlo je do greške. Molimo pokušajte ponovo.",
                note:'Spreman za kviz? Unesite temu i počnite.'
            },

            signup: {
                answer:"Odgovor",
               
                buttonsignup: "Pošalji",

                noemail:'Korisnik sa ovom email adresom ne postoji.',

                signup: "Registracija",
                signuptext: "Dobićete 10000 besplatnih kredita kada se registrujete.",
                securityquestions:"Sigurnosna pitanja",
                securityquestion:"Sigurnosno pitanje:",
               
                placeholderemail: "vaš_emeil@emeil.com",
                placeholderconfirmemail: "Potvrdi emeil",
                placeholderpassword: "Lozinka",
                placeholderconfirmpassword: "Potvrdi lozinku",

                question_1:"Koje je devojačko prezime Vaše majke?",
                question_2:"Kako se zove grad u kojem ste rođeni?"
            },

            status: {
                accountcreated: 'Vaš račun je otvoren. Imate 10000 besplatnih kredita za korišćenje.',
                addcredits: 'Molimo dodajte kredite.',
                attachfile: 'Dodajte tekst fajl',  
                attachmaxthreefiles: 'Najviše tri fajla mogu biti dodata.',

                copy: 'Kopiraj',

                deletetopic: 'Da li želite da obrišete temu', 
                deepseeknotsupported: 'Ova stranica ne podržava DeepSeek model.',

                emailmismatch: 'Email nije potvrdjen.',
                emailverification: "Molimo vas da unesete sigurnosni kod poslat na vašu email adresu. Ako ga ne vidite, proverite još jednom svoju email adresu ili pogledajte u svoju SPAM fasciklu za neželjenu poštu.",
                enteraname: "Unesite ime.",
                enteratext: 'Unesite tekst.',
                enteratextandsubmit: 'Unesite tekst i pošaljite.',
                exampletext1: 'Koristite ovo kao primer za \'ćaskanje\' sa bilo kojom poznatom osobom.',
                exampletext10: 'Unesite tekst i pošaljite.',
                exampletext19: 'Kreirajte i sačuvajte prilagođene poruke (Prompts) za pitanja koja se ponavljaju.',
                exampletext2: 'Ovaj primer vam pokazuje kako da napisete e-mail',
                exampletext20: 'Pošaljite da vidite rezultat.',
                exampletext21: 'Pošaljite da vidite rezultat.',
                exampletext22: 'Pošaljite da vidite rezultat.',
                exampletext23: 'Pošaljite da vidite rezultat.',
                exampletext3: 'Ovaj primer pokazuje kako započeti pisanje članka ili dokumenta bilo koje vrste.',
                exampletext4: 'Koristite ovo kao primer za dobijanje saveta o raznim temama.',
                exampletext5: 'Koristite ovo kao primer kako započeti razgovor.',
                exampletext6: 'Ovaj primer pokazuje kako kreirati priču. Pratite ovaj primer da biste kreirali svoje priče.',
                exampletext8: 'Unesite tekst i kliknite na Pošalji. Koristite stranicu AI Tutora da se pripremite za intervju i testirate svoje znanje o bilo kojoj temi.',
                exampletext9: 'Unesite tekst i kliknite na Pošalji za bilo koju vrstu e-mailova.',

                footertext1: 'DedaAI koristi ChatGPT AI algoritam koji je vlasnistvo kompanije ',
                footertext2: ' Sva pravila koriscenja su definisana pravilima kompanije ',
                footertext3: ' ',
                
                globalsearch: 'Pretraži veb',

                invalidanswer: "Greška u odgovoru.",
                invalidconfirmemail: "Nevažeća potvrda e-pošta.",
                invalidemail: "Nevažeći emeil.",
                invalidsecuritycode: 'Pogrešan sigurnosni kod.',

                loginfailed: 'Prijava nije uspela.',

                namenotdefined: 'Ime nije dato.',
                noemail: 'Korisnik sa ovom email adresom ne postoji.',
                noresponsetosave: 'Nema odgovora za čuvanje.',
                notopictosave: 'Nedostaje ime teme.',

                passwordlength: "Lozinka mora sadržati najmanje 8 alfanumeričkih karaktera.",
                passwordmismatch: 'Lozinka nije potvrdjena.',
                paymenttext: 'Kupovina je $',
                pleaselogin: 'Molimo prijavite se.',
                pleaseselectlanguage: 'Molimo, izaberite jezik.',
                providetopic: 'Molimo navedite temu.',
                provideanswer: 'Molimo dajte odgovor.',
                promptempty: 'Postavite pitanje.',

                responsetype: 'Tip odgovora',
                
                selectlanguage: 'Izaberite jezik, unesite tekst i pošaljite ga.',
                selectmodel: "Izaberi AI Model",
                selectmodelnote: 'Napomena: Zbog čestog puštanja novih AI modula, lista podržanih modula može se promeniti.',   
                signupsuccess: 'Uspešno ste se registrovali sa DedaAI. Imate 2.500 besplatnih kredita za korišćenje.',
             
            }, 

            templates: {
                add: 'Dodaj belešku',
                notes: 'Beleške',
                responses: 'Odgovori',
                notesandresponses: "Beleške i odgovori",
                dialognewprompt: 'Nova beleška',
                dialogupdateprompt: 'Ažuriraj belešku',
                
                addtooltip: 'Dodaj belešku',  
                previewtooltip: 'Pregledaj beleške',
                
                createtemplate:'Dodaj beleške', 
                createtemplatetooltip: 'Napravite svoju niz: dodajte beleške jednu po jednu. Sačuvajte svoj rad: kliknite na "Arhiva" da sačuvate beleške.',
                addprompt: 'Dodaj modul',
                addprompt_label1: "Naslov, ko, šta, itd...",
                addprompt_label2: "Opis, činjenice, itd...",
               
                close: 'Zatvori',
                clearall: "Obriši",
                credits: 'Krediti:',

                delete: 'Obriši',

                hide: 'Zatvori',

                hideprompt: 'Sakrij prompt',
                hideprompttext: 'Poslednji korak mora biti prompt koji će se primeniti na kontekst šablona.',
               
                navbartitle: "Beleške:",
                navbarsave: 'Sačuvaj',
                navbarsavedtitles: 'Teme',
                navbarsaveplaceholder: 'Naziv teme ...',
                navbarvariations: 'Raznolikost odgovora',
                navbartext1: 'Kreiraj logičan niz beleški ističući ključne činjenice. Ovo je modularni pristup organizaciji tvog rada oko veštačke inteligencije.',
                navbartext2: "Sačuvajte model i koristite ga ponovo sa različitim skupom podataka. Time se eliminiše potreba za ponovnim pisanjem dugih pitanja i ponavljanjem cinjenica.",
                navbartext3: "Na primer: pretpostavimo da postoje pet klijenata sa različitim potrebama. Možete kreirati model e-pošte za svakog klijenta i samo menjati činjenice svaki put kada treba da pošaljete e-poštu.",
                navbartext4: "Pogledajte primere sa početne stranice i koristite ih kao polaznu tačku.",
                navbartext5: "Mozete i interaktivno da postavljate pitanja o sadrzaju modela.",

                promptplaceholder:'Pitaj me o nečemu ...',
                preview: 'Pregledaj',
                placeholderwho:'Naslov, ko, sta, itd.',
                placeholderwhat: 'Opis, podaci, itd.',

                responselanguage:"Send me a response in ",

                showprompt: 'Pokaži prompt',
                showprompttext: 'Prompt će se primeniti na kontekst šablona.',
                update: 'Ažuriranje',

                whowarning: "Molimo dodajte 'Naslov, ko, šta, itd.'", 
                whatwarning:"'Opis, podaci, itd,' je prazno. Do li zelite da ostane prazno?", 
            },

            templatesamples: {
                templatesamples: 'Primena modela',
                prepareameeting: 'Pripremi sastanak',
                writeareport:'Napiši izveštaj',
                performancereview:'Godišnja ocena',
                email: 'E-pošta',
                travelexpense: 'Troskovi sluzbenog puta',

            },

            translation: {
                clearall: "Obriši",
                credits: 'Krediti',
                
                navbartitle: "Prevodi:",
                navbarsave: 'Sačuvaj',
                navbarsavedtitles: 'Teme',
                navbarsaveplaceholder: 'Naziv teme ...',
                promptplaceholder:'Tekst koji se prevodi ...',
                translateto: 'Prevedi na: ',

                navbartext1: 'Izaberite jezik, unesite tekst za prevođenje i pošaljite',
                navbartext2: 'Zbog ograničenja veštačke inteligencije u vezi sa količinom teksta koji se može obraditi odjednom, podelite veliki tekst na odeljke ili poglavlja i prevedite ih jedan po jedan.',
                navbartext3: 'Sačuvajte svoj rad i nastavite bilo kada.',
                
                responselanguage:"Send me a response in ",
                showprompts: 'Pokaži pitanja',
                hideprompts: 'Sakrij pitanja',
                
            },
            tutor: {
                clearall: "Obriši",
                credits: 'Krediti',
                
                navbartitle: "Tutor:",
                navbarsave: 'Sačuvaj',
                navbarsavedtitles: 'Teme',
                navbarsaveplaceholder: 'Naziv teme ...',
                navbarvariations: 'Raznovrstnost odgovora',
                navbarlanguage:"Jezik: ",
                promptplaceholder:'Daj svoj odgovor ...',

                navbartext1: "Naučite ili testirajte svoje znanje o bilo kojoj temi. Unesite temu, kliknite na 'Pitanje', dajte odgovor i pošaljite.",
                navbartext2: "Sačuvajte svoj razgovor. Pregledajte ga ili nastavite bilo kada.",
                navbartext3: "Koristite kontrolu Raznovrstnost odgovora da biste dobili varijacije u odgovorima veštačke inteligencije.",
                note: 'Unesite temu i kliknite na "Pitanje." Nakon toga, navedite svoj odgovor i pošaljite ga.',

                summaryprompt: 'Rezimiraj sledeci text:',
                responselanguage:"Send me a response in ",
                tutortema: 'Tema',
                askquestion:'Pitanje',
                question: 'Pitanje?',

                sametopic: "Već postoji tema sa tim imenom. Da li želite da je azurirate?",
                samplemessage: 'Izaberite bilo koju temu, kliknite na "Pitanje?" i pošaljite odgovor.'
            },
            
    }
};



    //!!! AITestContext: SendMoreAnswers uses hard coded GPT names. Make sure to change them when chaning names here.
    const models = [
        //OpenAI
        {
          provider: 'ChatGPT',
          name: 'gpt-5.6-luna',
          model:'gpt-5.6-luna',
          description: 'A general purpose model trained for varaity of tasks.',
        },
    
     
        //DeepSeek
        {
          provider: 'DeepSeek',
          name:'DeepSeek-V4',
          //model: 'deepseek-v4-flash',
          model: 'deepseek-flash',
          description: 'A model trained for natural language understanding, text generation, and conversational AI.',
        },

   
        //Gemini
        {
          provider: 'Google',
          name:'gemini-2.5-flash',
          model:'gemini-2.5-flash',
          description: 'A general purpose model trained for varaity of tasks.',
        },
   

         //MistralAI
         {
          provider: 'MistralAI',
          name:'mistral-large-latest',
          model:'mistral-large-latest',
          description: 'A general purpose model trained for varaity of tasks.',
        },
      
           //Alibaba
           {
            provider: 'Alibaba',
            name: 'qwen-flash',
            model: 'qwen-flash',
            description: 'A general purpose model trained for varaity of tasks.',
          },
     
      ]
   
    return <StatusContext.Provider value={{

        statusNavbar,
        setStatusNavbar,
        temperature,
        handleTemperature,
        sortTemplates,
        
        isMobile,
        scrollRef,
        ScrollResponse,
        ScrollResponseToMiddle,

        isLoading,
        setIsLoading,

        mainLanguage,
        setMainLanguage,
        changeLanguage,
        changeLanguageEnglish,
        changeTestLanguage,

        showmainLanguage,
        setShowMainLanguage,

        language,
        setLanguage,
        languages,
        setLanguages,
        saveMainLanguage,

        openDialog,
        openDialogBox,
        closeDialogBox,

        openDialogResponse,
        openDialogBoxResponse,
        closeDialogBoxResponse,

        openDialogAlert,
        openDialogBoxAlert,
        closeDialogBoxAlert,

        openDialogConfirm,
        
        openDialogBoxConfirm,
        closeDialogBoxConfirm,

        openLoginDialogConfirm,
        closeLoginDialogConfirm,

        openLogoutDialogConfirm,
        closeLogoutDialogConfirm,
        openLogin,
        openLogout,

        getChats,

        testname, 
        setTestName,

        showlogindialog,
        setShowLoginDialog,

        showlogoutdialog,
        setShowLogoutDialog,

        showsecuritydialog,
        setShowSecurityDialog,

        showpasswordchangeddialog,
        setShowPasswordChangedDialog,

        showsignupdialog,
        setShowSignupDialog,
        enablesignupdialog, 
        setEnableSignupDialog,
      
        showsignupconfirmdialog,
        setShowSignupConfirmDialog,

        showloginconfirmdialog,
        setShowLoginConfirmDialog,

        showcreateconnectaccountdialog,
        setShowCreateConnectAccountDialog,

        showbuytestdialog,
        setShowBuyTestDialog,

        showdialogsecurityquestion,
        setShowDialogSecurityQuestion,

        secquestion,
        setSecurityQuestion,

        shownewpassworddialog,
        setShowNewPasswordDialog,

        logininputs,
        setLoginInputs,

        showcreditsdialog,
        setShowCreditsDialog,

        showbuycredits,
        setShowBuyCredits,

        onCopy,
        isTextCopied,
        setIsTextCopied,

        dialogStatus, 
        setDialogStatus,

        showLanguages,
        setShowLanguages,

        shortLanguage,
        setShortLanguage,

        focusRef,
        handleFocus,

        showDialogAccountCreated,
        setShowDialogAccountCreated,

        dialogAccountText,
        setDialogAccountText,

        dialogLogoutText,
        setDialogLogoutText,

        setOpenLogoutDialog,
        openLogoutDialog,

        waitonResponse,
        setWaitOnResponse,

        getAIProvider, 
        getAIModel,
        getAIName,
      
        responseMode, 
        setResponseMode,

        showModels,
        setShowModels,

        activePane,
        setActivePane,

        onClickAIButton,
        onSelectModel,

        showDialogBoughtCredits,
        setShowDialogBoughtCredits,

        securitycodestatus, 
        setSecurityCodeStatus,

        isMe,
        getChatGPTModel,

        models, 
        supportedlanguages,
        setTestLanguage,
        testlanguage,
        isPromotion,
    }}>
        {props.children}
    </StatusContext.Provider>
})